export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    /** Date custom scalar type */
    DateTime: Date;
    /** JSON scalar */
    Json: any;
};

/** Result for addFriendship */
export type AddFriendshipResult = CoinsResultSuccess | ResultError;

export type AgeFilter = {
    gt?: Maybe<Scalars['Int']>;
    gte?: Maybe<Scalars['Int']>;
    lt?: Maybe<Scalars['Int']>;
    lte?: Maybe<Scalars['Int']>;
};

/** aggregate for own conversations */
export type AggregateConversationsResult = {
    __typename: 'AggregateConversationsResult';
    _sum?: Maybe<ConversationProfileAggregate>;
};

export type AllEnum = {
    __typename: 'AllEnum';
    PeriodUnit: Array<PeriodUnit>;
    PeriodUnitOffer: Array<PeriodUnitOffer>;
};

/** Avatar is a feature and not available for all projects */
export type Avatar = {
    __typename: 'Avatar';
    /** cuid */
    avatarId: Scalars['String'];
    gender: Gender;
    name?: Maybe<Scalars['String']>;
    /** relative image path */
    path: Scalars['String'];
    /** translations for avatars, not filtered if no login */
    translations: Array<Translation>;
};

/** Avatar is a feature and not available for all projects */
export type AvatarPathArgs = {
    relative?: Maybe<Scalars['Boolean']>;
};

/** Avatar is a feature and not available for all projects */
export type AvatarWhereInput = {
    gender?: Maybe<EnumGenderFilter>;
};

export type BankData = {
    __typename: 'BankData';
    bank?: Maybe<Scalars['String']>;
    beneficiary: Scalars['String'];
    bic: Scalars['String'];
    iban: Scalars['String'];
};

export type BatchPayload = {
    __typename: 'BatchPayload';
    count: Scalars['Int'];
};

export type BlockProfileInput = {
    /** this will be nonNullable in future releases */
    complainType?: Maybe<ComplainTypeWhereUniqueInput>;
    profileId: Scalars['String'];
};

export const BlockType = {
    Blocked: 'Blocked',
    Hidden: 'Hidden',
    None: 'None',
} as const;

export type BlockType = typeof BlockType[keyof typeof BlockType];
export type Blocked = {
    __typename: 'Blocked';
    /** identifier cuid */
    blockedId: Scalars['String'];
    createdAt: Scalars['DateTime'];
    /** other [Profile]({{Types.Profile}}) node */
    other: Profile;
    /** profileId from other Profile */
    otherId: Scalars['String'];
};

export type BlockedOrderByInput = {
    /** cuid of Blocked */
    blockedId?: Maybe<SortOrder>;
    /** DateTime profile was blocked */
    createdAt?: Maybe<SortOrder>;
    /** profileId of blocked Profile */
    otherId?: Maybe<SortOrder>;
    /** own profileId */
    selfId?: Maybe<SortOrder>;
};

export type BlockedWhereInput = {
    /** combine search filter with AND */
    AND?: Maybe<Array<BlockedWhereInput>>;
    /** combine search filter with NOT */
    NOT?: Maybe<Array<BlockedWhereInput>>;
    /** combine search filter with OR */
    OR?: Maybe<Array<BlockedWhereInput>>;
    /** identifier cuid */
    blockedId?: Maybe<StringFilter>;
    /** DateTime Blocked was created */
    createdAt?: Maybe<DateTimeFilter>;
    /** Profile node from other Profile */
    other?: Maybe<ProfileWhereInput>;
    /** profileId from other Profile */
    otherId?: Maybe<StringFilter>;
};

export type BlockedWhereUniqueInput = {
    /** combine unique index: own profileId and other profileId */
    selfId_otherId: SelfIdOtherIdCompoundUniqueInput;
};

export type BoolFilter = {
    equals?: Maybe<Scalars['Boolean']>;
    not?: Maybe<Scalars['Boolean']>;
};

export type BoolNullableFilter = {
    equals?: Maybe<Scalars['Boolean']>;
    not?: Maybe<Scalars['Boolean']>;
};

export type ChangeFriendshipInput = {
    /** cuid other Profile */
    otherId: Scalars['String'];
    /** only Accepted or Declined */
    status: FriendshipStatus;
};

export type CoinsHistory = {
    __typename: 'CoinsHistory';
    /** description of action */
    action: Scalars['String'];
    /** amount of coins changed by this action */
    coins: Scalars['Int'];
    /** identifier cuid */
    coinsHistoryId: Scalars['String'];
    /** DateTime coins changed */
    createdAt: Scalars['DateTime'];
    /** own User node */
    user: User;
    /** own userId */
    userId: Scalars['String'];
};

/** Union of ResultError and CoinsResultSuccess */
export type CoinsResult = CoinsResultSuccess | ResultError;

/** Result after spend/receive coins */
export type CoinsResultSuccess = {
    __typename: 'CoinsResultSuccess';
    /** current amount of coins */
    coins: Scalars['Int'];
    /** increased coins in this request */
    increasedCoins?: Maybe<Scalars['Int']>;
    /** spent coins in this request */
    spentCoins?: Maybe<Scalars['Int']>;
};

export type ComplainType = {
    __typename: 'ComplainType';
    /** identifier cuid */
    complainTypeId: Scalars['String'];
    /** unique name */
    name: Scalars['String'];
    /** List of Translation nodes, filtered by user language */
    translations: Array<Translation>;
};

export type ComplainTypeCreateOneWithoutUserComplainInput = {
    connect: ComplainTypeWhereUniqueInput;
};

export type ComplainTypeWhereUniqueInput = {
    /** identifier cuid */
    complainTypeId?: Maybe<Scalars['String']>;
    /** unique name */
    name?: Maybe<Scalars['String']>;
};

export type Config = {
    __typename: 'Config';
    /** amount of coins user gets after activation */
    activateBonus: Scalars['Int'];
    /** all costs */
    cost: Cost;
    /** amount of coins user gets after login per day */
    dailyLoginBonus: Scalars['Int'];
    /** amount of coins user gets for the first flirtText */
    firstFlirtTextBonus: Scalars['Int'];
    /** amount of coins user gets after uploading first image */
    firstImageBonus: Scalars['Int'];
    /** amount of coins user gets after providing mobile number */
    mobileNumberBonus: Scalars['Int'];
    /** amount of coins user gets after provide additional information */
    profileFlagsBonus: Scalars['Int'];
};

export type ContactSupportInput = {
    category?: SupportCategory;
    email: Scalars['String'];
    subject: Scalars['String'];
    text: Scalars['String'];
};

export type Conversation = {
    __typename: 'Conversation';
    /** conversation is a blind chat */
    blind: Scalars['Boolean'];
    /** identifier no cuid!, build from all participants */
    conversationId: Scalars['String'];
    /** no costs for this conversation */
    free: Scalars['Boolean'];
    /** DateTime of last action in conversation */
    lastAction?: Maybe<Scalars['DateTime']>;
    /** Message node of last message wrote */
    lastMessage?: Maybe<Message>;
    /** cuid of last message in conversation */
    lastMessageId?: Maybe<Scalars['String']>;
    /** cost per message for this conversation */
    messageCost: Scalars['Int'];
    /** length of one message, cost = ceil(text.length/messageLength) */
    messageLength: Scalars['Int'];
    /** list of messages, max take = (-)10 */
    messages: Array<Message>;
    /** list of conversationProfile, a conversation can have X >= 2 participants include own Profile */
    profiles: Array<ConversationProfile>;
    /**
     * support dialog, only for imported projects
     * @deprecated only for old imported projects
     */
    support: Scalars['Boolean'];
};

export type ConversationMessagesArgs = {
    cursor?: Maybe<MessageWhereUniqueInput>;
    orderBy?: Maybe<MessageOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<MessageWhereInput>;
};

export type ConversationProfilesArgs = {
    where?: Maybe<ConversationProfileWhereInput>;
};

/** unique identifier */
export type ConversationIdProfileIdCompoundUniqueInput = {
    conversationId: Scalars['String'];
    profileId: Scalars['String'];
};

export type ConversationOrderByInput = {
    /** conversationId is not a cuid, for sorting by DateTime use lastAction */
    conversationId?: Maybe<SortOrder>;
    lastAction?: Maybe<SortOrder>;
};

export type ConversationProfile = ConversationProfileInterface & {
    __typename: 'ConversationProfile';
    /** Conversation node */
    conversation: Conversation;
    /** identifier of Conversation node, no cuid! */
    conversationId: Scalars['String'];
    /** identifier cuid */
    conversationProfileId: Scalars['String'];
    /** number of free messages left */
    freeMessages: Scalars['Int'];
    /** number of sent gifts */
    giftsSend: Scalars['Int'];
    /** number of unread gifts */
    giftsUnread: Scalars['Int'];
    /** number of sent messages, MessageType = Message | PredefinedMessage */
    messagesSend: Scalars['Int'];
    /** number of unread messages, MessageType = Message | PredefinedMessage */
    messagesUnread: Scalars['Int'];
    /** number of sent pictures */
    picturesSend: Scalars['Int'];
    /** number of unread pictures */
    picturesUnread: Scalars['Int'];
    /** number of sent pokes */
    pokesSend: Scalars['Int'];
    /** number of unread pokes */
    pokesUnread: Scalars['Int'];
    /** Profile node */
    profile: Profile;
    /** cuid of Profile node */
    profileId: Scalars['String'];
    /** sum of all sent */
    send: Scalars['Int'];
    /** sum of all unread */
    unread: Scalars['Int'];
};

/** node for using ConversationProfileInterface */
export type ConversationProfileAggregate = ConversationProfileInterface & {
    __typename: 'ConversationProfileAggregate';
    /** number of free messages left */
    freeMessages: Scalars['Int'];
    /** number of sent gifts */
    giftsSend: Scalars['Int'];
    /** number of unread gifts */
    giftsUnread: Scalars['Int'];
    /** number of sent messages, MessageType = Message | PredefinedMessage */
    messagesSend: Scalars['Int'];
    /** number of unread messages, MessageType = Message | PredefinedMessage */
    messagesUnread: Scalars['Int'];
    /** number of sent pictures */
    picturesSend: Scalars['Int'];
    /** number of unread pictures */
    picturesUnread: Scalars['Int'];
    /** number of sent pokes */
    pokesSend: Scalars['Int'];
    /** number of unread pokes */
    pokesUnread: Scalars['Int'];
    /** sum of all sent */
    send: Scalars['Int'];
    /** sum of all unread */
    unread: Scalars['Int'];
};

/** choose which fields should be aggregate */
export type ConversationProfileCountAggregateInputType = {
    _all?: Maybe<Scalars['Boolean']>;
    freeMessages?: Maybe<Scalars['Boolean']>;
    giftsSend?: Maybe<Scalars['Boolean']>;
    giftsUnread?: Maybe<Scalars['Boolean']>;
    messagesSend?: Maybe<Scalars['Boolean']>;
    messagesUnread?: Maybe<Scalars['Boolean']>;
    picturesSend?: Maybe<Scalars['Boolean']>;
    picturesUnread?: Maybe<Scalars['Boolean']>;
    pokesSend?: Maybe<Scalars['Boolean']>;
    pokesUnread?: Maybe<Scalars['Boolean']>;
    send?: Maybe<Scalars['Boolean']>;
    unread?: Maybe<Scalars['Boolean']>;
};

export const ConversationProfileDistinctFieldEnum = {
    Blocked: 'blocked',
    ConversationId: 'conversationId',
    ConversationProfileId: 'conversationProfileId',
    CreatedAt: 'createdAt',
    FreeMessages: 'freeMessages',
    GiftsSend: 'giftsSend',
    GiftsUnread: 'giftsUnread',
    MessagesSend: 'messagesSend',
    MessagesUnread: 'messagesUnread',
    PicturesSend: 'picturesSend',
    PicturesUnread: 'picturesUnread',
    PokesSend: 'pokesSend',
    PokesUnread: 'pokesUnread',
    ProfileId: 'profileId',
    Send: 'send',
    Unread: 'unread',
    UpdatedAt: 'updatedAt',
} as const;

export type ConversationProfileDistinctFieldEnum =
    typeof ConversationProfileDistinctFieldEnum[keyof typeof ConversationProfileDistinctFieldEnum];
export type ConversationProfileInterface = {
    /** number of free messages left */
    freeMessages: Scalars['Int'];
    /** number of sent gifts */
    giftsSend: Scalars['Int'];
    /** number of unread gifts */
    giftsUnread: Scalars['Int'];
    /** number of sent messages, MessageType = Message | PredefinedMessage */
    messagesSend: Scalars['Int'];
    /** number of unread messages, MessageType = Message | PredefinedMessage */
    messagesUnread: Scalars['Int'];
    /** number of sent pictures */
    picturesSend: Scalars['Int'];
    /** number of unread pictures */
    picturesUnread: Scalars['Int'];
    /** number of sent pokes */
    pokesSend: Scalars['Int'];
    /** number of unread pokes */
    pokesUnread: Scalars['Int'];
    /** sum of all sent */
    send: Scalars['Int'];
    /** sum of all unread */
    unread: Scalars['Int'];
};

export type ConversationProfileListRelationFilter = {
    every?: Maybe<ConversationProfileWhereInput>;
    none?: Maybe<ConversationProfileWhereInput>;
    some?: Maybe<ConversationProfileWhereInput>;
};

export type ConversationProfileOrderByInput = {
    blocked?: Maybe<SortOrder>;
    conversationId?: Maybe<SortOrder>;
    conversationProfileId?: Maybe<SortOrder>;
    createdAt?: Maybe<SortOrder>;
    freeMessages?: Maybe<SortOrder>;
    giftsSend?: Maybe<SortOrder>;
    giftsUnread?: Maybe<SortOrder>;
    messagesSend?: Maybe<SortOrder>;
    messagesUnread?: Maybe<SortOrder>;
    picturesSend?: Maybe<SortOrder>;
    picturesUnread?: Maybe<SortOrder>;
    pokesSend?: Maybe<SortOrder>;
    pokesUnread?: Maybe<SortOrder>;
    profileId?: Maybe<SortOrder>;
    send?: Maybe<SortOrder>;
    unread?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
};

/** choose which fields should be aggregate */
export type ConversationProfileSumAggregateInputType = {
    freeMessages?: Maybe<Scalars['Boolean']>;
    giftsSend?: Maybe<Scalars['Boolean']>;
    giftsUnread?: Maybe<Scalars['Boolean']>;
    messagesSend?: Maybe<Scalars['Boolean']>;
    messagesUnread?: Maybe<Scalars['Boolean']>;
    picturesSend?: Maybe<Scalars['Boolean']>;
    picturesUnread?: Maybe<Scalars['Boolean']>;
    pokesSend?: Maybe<Scalars['Boolean']>;
    pokesUnread?: Maybe<Scalars['Boolean']>;
    send?: Maybe<Scalars['Boolean']>;
    unread?: Maybe<Scalars['Boolean']>;
};

/** filter for ConversationProfile node */
export type ConversationProfileWhereInput = {
    blocked?: Maybe<BoolNullableFilter>;
    conversationId?: Maybe<StringFilter>;
    createdAt?: Maybe<DateTimeFilter>;
    giftsUnread?: Maybe<IntNullableFilter>;
    hidden?: Maybe<BoolNullableFilter>;
    messagesUnread?: Maybe<IntNullableFilter>;
    picturesUnread?: Maybe<IntNullableFilter>;
    pokesUnread?: Maybe<IntNullableFilter>;
    profileId?: Maybe<StringFilter>;
    send?: Maybe<IntNullableFilter>;
    unread?: Maybe<IntNullableFilter>;
    updatedAt?: Maybe<DateTimeFilter>;
};

export type ConversationProfileWhereUniqueInput = {
    conversationId_profileId: ConversationIdProfileIdCompoundUniqueInput;
};

export type ConversationWhereInput = {
    /** combine search filter with AND */
    AND?: Maybe<Array<ConversationWhereInput>>;
    /** combine search filter with NOT */
    NOT?: Maybe<Array<ConversationWhereInput>>;
    /** combine search filter with OR */
    OR?: Maybe<Array<ConversationWhereInput>>;
    blind?: Maybe<BoolNullableFilter>;
    conversationId?: Maybe<StringFilter>;
    free?: Maybe<BoolNullableFilter>;
    lastAction?: Maybe<DateTimeNullableFilter>;
    lastMessageId?: Maybe<StringNullableFilter>;
    messages?: Maybe<MessageListRelationFilter>;
    profiles?: Maybe<ConversationProfileListRelationFilter>;
    support?: Maybe<BoolNullableFilter>;
};

/** unique identifiers for one conversation */
export type ConversationWhereUniqueInput = {
    conversationId?: Maybe<Scalars['String']>;
    receivers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** cost and additional information per type */
export type Cost = {
    __typename: 'Cost';
    eyeCatcher?: Maybe<CostNode>;
    friendship: CostNode;
    match?: Maybe<CostNode>;
    message: MessageCost;
    picture?: Maybe<CostNode>;
    poke: PokeCost;
    /**
     * **[PredefinedMessage]({{Types.PredefinedMessage}}) is
     *             a feature and not available for all projects**
     */
    predefinedMessage?: Maybe<CostNode>;
};

export type CostNode = {
    __typename: 'CostNode';
    cost: Scalars['Int'];
};

export type Coupon = {
    __typename: 'Coupon';
    /** unique */
    code: Scalars['String'];
};

export type CouponWhereUniqueInput = {
    /** unique identifier */
    code: Scalars['String'];
};

/** **DailySong is a feature and not available for all projects** */
export type DailySong = {
    __typename: 'DailySong';
    dailySongId: Scalars['String'];
    name: Scalars['String'];
    /** youtube video link */
    path: Scalars['String'];
};

export type DateTimeFilter = {
    gt?: Maybe<Scalars['DateTime']>;
    gte?: Maybe<Scalars['DateTime']>;
    lt?: Maybe<Scalars['DateTime']>;
    lte?: Maybe<Scalars['DateTime']>;
};

export type DateTimeNullableFilter = {
    gt?: Maybe<Scalars['DateTime']>;
    gte?: Maybe<Scalars['DateTime']>;
    lt?: Maybe<Scalars['DateTime']>;
    lte?: Maybe<Scalars['DateTime']>;
};

export type DeactivatedPush = {
    __typename: 'DeactivatedPush';
    /** cuid */
    deactivatedPushId: Scalars['String'];
    /** PushSetting node */
    setting: PushSetting;
};

export type DeactivatedPushChangeInput = {
    deactivate: Scalars['Boolean'];
    setting: PushSetting;
};

export type DeactivatedPushCreateWithoutUserInput = {
    id?: Maybe<Scalars['String']>;
    setting?: Maybe<PushSetting>;
};

export const DeactivatedPushDistinctFieldEnum = {
    DeactivatedPushId: 'deactivatedPushId',
    Setting: 'setting',
    UserId: 'userId',
} as const;

export type DeactivatedPushDistinctFieldEnum =
    typeof DeactivatedPushDistinctFieldEnum[keyof typeof DeactivatedPushDistinctFieldEnum];
export type DeactivatedPushOrderByInput = {
    deactivatedPushId?: Maybe<SortOrder>;
    setting?: Maybe<SortOrder>;
};

export type DeactivatedPushScalarWhereInput = {
    deactivatedPushId?: Maybe<StringFilter>;
    setting?: Maybe<EnumPushSettingFilter>;
    userId?: Maybe<StringFilter>;
};

export type DeactivatedPushUpdateManyWithoutUserInput = {
    create?: Maybe<Array<DeactivatedPushCreateWithoutUserInput>>;
    delete?: Maybe<Array<DeactivatedPushWhereUniqueInput>>;
    deleteMany?: Maybe<Array<DeactivatedPushScalarWhereInput>>;
};

export type DeactivatedPushWhereInput = {
    deactivatedPushId?: Maybe<StringFilter>;
    setting?: Maybe<EnumPushSettingFilter>;
};

/** unique identifier */
export type DeactivatedPushWhereUniqueInput = {
    userId_setting: UserIdSettingCompoundUniqueInput;
};

export type DeleteAccountInput = {
    deleteHash: Scalars['String'];
};

export type DeleteAccountResult = ResultError | ResultSuccess;

export type DeleteGalleryImageInput = {
    imageId: Scalars['String'];
};

export type EnumBlockTypeNullableFilter = {
    equals?: Maybe<BlockType>;
    in?: Maybe<Array<Maybe<BlockType>>>;
    not?: Maybe<BlockType>;
    notIn?: Maybe<Array<Maybe<BlockType>>>;
};

export type EnumFriendshipStatusFilter = {
    equals?: Maybe<FriendshipStatus>;
    in?: Maybe<Array<Maybe<FriendshipStatus>>>;
    not?: Maybe<FriendshipStatus>;
    notIn?: Maybe<Array<Maybe<FriendshipStatus>>>;
};

export type EnumGenderFilter = {
    equals?: Maybe<Gender>;
    in?: Maybe<Array<Maybe<Gender>>>;
    not?: Maybe<Gender>;
    notIn?: Maybe<Array<Maybe<Gender>>>;
};

export type EnumMatchTypeFilter = {
    equals?: Maybe<MatchType>;
    in?: Maybe<Array<Maybe<MatchType>>>;
    not?: Maybe<MatchType>;
    notIn?: Maybe<Array<Maybe<MatchType>>>;
};

export type EnumMessageTypeFilter = {
    equals?: Maybe<MessageType>;
    in?: Maybe<Array<Maybe<MessageType>>>;
    not?: Maybe<MessageType>;
    notIn?: Maybe<Array<Maybe<MessageType>>>;
};

export type EnumNotificationTypeFilter = {
    equals?: Maybe<NotificationType>;
    in?: Maybe<Array<Maybe<NotificationType>>>;
    not?: Maybe<NotificationType>;
    notIn?: Maybe<Array<Maybe<NotificationType>>>;
};

export type EnumPushSettingFilter = {
    equals?: Maybe<PushSetting>;
    in?: Maybe<Array<Maybe<PushSetting>>>;
    not?: Maybe<PushSetting>;
    notIn?: Maybe<Array<Maybe<PushSetting>>>;
};

export type EnumSupportTicketStatusFilter = {
    equals?: Maybe<SupportTicketStatus>;
    in?: Maybe<Array<Maybe<SupportTicketStatus>>>;
    not?: Maybe<SupportTicketStatus>;
    notIn?: Maybe<Array<Maybe<SupportTicketStatus>>>;
};

export type Error = {
    __typename: 'Error';
    errorCode: Scalars['Int'];
    errorMessage: Scalars['String'];
};

export const ErrorCodes = {
    Age: 'AGE',
    AgeLength: 'AGE_LENGTH',
    CoinsFailure: 'COINS_FAILURE',
    CoinsMissing: 'COINS_MISSING',
    ConversationNotFound: 'CONVERSATION_NOT_FOUND',
    CountryInvalid: 'COUNTRY_INVALID',
    CountryNotExists: 'COUNTRY_NOT_EXISTS',
    CouponInvalid: 'COUPON_INVALID',
    CouponRedeemed: 'COUPON_REDEEMED',
    Default: 'DEFAULT',
    EmailAlreadySet: 'EMAIL_ALREADY_SET',
    EmailExists: 'EMAIL_EXISTS',
    EmailInvalid: 'EMAIL_INVALID',
    FlirttextMaxChars: 'FLIRTTEXT_MAX_CHARS',
    InputIncorrect: 'INPUT_INCORRECT',
    LanguageExists: 'LANGUAGE_EXISTS',
    LoginInvalid: 'LOGIN_INVALID',
    LoginUserBlocked: 'LOGIN_USER_BLOCKED',
    LoginUserDeleted: 'LOGIN_USER_DELETED',
    MainImageNotFound: 'MAIN_IMAGE_NOT_FOUND',
    MatchBuyMore: 'MATCH_BUY_MORE',
    MatchLimit: 'MATCH_LIMIT',
    MatchLimitBuyMore: 'MATCH_LIMIT_BUY_MORE',
    MatchNotActive: 'MATCH_NOT_ACTIVE',
    MatchNotFound: 'MATCH_NOT_FOUND',
    MobilenumberAlreadySet: 'MOBILENUMBER_ALREADY_SET',
    MobilenumberExists: 'MOBILENUMBER_EXISTS',
    MobilenumberInvalid: 'MOBILENUMBER_INVALID',
    PasswordMaxChars: 'PASSWORD_MAX_CHARS',
    PasswordMinChars: 'PASSWORD_MIN_CHARS',
    PostcodeInvalid: 'POSTCODE_INVALID',
    PostcodeNotExists: 'POSTCODE_NOT_EXISTS',
    ProfileNotFound: 'PROFILE_NOT_FOUND',
    ProviderInvalid: 'PROVIDER_INVALID',
    StatusFailure: 'STATUS_FAILURE',
    Timezone: 'TIMEZONE',
    TownInvalid: 'TOWN_INVALID',
    TownNotExists: 'TOWN_NOT_EXISTS',
    TransactionCallbackCaptureFailed: 'TRANSACTION_CALLBACK_CAPTURE_FAILED',
    TransactionCallbackCorruptedData: 'TRANSACTION_CALLBACK_CORRUPTED_DATA',
    TransactionCallbackFailed: 'TRANSACTION_CALLBACK_FAILED',
    TransactionCallbackInvalidData: 'TRANSACTION_CALLBACK_INVALID_DATA',
    TransactionCallbackWrongAmount: 'TRANSACTION_CALLBACK_WRONG_AMOUNT',
    TransactionCreateFailed: 'TRANSACTION_CREATE_FAILED',
    TransactionLimitReached: 'TRANSACTION_LIMIT_REACHED',
    TransactionOfferInactive: 'TRANSACTION_OFFER_INACTIVE',
    TransactionOfferInvalid: 'TRANSACTION_OFFER_INVALID',
    TransactionOfferPremiumActive: 'TRANSACTION_OFFER_PREMIUM_ACTIVE',
    TransactionProjectMismatch: 'TRANSACTION_PROJECT_MISMATCH',
    UsernameExists: 'USERNAME_EXISTS',
    UsernameMaxChars: 'USERNAME_MAX_CHARS',
    UsernameMinChars: 'USERNAME_MIN_CHARS',
    UsernameMissing: 'USERNAME_MISSING',
} as const;

export type ErrorCodes = typeof ErrorCodes[keyof typeof ErrorCodes];
export type EyeCatcher = {
    __typename: 'EyeCatcher';
    /** cuid */
    eyeCatcherId: Scalars['String'];
    /** Image node */
    image: Image;
    /** cuid of Image node */
    imageId: Scalars['String'];
    /** Profile node */
    profile: Profile;
    /** cuid of Profile node */
    profileId: Scalars['String'];
};

export type EyeCatcherCreateInput = {
    image: ImageCreateOneWithoutEyeCatcherInput;
};

export type EyeCatcherWhereInput = {
    AND?: Maybe<Array<Maybe<EyeCatcherWhereInput>>>;
    NOT?: Maybe<Array<Maybe<EyeCatcherWhereInput>>>;
    OR?: Maybe<Array<Maybe<EyeCatcherWhereInput>>>;
    profile?: Maybe<ProfileWhereInput>;
};

export type EyeCatcherWhereUniqueInput = {
    eyeCatcherId: Scalars['String'];
};

export type Favorite = {
    __typename: 'Favorite';
    createdAt: Scalars['DateTime'];
    favoriteId: Scalars['String'];
    /** other Profile node */
    other: Profile;
    /** profileId (cuid) of other Profile */
    otherId: Scalars['String'];
};

export type FavoriteOrderByInput = {
    createdAt?: Maybe<SortOrder>;
    favoriteId?: Maybe<SortOrder>;
    otherId?: Maybe<SortOrder>;
    selfId?: Maybe<SortOrder>;
};

export type FavoriteWhereInput = {
    createdAt?: Maybe<DateTimeFilter>;
    favoriteId?: Maybe<StringFilter>;
    other?: Maybe<ProfileWhereInput>;
    otherId?: Maybe<StringFilter>;
};

/** unique identifier */
export type FavoriteWhereUniqueInput = {
    selfId_otherId: SelfIdOtherIdCompoundUniqueInput;
};

export type Flag = {
    __typename: 'Flag';
    flagId: Scalars['String'];
    flagValues: Array<FlagValue>;
    gender: FlagGender;
    max?: Maybe<Scalars['Int']>;
    maxLength: Scalars['Int'];
    min?: Maybe<Scalars['Int']>;
    minLength: Scalars['Int'];
    name: Scalars['String'];
    numberStep?: Maybe<Scalars['String']>;
    regEx?: Maybe<Scalars['String']>;
    translations: Array<Translation>;
    type: FlagType;
};

export type FlagCreateNestedOneWithoutProfileFlagsInput = {
    connect: FlagWhereUniqueInput;
};

export const FlagGender = {
    All: 'All',
    Divers: 'Divers',
    Female: 'Female',
    Male: 'Male',
} as const;

export type FlagGender = typeof FlagGender[keyof typeof FlagGender];
export const FlagType = {
    InputNumber: 'InputNumber',
    InputString: 'InputString',
    Select: 'Select',
} as const;

export type FlagType = typeof FlagType[keyof typeof FlagType];
export type FlagValue = {
    __typename: 'FlagValue';
    flagId: Scalars['String'];
    flagValueId: Scalars['String'];
    translations: Array<Translation>;
};

export type FlagValueCreateNestedOneWithoutProfileFlagsInput = {
    connect: FlagValueWhereUniqueInput;
};

export type FlagValueWhereUniqueInput = {
    flagValueId: Scalars['String'];
};

export type FlagWhereUniqueInput = {
    flagId: Scalars['String'];
};

export type FloatFilter = {
    equals?: Maybe<Scalars['Float']>;
    gt?: Maybe<Scalars['Float']>;
    gte?: Maybe<Scalars['Float']>;
    in?: Maybe<Array<Maybe<Scalars['Float']>>>;
    lt?: Maybe<Scalars['Float']>;
    lte?: Maybe<Scalars['Float']>;
    not?: Maybe<Scalars['Float']>;
    notIn?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type ForgottenPasswordInput = {
    email?: Maybe<Scalars['String']>;
    username?: Maybe<Scalars['String']>;
};

export type Friendship = {
    __typename: 'Friendship';
    /** cuid */
    friendshipId: Scalars['String'];
    /** other Profile node */
    other: Profile;
    /** cuid of other Profile */
    otherId: Scalars['String'];
    status: FriendshipStatus;
    updatedAt: Scalars['DateTime'];
};

export type FriendshipOrderByInput = {
    createdAt?: Maybe<SortOrder>;
    friendshipId?: Maybe<SortOrder>;
    status?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
};

export const FriendshipStatus = {
    Accepted: 'Accepted',
    Declined: 'Declined',
    Pending: 'Pending',
    Sent: 'Sent',
} as const;

export type FriendshipStatus =
    typeof FriendshipStatus[keyof typeof FriendshipStatus];
export type FriendshipWhereInput = {
    createdAt?: Maybe<DateTimeFilter>;
    friendshipId?: Maybe<StringFilter>;
    otherId?: Maybe<StringFilter>;
    selfId?: Maybe<StringFilter>;
    status?: Maybe<EnumFriendshipStatusFilter>;
    updatedAt?: Maybe<DateTimeFilter>;
};

export type FriendshipWhereUniqueInput = {
    selfId_otherId: SelfIdOtherIdCompoundUniqueInput;
};

export const Gender = {
    Divers: 'Divers',
    Female: 'Female',
    Male: 'Male',
} as const;

export type Gender = typeof Gender[keyof typeof Gender];
export type Geolocation = {
    __typename: 'Geolocation';
    community?: Maybe<Scalars['String']>;
    country: Scalars['String'];
    /** cuid */
    geolocationId: Scalars['String'];
    iso: Scalars['String'];
    latitude: Scalars['String'];
    location: Scalars['String'];
    longitude: Scalars['String'];
    postcode: Scalars['String'];
    province?: Maybe<Scalars['String']>;
    state?: Maybe<Scalars['String']>;
};

export const GeolocationDistinctFieldEnum = {
    Iso: 'iso',
    Postcode: 'postcode',
    Province: 'province',
    State: 'state',
} as const;

export type GeolocationDistinctFieldEnum =
    typeof GeolocationDistinctFieldEnum[keyof typeof GeolocationDistinctFieldEnum];
export type GeolocationOrderByInput = {
    community?: Maybe<SortOrder>;
    country?: Maybe<SortOrder>;
    geolocationId?: Maybe<SortOrder>;
    latitude?: Maybe<SortOrder>;
    location?: Maybe<SortOrder>;
    longitude?: Maybe<SortOrder>;
    postcode?: Maybe<SortOrder>;
    province?: Maybe<SortOrder>;
    state?: Maybe<SortOrder>;
};

export type GeolocationWhereInput = {
    AND?: Maybe<Array<Maybe<GeolocationWhereInput>>>;
    NOT?: Maybe<Array<Maybe<GeolocationWhereInput>>>;
    OR?: Maybe<Array<Maybe<GeolocationWhereInput>>>;
    community?: Maybe<StringNullableFilter>;
    country?: Maybe<StringFilter>;
    geolocationId?: Maybe<StringFilter>;
    /** upperCase ISO String e.g. "DE" */
    iso?: Maybe<StringFilter>;
    location?: Maybe<StringFilter>;
    postcode?: Maybe<StringFilter>;
    province?: Maybe<StringNullableFilter>;
    state?: Maybe<StringNullableFilter>;
};

export type GeolocationWhereUniqueInput = {
    geolocationId: Scalars['String'];
};

export type Gift = {
    __typename: 'Gift';
    cost: Scalars['Int'];
    /** cuid */
    giftId: Scalars['String'];
    name: Scalars['String'];
    /** relative theme image path */
    path: Scalars['String'];
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type GiftPathArgs = {
    relative?: Maybe<Scalars['Boolean']>;
};

export type GiftCategory = {
    __typename: 'GiftCategory';
    /** cuid */
    giftCategoryId: Scalars['String'];
    gifts: Array<Gift>;
    name: Scalars['String'];
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type GiftCategoryOrderByInput = {
    name: SortOrder;
};

export type GiftCategoryWhereInput = {
    giftCategoryId?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
};

export type GiftCategoryWhereUniqueInput = {
    giftCategoryId: Scalars['String'];
};

/** user receivers for new conversation or conversation to answer */
export type GiftInput = {
    conversation?: Maybe<ConversationWhereUniqueInput>;
    gift: GiftWhereUniqueInput;
    receivers?: Maybe<Array<ProfileWhereUniqueInput>>;
    text?: Maybe<Scalars['String']>;
};

export type GiftWhereInput = {
    categoryId: Scalars['String'];
};

export type GiftWhereUniqueInput = {
    giftId: Scalars['String'];
};

export type Image = {
    __typename: 'Image';
    /** cuid */
    imageId: Scalars['String'];
    /** main image of Profile */
    main: Scalars['Boolean'];
    /** absolute image path */
    path: Scalars['String'];
    /** image is private, only visible (path) if Accepted Friendship */
    private: Scalars['Boolean'];
    /** Profile node */
    profile: Profile;
    /** cuid of Profile */
    profileId: Scalars['String'];
    userChanged: Scalars['DateTime'];
    /** all images have to be verified by adminUser */
    verified: Scalars['Boolean'];
};

export type ImagePathArgs = {
    relative?: Maybe<Scalars['Boolean']>;
    size?: Maybe<Scalars['Int']>;
};

export type ImageCreateOneWithoutEyeCatcherInput = {
    connect?: Maybe<ImageWhereUniqueInput>;
};

export const ImageDistinctFieldEnum = {
    Fsk18: 'fsk18',
    ImageId: 'imageId',
    Main: 'main',
    Path: 'path',
    Private: 'private',
    ProfileId: 'profileId',
    UserChanged: 'userChanged',
    Verified: 'verified',
} as const;

export type ImageDistinctFieldEnum =
    typeof ImageDistinctFieldEnum[keyof typeof ImageDistinctFieldEnum];
export type ImageListRelationFilter = {
    every?: Maybe<ImageWhereInput>;
    none?: Maybe<ImageWhereInput>;
    some?: Maybe<ImageWhereInput>;
};

export type ImageOrderByInput = {
    fsk18?: Maybe<SortOrder>;
    imageId?: Maybe<SortOrder>;
    main?: Maybe<SortOrder>;
    path?: Maybe<SortOrder>;
    private?: Maybe<SortOrder>;
    profileId?: Maybe<SortOrder>;
    userChanged?: Maybe<SortOrder>;
    verified?: Maybe<SortOrder>;
};

export type ImageWhereInput = {
    imageId?: Maybe<StringFilter>;
    main?: Maybe<BoolFilter>;
    path?: Maybe<StringFilter>;
    private?: Maybe<BoolFilter>;
    profileId?: Maybe<StringFilter>;
    userChanged?: Maybe<DateTimeFilter>;
};

export type ImageWhereUniqueInput = {
    imageId?: Maybe<Scalars['String']>;
    path?: Maybe<Scalars['String']>;
};

export type IntFilter = {
    equals?: Maybe<Scalars['Int']>;
    gt?: Maybe<Scalars['Int']>;
    gte?: Maybe<Scalars['Int']>;
    in?: Maybe<Array<Maybe<Scalars['Int']>>>;
    lt?: Maybe<Scalars['Int']>;
    lte?: Maybe<Scalars['Int']>;
    not?: Maybe<Scalars['Int']>;
    notIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type IntNullableFilter = {
    equals?: Maybe<Scalars['Int']>;
    gt?: Maybe<Scalars['Int']>;
    gte?: Maybe<Scalars['Int']>;
    in?: Maybe<Array<Maybe<Scalars['Int']>>>;
    lt?: Maybe<Scalars['Int']>;
    lte?: Maybe<Scalars['Int']>;
    not?: Maybe<Scalars['Int']>;
    notIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type Interest = {
    __typename: 'Interest';
    /** @deprecated use category queries, no circular reference */
    category: InterestCategory;
    /** cuid of InterestCategory */
    categoryId: Scalars['String'];
    /** optional css class use by font */
    class?: Maybe<Scalars['String']>;
    /** cuid */
    interestId: Scalars['String'];
    name: Scalars['String'];
    /** optional relative image path */
    path?: Maybe<Scalars['String']>;
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type InterestCategory = {
    __typename: 'InterestCategory';
    /** cuid */
    interestCategoryId: Scalars['String'];
    interests: Array<Interest>;
    name: Scalars['String'];
    /** translations if user login filtered by user.languageCode */
    translations: Array<Translation>;
};

export type InterestCategoryWhereUniqueInput = {
    interestCategoryId: Scalars['String'];
};

export const InterestDistinctFieldEnum = {
    CategoryId: 'categoryId',
    Class: 'class',
    InterestId: 'interestId',
    Name: 'name',
} as const;

export type InterestDistinctFieldEnum =
    typeof InterestDistinctFieldEnum[keyof typeof InterestDistinctFieldEnum];
export type InterestWhereInput = {
    categoryId: Scalars['String'];
};

export type InterestWhereUniqueInput = {
    interestId: Scalars['String'];
};

export type Language = {
    __typename: 'Language';
    /** unique identifier */
    code: Scalars['String'];
    name: Scalars['String'];
};

export type Lead = {
    __typename: 'Lead';
    /** cuid */
    leadId: Scalars['String'];
    name: Scalars['String'];
};

export type LeadCreateOneWithoutUserLeadInput = {
    connect?: Maybe<LeadWhereUniqueInput>;
};

export type LeadWhereUniqueInput = {
    leadId?: Maybe<Scalars['String']>;
    name?: Maybe<Scalars['String']>;
};

/**
 * [likeProfile]({{Mutations.likeProfile}})
 *     is a feature and not available for all projects
 */
export type LikeProfileInput = {
    /** cuid of Profile */
    profileId: Scalars['String'];
};

export type LocationInput = {
    accuracy: Scalars['String'];
    city?: Maybe<Scalars['String']>;
    community: Scalars['String'];
    community_code: Scalars['String'];
    country: Scalars['String'];
    county: Scalars['String'];
    county_code: Scalars['String'];
    id: Scalars['String'];
    latitude?: Maybe<Scalars['String']>;
    longitude?: Maybe<Scalars['String']>;
    postcode: Scalars['String'];
    state: Scalars['String'];
    state_code: Scalars['String'];
    state_code_dc: Scalars['String'];
};

export type LoginInput = {
    client?: Maybe<Scalars['String']>;
    clientVersion?: Maybe<Scalars['String']>;
    password: Scalars['String'];
    timezone?: Maybe<Scalars['String']>;
    /** Username or email */
    username: Scalars['String'];
};

export type LoginMd5Input = {
    client?: Maybe<Scalars['String']>;
    clientVersion?: Maybe<Scalars['String']>;
    md5: Scalars['String'];
    timezone?: Maybe<Scalars['String']>;
    /** Username or email */
    username: Scalars['String'];
};

export type LoginResult = LoginResultSuccess | ResultError;

export type LoginResultSuccess = {
    __typename: 'LoginResultSuccess';
    coins: Scalars['Int'];
    cost: Cost;
    deactivatedPushes: Array<Maybe<DeactivatedPush>>;
    freePokes: Scalars['Int'];
    myProfile: MyProfile;
    role: UserRole;
    token: Scalars['String'];
    user: User;
    userId: Scalars['String'];
};

export type LoginTokenInput = {
    timezone?: Maybe<Scalars['String']>;
    token: Scalars['String'];
};

export type Match = {
    __typename: 'Match';
    matchId: Scalars['String'];
    owner: Profile;
    ownerId: Scalars['String'];
    playedAt?: Maybe<Scalars['DateTime']>;
    profile: Profile;
    profileId: Scalars['String'];
    type: MatchType;
};

export type MatchConfigResult = Error | MatchConfigResultSuccess;

export type MatchConfigResultSuccess = {
    __typename: 'MatchConfigResultSuccess';
    buyMore: Scalars['Boolean'];
    cost: Scalars['Int'];
    freeMessages: Scalars['Int'];
    limit: Scalars['Int'];
    played: Scalars['Int'];
};

export type MatchFilter = {
    __typename: 'MatchFilter';
    /** min age of profile */
    ageFrom: Scalars['Int'];
    /** max age of profile */
    ageTo: Scalars['Int'];
    /** identifier cuid */
    matchFilterId: Scalars['String'];
    /** DateTime from last update */
    updatedAt: Scalars['DateTime'];
    /** own userId (cuid) */
    userId: Scalars['String'];
};

/** Result for MatchFilter */
export type MatchFilterResult = Error | MatchFilter;

export type MatchFilterUpdateInput = {
    /** min age of profile */
    ageFrom?: Maybe<Scalars['Int']>;
    /** max age of profile */
    ageTo?: Maybe<Scalars['Int']>;
};

export type MatchOrderByWithRelationInput = {
    matchId?: Maybe<SortOrder>;
    playedAt?: Maybe<SortOrder>;
};

export const MatchType = {
    Default: 'default',
    No: 'no',
    Skip: 'skip',
    Yes: 'yes',
} as const;

export type MatchType = typeof MatchType[keyof typeof MatchType];
export type MatchWhereInput = {
    cost?: Maybe<IntFilter>;
    matchId?: Maybe<Scalars['String']>;
    playedAt?: Maybe<DateTimeNullableFilter>;
    profileId?: Maybe<Scalars['String']>;
    type?: Maybe<EnumMatchTypeFilter>;
};

export type MatchWhereUniqueInput = {
    matchId: Scalars['String'];
};

export type Message = {
    __typename: 'Message';
    /** if own message cost of message */
    coins: Scalars['Int'];
    /** Conversation node */
    conversation: Conversation;
    /** cuid of Conversation */
    conversationId: Scalars['String'];
    createdAt: Scalars['DateTime'];
    /** Gift node */
    gift?: Maybe<Gift>;
    /** cuid of Gift */
    giftId?: Maybe<Scalars['String']>;
    /** cuid */
    messageId: Scalars['String'];
    model: MessageType;
    /** relative image path for Gift/Picture/PredefinedMessage */
    path?: Maybe<Scalars['String']>;
    /** Picture node */
    picture?: Maybe<Picture>;
    /** cuid of Picture */
    pictureId?: Maybe<Scalars['String']>;
    /** sender Profile node */
    sender: Profile;
    /** cuid of sender Profile */
    senderId: Scalars['String'];
    /** for PredefinedMessage: translated text for user.languageCode */
    text?: Maybe<Scalars['String']>;
    updatedAt: Scalars['DateTime'];
};

export type MessageCost = {
    __typename: 'MessageCost';
    cost: Scalars['Int'];
    length: Scalars['Int'];
};

export const MessageDistinctFieldEnum = {
    Bonus: 'bonus',
    Coins: 'coins',
    ConversationId: 'conversationId',
    CreatedAt: 'createdAt',
    GiftId: 'giftId',
    MessageId: 'messageId',
    Model: 'model',
    PictureId: 'pictureId',
    SenderId: 'senderId',
    Text: 'text',
    UpdatedAt: 'updatedAt',
} as const;

export type MessageDistinctFieldEnum =
    typeof MessageDistinctFieldEnum[keyof typeof MessageDistinctFieldEnum];
/** user receivers for new conversation or conversation to answer */
export type MessageInput = {
    conversation?: Maybe<ConversationWhereUniqueInput>;
    receivers?: Maybe<Array<ProfileWhereUniqueInput>>;
    text: Scalars['String'];
};

export type MessageListRelationFilter = {
    every?: Maybe<MessageWhereInput>;
    none?: Maybe<MessageWhereInput>;
    some?: Maybe<MessageWhereInput>;
};

export type MessageOrderByInput = {
    createdAt?: Maybe<SortOrder>;
    messageId?: Maybe<SortOrder>;
    model?: Maybe<SortOrder>;
    text?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
};

export const MessageType = {
    Gift: 'Gift',
    Match: 'Match',
    Message: 'Message',
    Picture: 'Picture',
    Poke: 'Poke',
    PredefinedMessage: 'PredefinedMessage',
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];
export type MessageWhereInput = {
    AND?: Maybe<Array<Maybe<MessageWhereInput>>>;
    NOT?: Maybe<Array<Maybe<MessageWhereInput>>>;
    OR?: Maybe<Array<Maybe<MessageWhereInput>>>;
    conversation?: Maybe<ConversationWhereInput>;
    conversationId?: Maybe<StringFilter>;
    giftId?: Maybe<StringNullableFilter>;
    messageId?: Maybe<StringFilter>;
    model?: Maybe<EnumMessageTypeFilter>;
    pictureId?: Maybe<StringNullableFilter>;
    sender?: Maybe<ProfileWhereInput>;
    senderId?: Maybe<StringFilter>;
    updatedAt?: Maybe<DateTimeFilter>;
};

export type MessageWhereUniqueInput = {
    messageId: Scalars['String'];
};

export type MobileNumberInput = {
    /** internationales Format „00491712345678“ */
    mobileNumber: Scalars['String'];
};

export type MobileNumberValidationInput = {
    /** Code for mobile number validation */
    mobileNumberValidation: Scalars['String'];
};

export type Mutation = {
    __typename: 'Mutation';
    /** deactivate all pushes */
    activateAllDeactivatedPush: BatchPayload;
    /** add a Profile to own favorites */
    addFavorite?: Maybe<Favorite>;
    /** add a new Friendship */
    addFriendship?: Maybe<AddFriendshipResult>;
    appleLogin: SocialLoginResult;
    /** block one Profile */
    blockProfile?: Maybe<ResultSuccess>;
    buyMoreMatches: NextMatchResult;
    changeMatchFilter: MatchFilterResult;
    /** activate/deactivate one DeactivatedPush */
    changeOneDeactivatedPush: DeactivatedPush;
    /** Decline or accept own Friendship */
    changeStatusFriendship?: Maybe<ResultSuccess>;
    commitTransaction?: Maybe<TransactionResult>;
    contactSupport: ResultSuccess;
    createOneEyeCatcher: CoinsResult;
    createOneUserComplain: UserComplain;
    createOneVoting: Voting;
    createTransaction?: Maybe<TransactionResult>;
    deleteAccount: DeleteAccountResult;
    /** allow all pushes */
    deleteAllDeactivatedPush: BatchPayload;
    /** delete own Image */
    deleteGalleryImage?: Maybe<ResultSuccess>;
    facebookLogin: SocialLoginResult;
    forgottenPassword: ResultSuccess;
    googleLogin: SocialLoginResult;
    /** hide/unhidden a conversation, hiding will be removed if a new action occurs */
    hideConversation?: Maybe<ResultSuccess>;
    /** like a [Profile]({{Types.Profile}}), likeProfile is a feature and not available for all projects */
    likeProfile?: Maybe<ResultSuccess>;
    login: LoginResult;
    loginByMD5: LoginResult;
    loginByToken: LoginResult;
    mobileNumberValidation: Result;
    /**
     * answer an [OptionPoll]({{Types.OptionPoll}}),
     *             **OptionPoll is a feature and not available for all projects**
     */
    optionPollAnswer?: Maybe<ProfileOptionPoll>;
    /** mutation to read a conversation */
    readConversation?: Maybe<ResultSuccess>;
    readManyNotification?: Maybe<BatchPayload>;
    readSupportMessage: SupportMessage;
    /** redeem a coupon to get coins */
    redeemCoupon?: Maybe<CoinsResult>;
    register: RegisterResult;
    registerC4F: RegisterResult;
    registerDirect: RegisterResult;
    registerShort: RegisterResult;
    /** remove a Profile from own favorites */
    removeFavorite?: Maybe<Favorite>;
    /** cancel own Friendship */
    removeFriendship?: Maybe<ResultSuccess>;
    resetPassword: ResetPasswordResult;
    sendGift?: Maybe<SendMessageResult>;
    sendMatch: SendMatchResult;
    sendMessage?: Maybe<SendMessageResult>;
    sendPicture?: Maybe<SendMessageResult>;
    sendPoke?: Maybe<SendMessageResult>;
    /**
     * send a [PredefinedMessage]({{Types.PredefinedMessage}}),
     *             **[PredefinedMessage]({{Types.PredefinedMessage}}) is a feature and not available for all projects**
     */
    sendPredefinedMessage: SendMessageResult;
    sendSupportMessage: SupportMessage;
    unbindSocial: Social;
    /** unblock one Profile, throws UserInputError if params are missing. */
    unblockProfile?: Maybe<ResultSuccess>;
    updateEmail: ValidateResult;
    /** set own Image to private */
    updateGalleryImage?: Maybe<ResultSuccess>;
    updateMobileNumber: ValidateResult;
    updateMyProfile?: Maybe<UpdateMyProfileResult>;
    updateOneUser: User;
    /** change own Image to main */
    updateProfileImage?: Maybe<ResultSuccess>;
    updatePushToken: UpdateTokenResultSuccess;
    /** upload a new image wo own Profile */
    uploadGalleryImage?: Maybe<Image>;
    uploadPicture: UploadPictureResult;
    validateEmail: ValidateResult;
    validateMobileNumber: ValidateResult;
    validateUsername: ValidateResult;
    verifyEmail: ResultSuccess;
    visitProfile?: Maybe<VisitProfileResult>;
};

export type MutationAddFavoriteArgs = {
    data: ProfileWhereUniqueInput;
};

export type MutationAddFriendshipArgs = {
    data: ProfileWhereUniqueInput;
};

export type MutationAppleLoginArgs = {
    data: SocialLoginInput;
};

export type MutationBlockProfileArgs = {
    data: BlockProfileInput;
};

export type MutationChangeMatchFilterArgs = {
    data: MatchFilterUpdateInput;
};

export type MutationChangeOneDeactivatedPushArgs = {
    data: DeactivatedPushChangeInput;
};

export type MutationChangeStatusFriendshipArgs = {
    data: ChangeFriendshipInput;
};

export type MutationCommitTransactionArgs = {
    data: TransactionWhereUniqueInput;
};

export type MutationContactSupportArgs = {
    data?: Maybe<ContactSupportInput>;
};

export type MutationCreateOneEyeCatcherArgs = {
    data: EyeCatcherCreateInput;
};

export type MutationCreateOneUserComplainArgs = {
    data: UserComplainCreateInput;
};

export type MutationCreateOneVotingArgs = {
    data: VotingCreateInput;
};

export type MutationCreateTransactionArgs = {
    data: TransactionInput;
};

export type MutationDeleteAccountArgs = {
    data: DeleteAccountInput;
};

export type MutationDeleteGalleryImageArgs = {
    data: DeleteGalleryImageInput;
};

export type MutationFacebookLoginArgs = {
    data: SocialLoginInput;
};

export type MutationForgottenPasswordArgs = {
    data: ForgottenPasswordInput;
};

export type MutationGoogleLoginArgs = {
    data: SocialLoginInput;
};

export type MutationHideConversationArgs = {
    conversationId: Scalars['String'];
    hide?: Scalars['Boolean'];
};

export type MutationLikeProfileArgs = {
    data: LikeProfileInput;
};

export type MutationLoginArgs = {
    data: LoginInput;
};

export type MutationLoginByMd5Args = {
    data: LoginMd5Input;
};

export type MutationLoginByTokenArgs = {
    data: LoginTokenInput;
};

export type MutationMobileNumberValidationArgs = {
    data: MobileNumberValidationInput;
};

export type MutationOptionPollAnswerArgs = {
    data: OptionPollAnswerInput;
};

export type MutationReadConversationArgs = {
    conversationId?: Maybe<Scalars['String']>;
};

export type MutationReadManyNotificationArgs = {
    where?: Maybe<Array<Maybe<NotificationWhereUniqueInput>>>;
};

export type MutationReadSupportMessageArgs = {
    where?: Maybe<SupportMessageWhereUniqueInput>;
};

export type MutationRedeemCouponArgs = {
    data: CouponWhereUniqueInput;
};

export type MutationRegisterArgs = {
    data: RegisterInput;
};

export type MutationRegisterC4FArgs = {
    data: RegisterC4FInput;
};

export type MutationRegisterDirectArgs = {
    data: RegisterDirectInput;
};

export type MutationRegisterShortArgs = {
    data: RegisterShortInput;
};

export type MutationRemoveFavoriteArgs = {
    data: FavoriteWhereUniqueInput;
};

export type MutationRemoveFriendshipArgs = {
    data: RemoveFriendshipInput;
};

export type MutationResetPasswordArgs = {
    data: ResetPasswordInput;
};

export type MutationSendGiftArgs = {
    data: GiftInput;
};

export type MutationSendMatchArgs = {
    type: MatchType;
    where: MatchWhereUniqueInput;
};

export type MutationSendMessageArgs = {
    data: MessageInput;
};

export type MutationSendPictureArgs = {
    data: PictureInput;
};

export type MutationSendPokeArgs = {
    data: PokeInput;
};

export type MutationSendPredefinedMessageArgs = {
    data: PredefinedMessageInput;
};

export type MutationSendSupportMessageArgs = {
    data?: Maybe<SupportMessageCreateInput>;
};

export type MutationUnbindSocialArgs = {
    where: SocialWhereUniqueInput;
};

export type MutationUnblockProfileArgs = {
    data: MyBlockedWhereUniqueInput;
};

export type MutationUpdateEmailArgs = {
    data: ValidateEmailInput;
};

export type MutationUpdateGalleryImageArgs = {
    data: UpdateGalleryImageInput;
};

export type MutationUpdateMobileNumberArgs = {
    data: ValidateMobileNumberInput;
};

export type MutationUpdateMyProfileArgs = {
    data: UpdateMyProfileInput;
};

export type MutationUpdateOneUserArgs = {
    data: UserUpdateInput;
};

export type MutationUpdateProfileImageArgs = {
    data: UpdateProfileImageInput;
};

export type MutationUpdatePushTokenArgs = {
    data: UpdateTokenInput;
};

export type MutationUploadGalleryImageArgs = {
    data: UploadGalleryImageInput;
};

export type MutationUploadPictureArgs = {
    data: UploadPictureInput;
};

export type MutationValidateEmailArgs = {
    data: ValidateEmailInput;
};

export type MutationValidateMobileNumberArgs = {
    data: ValidateMobileNumberInput;
};

export type MutationValidateUsernameArgs = {
    data: ValidateUsernameInput;
};

export type MutationVerifyEmailArgs = {
    data: VerifyEmailInput;
};

export type MutationVisitProfileArgs = {
    data: ProfileWhereUniqueInput;
};

/** combine unique index for Blocked: blockedId -> cuid or profileId from other Profile */
export type MyBlockedWhereUniqueInput = {
    /** cuid of Blocked */
    blockedId?: Maybe<Scalars['String']>;
    /** profileId of other Profile */
    profileId?: Maybe<Scalars['String']>;
};

export type MyProfile = ProfileI & {
    __typename: 'MyProfile';
    /** Profile accept Picture */
    acceptPicture: Scalars['Boolean'];
    /** Profile age, if profile incomplete 0 */
    age: Scalars['Int'];
    /** Avatar is a feature and not available for all projects */
    avatar?: Maybe<Avatar>;
    /** relative image path to avatar image, Avatar is a feature and not available for all projects */
    avatarPath?: Maybe<Scalars['String']>;
    birthDate?: Maybe<Scalars['String']>;
    /** own Profile is completed */
    completed: Scalars['Boolean'];
    conversationProfiles: Array<ConversationProfile>;
    country: Scalars['String'];
    county: Scalars['String'];
    /**
     * translated string of [ProfileText]({{Types.ProfileText}}),
     *                 languageCode from login user
     *                 **[ProfileText]({{Types.ProfileText}}) is a feature and not available for all projects**
     */
    defaultText?: Maybe<Scalars['String']>;
    flirtText: Scalars['String'];
    /** list of own Friendship */
    friends: Array<Friendship>;
    furtherInformation?: Maybe<Scalars['String']>;
    gender: Gender;
    images: Array<Image>;
    languageCode: Scalars['String'];
    /** list of own Favorite */
    myFavorites: Array<Favorite>;
    premiumStatus: Array<ProfileStatus>;
    profileFlags: Array<ProfileFlag>;
    /** cuid */
    profileId: Scalars['String'];
    profileInterests: Array<ProfileInterest>;
    profileName: Scalars['String'];
    receivedPictures: Array<Picture>;
    searches: Gender;
    shownLocation: Scalars['String'];
    /** Theme node to display at some views */
    theme?: Maybe<Theme>;
    /** unique identifier for Theme node */
    themeName?: Maybe<Scalars['String']>;
    user: User;
    zodiacSign?: Maybe<Scalars['String']>;
};

export type MyProfileAvatarPathArgs = {
    relative?: Maybe<Scalars['Boolean']>;
};

export type MyProfileConversationProfilesArgs = {
    cursor?: Maybe<ConversationProfileWhereUniqueInput>;
    orderBy?: Maybe<ConversationProfileOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ConversationProfileWhereInput>;
};

export type MyProfileFriendsArgs = {
    cursor?: Maybe<FriendshipWhereUniqueInput>;
    orderBy?: Maybe<FriendshipOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<FriendshipWhereInput>;
};

export type MyProfileImagesArgs = {
    cursor?: Maybe<ImageWhereUniqueInput>;
    distinct?: Maybe<ImageDistinctFieldEnum>;
    orderBy?: Maybe<Array<Maybe<ImageOrderByInput>>>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ImageWhereInput>;
};

export type MyProfileMyFavoritesArgs = {
    cursor?: Maybe<FavoriteWhereUniqueInput>;
    orderBy?: Maybe<FavoriteOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<FavoriteWhereInput>;
};

export type MyProfileReceivedPicturesArgs = {
    cursor?: Maybe<PictureWhereUniqueInput>;
    orderBy?: Maybe<PictureOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<PictureWhereInput>;
};

/** Result for getNext */
export type NextMatchResult = Error | NextMatchResultSuccess;

export type NextMatchResultSuccess = {
    __typename: 'NextMatchResultSuccess';
    matches: Array<Match>;
};

export type Notification = {
    __typename: 'Notification';
    createdAt: Scalars['DateTime'];
    /** cuid */
    notificationId: Scalars['String'];
    /** Profile node */
    profile?: Maybe<Profile>;
    /** cuid of Profile */
    profileId?: Maybe<Scalars['String']>;
    read: Scalars['Boolean'];
    /** SupportMessage -> supportTicketId, [Poke, Gift] -> conversationId, Friendship -> friendshipId, CoinsAdded -> coinsChanged string from number */
    target?: Maybe<Scalars['String']>;
    type: NotificationType;
    updatedAt: Scalars['DateTime'];
};

export const NotificationDistinctFieldEnum = {
    CreatedAt: 'createdAt',
    NotificationId: 'notificationId',
    Read: 'read',
    Type: 'type',
    UpdatedAt: 'updatedAt',
    UserId: 'userId',
} as const;

export type NotificationDistinctFieldEnum =
    typeof NotificationDistinctFieldEnum[keyof typeof NotificationDistinctFieldEnum];
export type NotificationOrderByInput = {
    notificationId?: Maybe<SortOrder>;
    read?: Maybe<SortOrder>;
    type?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
};

/** you received coins */
export type NotificationSubscriptionCoinsAddedPayload = {
    __typename: 'NotificationSubscriptionCoinsAddedPayload';
    coinsChanged: Scalars['Int'];
    totalCoins: Scalars['Int'];
    type: NotificationType;
};

/** new Friendship */
export type NotificationSubscriptionFriendshipPayload = {
    __typename: 'NotificationSubscriptionFriendshipPayload';
    friendshipId: Scalars['String'];
    /** cuid other Profile */
    senderId: Scalars['String'];
    senderName: Scalars['String'];
    type: NotificationType;
};

/** new gift */
export type NotificationSubscriptionGiftPayload = {
    __typename: 'NotificationSubscriptionGiftPayload';
    conversationId: Scalars['String'];
    giftId: Scalars['String'];
    /** cuid other Profile */
    senderId: Scalars['String'];
    senderName: Scalars['String'];
    text: Scalars['String'];
    type: NotificationType;
};

/** set Image: ImageDeleted or ImagePrivate by Admin */
export type NotificationSubscriptionImagePayload = {
    __typename: 'NotificationSubscriptionImagePayload';
    /** cuid Image */
    imageId: Scalars['String'];
    type: NotificationType;
};

/** sb likes you */
export type NotificationSubscriptionLikePayload = {
    __typename: 'NotificationSubscriptionLikePayload';
    /** cuid other Profile */
    otherProfileId: Scalars['String'];
    type: NotificationType;
};

/** a new Match */
export type NotificationSubscriptionMatchPayload = {
    __typename: 'NotificationSubscriptionMatchPayload';
    /** cuid Match */
    matchId: Scalars['String'];
    /** cuid other Profile */
    otherProfileId: Scalars['String'];
    type: NotificationType;
};

/** new message */
export type NotificationSubscriptionMessagePayload = {
    __typename: 'NotificationSubscriptionMessagePayload';
    conversationId: Scalars['String'];
    /** cuid other Profile */
    senderId: Scalars['String'];
    senderName: Scalars['String'];
    text: Scalars['String'];
    type: NotificationType;
};

export type NotificationSubscriptionPayload =
    | NotificationSubscriptionCoinsAddedPayload
    | NotificationSubscriptionFriendshipPayload
    | NotificationSubscriptionGiftPayload
    | NotificationSubscriptionImagePayload
    | NotificationSubscriptionLikePayload
    | NotificationSubscriptionMatchPayload
    | NotificationSubscriptionMessagePayload
    | NotificationSubscriptionPaymentPayload
    | NotificationSubscriptionPicturePayload
    | NotificationSubscriptionPokePayload
    | NotificationSubscriptionProfileTextChangedPayload
    | NotificationSubscriptionSupportMessagePayload
    | NotificationSubscriptionVisitPayload;

/** PaymentSuccess|PaymentFailed */
export type NotificationSubscriptionPaymentPayload = {
    __typename: 'NotificationSubscriptionPaymentPayload';
    coins: Scalars['Int'];
    /** payment provider (e.g. payPal) */
    provider: Scalars['String'];
    /** cuid Transaction */
    transactionId: Scalars['String'];
    type: NotificationType;
};

/** new picture */
export type NotificationSubscriptionPicturePayload = {
    __typename: 'NotificationSubscriptionPicturePayload';
    conversationId: Scalars['String'];
    pictureId: Scalars['String'];
    /** cuid other Profile */
    senderId: Scalars['String'];
    senderName: Scalars['String'];
    type: NotificationType;
};

/** new poke */
export type NotificationSubscriptionPokePayload = {
    __typename: 'NotificationSubscriptionPokePayload';
    conversationId: Scalars['String'];
    /** cuid other Profile */
    senderId: Scalars['String'];
    senderName: Scalars['String'];
    type: NotificationType;
};

/** admin changed your flirtText */
export type NotificationSubscriptionProfileTextChangedPayload = {
    __typename: 'NotificationSubscriptionProfileTextChangedPayload';
    type: NotificationType;
};

/** send for new support message */
export type NotificationSubscriptionSupportMessagePayload = {
    __typename: 'NotificationSubscriptionSupportMessagePayload';
    /** cuid SupportMessage */
    supportMessageId: Scalars['String'];
    /** cuid SupportTicket */
    supportTicketId: Scalars['String'];
    text: Scalars['String'];
    type: NotificationType;
};

/** new visit */
export type NotificationSubscriptionVisitPayload = {
    __typename: 'NotificationSubscriptionVisitPayload';
    /** cuid other Profile */
    senderId: Scalars['String'];
    senderName: Scalars['String'];
    type: NotificationType;
};

export const NotificationType = {
    CoinsAdded: 'CoinsAdded',
    FriendshipAccept: 'FriendshipAccept',
    FriendshipDecline: 'FriendshipDecline',
    FriendshipDelete: 'FriendshipDelete',
    FriendshipRequest: 'FriendshipRequest',
    Gift: 'Gift',
    ImageDeleted: 'ImageDeleted',
    ImagePrivate: 'ImagePrivate',
    Message: 'Message',
    PaymentFailed: 'PaymentFailed',
    PaymentSuccess: 'PaymentSuccess',
    Picture: 'Picture',
    Poke: 'Poke',
    ProfileTextChanged: 'ProfileTextChanged',
    SupportMessage: 'SupportMessage',
    Visit: 'Visit',
} as const;

export type NotificationType =
    typeof NotificationType[keyof typeof NotificationType];
export type NotificationWhereInput = {
    AND?: Maybe<Array<Maybe<NotificationWhereInput>>>;
    NOT?: Maybe<Array<Maybe<NotificationWhereInput>>>;
    OR?: Maybe<Array<Maybe<NotificationWhereInput>>>;
    notificationId?: Maybe<StringFilter>;
    read?: Maybe<BoolFilter>;
    type?: Maybe<EnumNotificationTypeFilter>;
    updatedAt?: Maybe<DateTimeFilter>;
};

export type NotificationWhereUniqueInput = {
    notificationId: Scalars['String'];
};

export type Offer = {
    __typename: 'Offer';
    bonus: Scalars['Int'];
    coins: Scalars['Int'];
    cost: Scalars['Float'];
    currency: Scalars['String'];
    extra: Scalars['String'];
    name: Scalars['String'];
    /** cuid */
    offerId: Scalars['String'];
    periodUnit: PeriodUnitOffer;
    profileStatus?: Maybe<ProfileStatus>;
    /** Provider node */
    provider: Provider;
    /** unique identifier for Provider */
    providerName: Scalars['String'];
    statusPeriod: Scalars['Int'];
};

export const OfferDistinctFieldEnum = {
    Active: 'active',
    Bonus: 'bonus',
    Coins: 'coins',
    Cost: 'cost',
    Currency: 'currency',
    Extra: 'extra',
    Limit: 'limit',
    Name: 'name',
    OfferId: 'offerId',
    ProviderName: 'providerName',
} as const;

export type OfferDistinctFieldEnum =
    typeof OfferDistinctFieldEnum[keyof typeof OfferDistinctFieldEnum];
export type OfferListRelationFilter = {
    every?: Maybe<OfferWhereInput>;
    none?: Maybe<OfferWhereInput>;
    some?: Maybe<OfferWhereInput>;
};

export type OfferOrderByInput = {
    active?: Maybe<SortOrder>;
    bonus?: Maybe<SortOrder>;
    coins?: Maybe<SortOrder>;
    cost?: Maybe<SortOrder>;
    currency?: Maybe<SortOrder>;
    extra?: Maybe<SortOrder>;
    limit?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    offerId?: Maybe<SortOrder>;
    providerName?: Maybe<SortOrder>;
};

export type OfferWhereInput = {
    AND?: Maybe<Array<Maybe<OfferWhereInput>>>;
    NOT?: Maybe<Array<Maybe<OfferWhereInput>>>;
    OR?: Maybe<Array<Maybe<OfferWhereInput>>>;
    bonus?: Maybe<IntFilter>;
    coins?: Maybe<IntFilter>;
    cost?: Maybe<FloatFilter>;
    currency?: Maybe<StringFilter>;
    extra?: Maybe<StringFilter>;
    name?: Maybe<StringFilter>;
    offerId?: Maybe<StringFilter>;
    provider?: Maybe<ProviderWhereInput>;
    providerName?: Maybe<StringFilter>;
};

export type OfferWhereUniqueInput = {
    offerId: Scalars['String'];
};

export const OperatingSystem = {
    Android: 'ANDROID',
    Ios: 'IOS',
    Web: 'WEB',
} as const;

export type OperatingSystem =
    typeof OperatingSystem[keyof typeof OperatingSystem];
/**
 * **[OptionPoll]({{Types.OptionPoll}}) is a feature
 *     and not available for all projects**
 */
export type OptionPoll = {
    __typename: 'OptionPoll';
    /** list of all answers */
    answers: Array<OptionPollAnswer>;
    languageCode: Scalars['String'];
    /** if user had answered node of [ProfileOptionPoll]({{Types.ProfileOptionPoll}}) */
    myAnswer?: Maybe<ProfileOptionPoll>;
    name: Scalars['String'];
    /** cuid */
    optionPollId: Scalars['String'];
    position: Scalars['Int'];
    /** translated text */
    text: Scalars['String'];
};

export type OptionPollAnswer = {
    __typename: 'OptionPollAnswer';
    languageCode: Scalars['String'];
    /** cuid */
    optionPollAnswerId: Scalars['String'];
    /** cuid of OptionPoll */
    optionPollId: Scalars['String'];
    /** optional relative image path */
    path?: Maybe<Scalars['String']>;
    text: Scalars['String'];
    /** number of votes in % */
    votes: Scalars['String'];
};

/**
 * **[OptionPoll]({{Types.OptionPoll}}) is a
 *         feature and not available for all projects**
 */
export type OptionPollAnswerInput = {
    optionPollAnswerId: Scalars['String'];
    optionPollId: Scalars['String'];
};

export const PeriodUnit = {
    Days: 'days',
    Hours: 'hours',
    Minutes: 'minutes',
    Months: 'months',
    Weeks: 'weeks',
} as const;

export type PeriodUnit = typeof PeriodUnit[keyof typeof PeriodUnit];
export const PeriodUnitOffer = {
    Days: 'days',
    Months: 'months',
    Weeks: 'weeks',
} as const;

export type PeriodUnitOffer =
    typeof PeriodUnitOffer[keyof typeof PeriodUnitOffer];
export type Picture = {
    __typename: 'Picture';
    fsk18: Scalars['Boolean'];
    owner: Profile;
    ownerId: Scalars['String'];
    /** relative image path */
    path: Scalars['String'];
    /** cuid */
    pictureId: Scalars['String'];
};

export type PicturePathArgs = {
    relative?: Maybe<Scalars['Boolean']>;
    size?: Maybe<Scalars['Int']>;
};

/** user receivers for new conversation or conversation to answer */
export type PictureInput = {
    conversation?: Maybe<ConversationWhereUniqueInput>;
    picture: PictureWhereUniqueInput;
    receivers?: Maybe<Array<ProfileWhereUniqueInput>>;
    text?: Maybe<Scalars['String']>;
};

export type PictureOrderByInput = {
    pictureId: SortOrder;
};

export type PictureWhereInput = {
    AND?: Maybe<Array<Maybe<PictureWhereInput>>>;
    Message?: Maybe<MessageListRelationFilter>;
    NOT?: Maybe<Array<Maybe<PictureWhereInput>>>;
    OR?: Maybe<Array<Maybe<PictureWhereInput>>>;
    fsk18?: Maybe<BoolFilter>;
    owner?: Maybe<ProfileWhereInput>;
    ownerId?: Maybe<StringFilter>;
    path?: Maybe<StringFilter>;
    pictureId?: Maybe<StringFilter>;
};

export type PictureWhereUniqueInput = {
    pictureId: Scalars['String'];
};

export type PokeCost = {
    __typename: 'PokeCost';
    cost: Scalars['Int'];
    free?: Maybe<Scalars['Int']>;
};

/** user receivers for new conversation or conversation to answer */
export type PokeInput = {
    conversation?: Maybe<ConversationWhereUniqueInput>;
    receivers?: Maybe<Array<ProfileWhereUniqueInput>>;
};

/**
 * **[PredefinedMessage]({{Types.PredefinedMessage}}) is
 *             a feature and not available for all projects**
 */
export type PredefinedMessage = {
    __typename: 'PredefinedMessage';
    /** optional relative image path */
    path?: Maybe<Scalars['String']>;
    /** cuid */
    predefinedMessageId: Scalars['String'];
    /** translations for login user languageCode */
    translations: Array<Translation>;
};

/**
 * for a new conversation use receivers, to answer use conversationId
 *     **[PredefinedMessage]({{Types.PredefinedMessage}}) is a feature and not available for all projects**
 */
export type PredefinedMessageInput = {
    conversation?: Maybe<ConversationWhereUniqueInput>;
    /** cuid of PredefinedMessage */
    predefinedMessageId: Scalars['String'];
    receivers?: Maybe<Array<ProfileWhereUniqueInput>>;
};

export type Profile = ProfileI & {
    __typename: 'Profile';
    /** Profile accept Picture */
    acceptPicture: Scalars['Boolean'];
    /** Profile age, if profile incomplete 0 */
    age: Scalars['Int'];
    /** Avatar is a feature and not available for all projects */
    avatar?: Maybe<Avatar>;
    /** relative image path to avatar image, Avatar is a feature and not available for all projects */
    avatarPath?: Maybe<Scalars['String']>;
    /** is on my blocked list */
    blocked: Scalars['Boolean'];
    country: Scalars['String'];
    county: Scalars['String'];
    /**
     * translated string of [ProfileText]({{Types.ProfileText}}),
     *                 languageCode from login user
     *                 **[ProfileText]({{Types.ProfileText}}) is a feature and not available for all projects**
     */
    defaultText?: Maybe<Scalars['String']>;
    /** is on my favorite list */
    favorite: Scalars['Boolean'];
    flirtText: Scalars['String'];
    /** status of Friendship */
    friendshipStatus?: Maybe<Scalars['String']>;
    furtherInformation?: Maybe<Scalars['String']>;
    gender: Gender;
    images: Array<Image>;
    languageCode: Scalars['String'];
    premiumStatus: Array<ProfileStatus>;
    profileFlags: Array<ProfileFlag>;
    /** cuid */
    profileId: Scalars['String'];
    profileInterests: Array<ProfileInterest>;
    profileName: Scalars['String'];
    searches: Gender;
    shownLocation: Scalars['String'];
    /** Theme node to display at some views */
    theme?: Maybe<Theme>;
    /** unique identifier for Theme node */
    themeName?: Maybe<Scalars['String']>;
    zodiacSign?: Maybe<Scalars['String']>;
};

export type ProfileAvatarPathArgs = {
    relative?: Maybe<Scalars['Boolean']>;
};

export type ProfileImagesArgs = {
    cursor?: Maybe<ImageWhereUniqueInput>;
    distinct?: Maybe<ImageDistinctFieldEnum>;
    orderBy?: Maybe<Array<Maybe<ImageOrderByInput>>>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ImageWhereInput>;
};

export type ProfileCreateOneWithoutUserComplainInput = {
    connect: ProfileWhereUniqueInput;
};

export type ProfileCreateOneWithoutVotingInput = {
    connect?: Maybe<ProfileWhereUniqueInput>;
};

export type ProfileFlag = {
    __typename: 'ProfileFlag';
    flag: Flag;
    flagId: Scalars['String'];
    flagValue?: Maybe<FlagValue>;
    flagValueId?: Maybe<Scalars['String']>;
    profileFlagId: Scalars['String'];
    profileId: Scalars['String'];
    value?: Maybe<Scalars['String']>;
};

export type ProfileFlagCreateWithoutProfileInput = {
    flag: FlagCreateNestedOneWithoutProfileFlagsInput;
    flagValue?: Maybe<FlagValueCreateNestedOneWithoutProfileFlagsInput>;
    value?: Maybe<Scalars['String']>;
};

export const ProfileFlagDistinctFieldEnum = {
    CreatedAt: 'createdAt',
    FlagId: 'flagId',
    ProfileFlagId: 'profileFlagId',
    ProfileId: 'profileId',
} as const;

export type ProfileFlagDistinctFieldEnum =
    typeof ProfileFlagDistinctFieldEnum[keyof typeof ProfileFlagDistinctFieldEnum];
export type ProfileFlagListRelationFilter = {
    every?: Maybe<ProfileFlagWhereOnlyScalarInput>;
    none?: Maybe<ProfileFlagWhereOnlyScalarInput>;
    some?: Maybe<ProfileFlagWhereOnlyScalarInput>;
};

export type ProfileFlagOrderByInput = {
    createdAt?: Maybe<SortOrder>;
    flagId?: Maybe<SortOrder>;
    profileFlagId?: Maybe<SortOrder>;
    profileId?: Maybe<SortOrder>;
};

export type ProfileFlagScalarWhereInput = {
    flagId?: Maybe<StringFilter>;
    profileFlagId?: Maybe<StringFilter>;
    profileId?: Maybe<StringFilter>;
};

export type ProfileFlagUpdateManyWithoutProfileInput = {
    delete?: Maybe<Array<Maybe<ProfileFlagWhereUniqueInput>>>;
    deleteMany?: Maybe<Array<Maybe<ProfileFlagScalarWhereInput>>>;
};

export type ProfileFlagUpdateManyWithoutProfileNestedInput = {
    create?: Maybe<Array<ProfileFlagCreateWithoutProfileInput>>;
    delete?: Maybe<Array<ProfileFlagWhereUniqueInput>>;
    update?: Maybe<Array<ProfileFlagUpdateWithWhereUniqueWithoutProfileInput>>;
};

export type ProfileFlagUpdateWithWhereUniqueWithoutProfileInput = {
    data: ProfileFlagUpdateWithoutProfileInput;
    where: ProfileFlagWhereUniqueInput;
};

export type ProfileFlagUpdateWithoutProfileInput = {
    flagValue?: Maybe<FlagValueCreateNestedOneWithoutProfileFlagsInput>;
    value?: Maybe<Scalars['String']>;
};

export type ProfileFlagWhereInput = {
    flagId?: Maybe<StringFilter>;
    profile?: Maybe<ProfileWhereInput>;
    profileFlagId?: Maybe<StringFilter>;
    profileId?: Maybe<StringFilter>;
};

export type ProfileFlagWhereOnlyScalarInput = {
    flagId?: Maybe<StringFilter>;
    profileFlagId?: Maybe<StringFilter>;
    profileId?: Maybe<StringFilter>;
};

export type ProfileFlagWhereUniqueInput = {
    profileFlagId: Scalars['String'];
};

export type ProfileI = {
    /** Profile accept Picture */
    acceptPicture: Scalars['Boolean'];
    /** Profile age, if profile incomplete 0 */
    age: Scalars['Int'];
    country: Scalars['String'];
    county: Scalars['String'];
    flirtText: Scalars['String'];
    furtherInformation?: Maybe<Scalars['String']>;
    gender: Gender;
    images: Array<Image>;
    languageCode: Scalars['String'];
    premiumStatus: Array<ProfileStatus>;
    profileFlags: Array<ProfileFlag>;
    /** cuid */
    profileId: Scalars['String'];
    profileInterests: Array<ProfileInterest>;
    profileName: Scalars['String'];
    searches: Gender;
    shownLocation: Scalars['String'];
    /** Theme node to display at some views */
    theme?: Maybe<Theme>;
    /** unique identifier for Theme node */
    themeName?: Maybe<Scalars['String']>;
    zodiacSign?: Maybe<Scalars['String']>;
};

export type ProfileIImagesArgs = {
    cursor?: Maybe<ImageWhereUniqueInput>;
    distinct?: Maybe<ImageDistinctFieldEnum>;
    orderBy?: Maybe<Array<Maybe<ImageOrderByInput>>>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ImageWhereInput>;
};

export type ProfileInterest = {
    __typename: 'ProfileInterest';
    /** Interest node */
    interest: Interest;
    /** unique identifier for Interest */
    interestName: Scalars['String'];
    /**
     * Profile node
     * @deprecated Use profile queries instead, no circular references
     */
    profile: Profile;
    /** cuid of Profile */
    profileId: Scalars['String'];
    /** cuid */
    profileInterestId: Scalars['String'];
};

export type ProfileInterestListRelationFilter = {
    every?: Maybe<ProfileInterestWhereInput>;
    none?: Maybe<ProfileInterestWhereInput>;
    some?: Maybe<ProfileInterestWhereInput>;
};

export type ProfileInterestWhereInput = {
    AND?: Maybe<Array<Maybe<ProfileInterestWhereInput>>>;
    NOT?: Maybe<Array<Maybe<ProfileInterestWhereInput>>>;
    OR?: Maybe<Array<Maybe<ProfileInterestWhereInput>>>;
    interest?: Maybe<InterestWhereInput>;
    interestId?: Maybe<StringFilter>;
    profileInterestId?: Maybe<StringFilter>;
};

export type ProfileOptionPoll = {
    __typename: 'ProfileOptionPoll';
    createdAt: Scalars['DateTime'];
    /** cuid of OptionPollAnswer */
    optionPollAnswerId: Scalars['String'];
    /** cuid of OptionPoll */
    optionPollId: Scalars['String'];
    /** cuid of Profile */
    profileId: Scalars['String'];
    /** cuid */
    profileOptionPollId: Scalars['String'];
};

export type ProfileOrderByInput = {
    birthDate?: Maybe<SortOrder>;
    flirtText?: Maybe<SortOrder>;
    gender?: Maybe<SortOrder>;
    profileName?: Maybe<SortOrder>;
    searches?: Maybe<SortOrder>;
    shownLocation?: Maybe<SortOrder>;
};

export const ProfileStatus = {
    Premium: 'Premium',
} as const;

export type ProfileStatus = typeof ProfileStatus[keyof typeof ProfileStatus];
export type ProfileText = {
    __typename: 'ProfileText';
    /** cuid */
    profileTextId: Scalars['String'];
    translations: Array<Translation>;
};

export type ProfileWhereInput = {
    AND?: Maybe<Array<Maybe<ProfileWhereInput>>>;
    NOT?: Maybe<Array<Maybe<ProfileWhereInput>>>;
    OR?: Maybe<Array<Maybe<ProfileWhereInput>>>;
    acceptPicture?: Maybe<BoolFilter>;
    country?: Maybe<StringNullableFilter>;
    county?: Maybe<StringNullableFilter>;
    flirtText?: Maybe<StringNullableFilter>;
    furtherInformation?: Maybe<StringNullableFilter>;
    gender?: Maybe<EnumGenderFilter>;
    images?: Maybe<ImageListRelationFilter>;
    languageCode?: Maybe<StringNullableFilter>;
    profileId?: Maybe<StringFilter>;
    profileInterests?: Maybe<ProfileInterestListRelationFilter>;
    profileName?: Maybe<StringFilter>;
    searches?: Maybe<EnumGenderFilter>;
    shownLocation?: Maybe<StringNullableFilter>;
    themeName?: Maybe<StringNullableFilter>;
};

export type ProfileWhereInputExtended = {
    AND?: Maybe<Array<Maybe<ProfileWhereInput>>>;
    NOT?: Maybe<Array<Maybe<ProfileWhereInput>>>;
    OR?: Maybe<Array<Maybe<ProfileWhereInput>>>;
    acceptPicture?: Maybe<BoolFilter>;
    age?: Maybe<AgeFilter>;
    country?: Maybe<StringNullableFilter>;
    county?: Maybe<StringNullableFilter>;
    flirtText?: Maybe<StringNullableFilter>;
    furtherInformation?: Maybe<StringNullableFilter>;
    gender?: Maybe<EnumGenderFilter>;
    images?: Maybe<ImageListRelationFilter>;
    languageCode?: Maybe<StringNullableFilter>;
    online?: Maybe<Scalars['Boolean']>;
    profileId?: Maybe<StringFilter>;
    profileInterests?: Maybe<ProfileInterestListRelationFilter>;
    profileName?: Maybe<StringFilter>;
    searches?: Maybe<EnumGenderFilter>;
    shownLocation?: Maybe<StringNullableFilter>;
    themeName?: Maybe<StringNullableFilter>;
};

export type ProfileWhereUniqueInput = {
    profileId: Scalars['String'];
};

export type Provider = {
    __typename: 'Provider';
    currency: Scalars['String'];
    description?: Maybe<Scalars['String']>;
    logo: Scalars['String'];
    name: Scalars['String'];
    offers: Array<Offer>;
    /** cuid */
    providerId: Scalars['String'];
    title: Scalars['String'];
};

export type ProviderOffersArgs = {
    cursor?: Maybe<OfferWhereUniqueInput>;
    distinct?: Maybe<OfferDistinctFieldEnum>;
    orderBy?: Maybe<OfferOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<OfferWhereInput>;
};

export type ProviderOrderByInput = {
    active?: Maybe<SortOrder>;
    currency?: Maybe<SortOrder>;
    description?: Maybe<SortOrder>;
    hidden?: Maybe<SortOrder>;
    limitTransaction?: Maybe<SortOrder>;
    logo?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    providerId?: Maybe<SortOrder>;
    title?: Maybe<SortOrder>;
};

export type ProviderWhereInput = {
    AND?: Maybe<Array<Maybe<ProviderWhereInput>>>;
    NOT?: Maybe<Array<Maybe<ProviderWhereInput>>>;
    OR?: Maybe<Array<Maybe<ProviderWhereInput>>>;
    currency?: Maybe<StringFilter>;
    description?: Maybe<StringNullableFilter>;
    hidden?: Maybe<BoolFilter>;
    name?: Maybe<StringFilter>;
    offers?: Maybe<OfferListRelationFilter>;
    os?: Maybe<OperatingSystem>;
    providerId?: Maybe<StringFilter>;
};

export type ProviderWhereUniqueInput = {
    name?: Maybe<Scalars['String']>;
    providerId?: Maybe<Scalars['String']>;
};

export const PushSetting = {
    Friendship: 'Friendship',
    Gift: 'Gift',
    Message: 'Message',
    Picture: 'Picture',
    Poke: 'Poke',
    SystemMessage: 'SystemMessage',
    Visit: 'Visit',
} as const;

export type PushSetting = typeof PushSetting[keyof typeof PushSetting];
export type Query = {
    __typename: 'Query';
    /** aggregate own conversations, e.g. get amount of all unread */
    aggregateConversations?: Maybe<AggregateConversationsResult>;
    coins?: Maybe<Scalars['Int']>;
    /** get cost and bonus coins */
    config: Config;
    /** get a list of [Avatar]({{Types.Avatar}}), Avatar is a feature and not available for all projects */
    findManyAvatar: Array<Avatar>;
    /** get list of all blocked Profile */
    findManyBlocked: Array<Blocked>;
    /** get count of all blocked Profile, use for pagination */
    findManyBlockedCount: Scalars['Int'];
    /** get ComplainType list, translations are filtered by user language */
    findManyComplainType: Array<ComplainType>;
    /** get list of conversation node for login user. Max take = (-)10, default orderBy lastAction desc */
    findManyConversation: Array<Conversation>;
    /** get count of user conversations */
    findManyConversationCount: Scalars['Int'];
    /** get list of own ConversationProfile node */
    findManyConversationProfile: Array<ConversationProfile>;
    /**
     * get list of [DailySong]({{Types.DailySong}}),
     *             **DailySong is a feature and not available for all projects**
     */
    findManyDailySong: Array<DailySong>;
    /** get list of own DeactivatedPush node */
    findManyDeactivatedPush: Array<DeactivatedPush>;
    findManyEyeCatcher: Array<EyeCatcher>;
    findManyEyeCatcherCount: Scalars['Int'];
    /** get list of Favorite node for login user */
    findManyFavorite: Array<Favorite>;
    /** get count of own Favorite */
    findManyFavoriteCount: Scalars['Int'];
    findManyFlag: Array<Flag>;
    /** list of own Friendship node */
    findManyFriendship: Array<Friendship>;
    /** count of own Friendship */
    findManyFriendshipCount: Scalars['Int'];
    findManyGeolocation: Array<Geolocation>;
    findManyGeolocationCount: Scalars['Int'];
    /** get list of Gift node */
    findManyGift: Array<Gift>;
    /** get list of GiftCategory node */
    findManyGiftCategory: Array<GiftCategory>;
    /** get count of GiftCategory */
    findManyGiftCategoryCount: Scalars['Int'];
    /** list of Interest node */
    findManyInterest: Array<Interest>;
    findManyInterestCategory: Array<InterestCategory>;
    /** count of Interest */
    findManyInterestCount: Scalars['Int'];
    /** get available languages */
    findManyLanguage: Array<Language>;
    findManyMatch: Array<Match>;
    findManyMatchCount: Scalars['Int'];
    findManyMessage?: Maybe<Array<Maybe<Message>>>;
    findManyMessageCount?: Maybe<Scalars['Int']>;
    findManyNotification: Array<Notification>;
    findManyNotificationCount: Scalars['Int'];
    findManyOffer: Array<Offer>;
    /**
     * Get list of [OptionPoll]({{Types.OptionPoll}}) for user languageCode,
     *                 **OptionPoll is a feature and not available for all projects**
     */
    findManyOptionPoll: Array<OptionPoll>;
    findManyPicture: Array<Picture>;
    /**
     * get list of all [PredefinedMessage]({{Types.PredefinedMessage}}),
     *             **[PredefinedMessage]({{Types.PredefinedMessage}}) is
     *             a feature and not available for all projects**
     */
    findManyPredefinedMessage: Array<PredefinedMessage>;
    findManyProfile: Array<Profile>;
    findManyProfileCount: Scalars['Int'];
    /** get list of all [ProfileText]({{Types.ProfileText}}) node */
    findManyProfileText: Array<ProfileText>;
    findManyProvider: Array<Provider>;
    findManySupportTicket: Array<SupportTicket>;
    findManyTheme: Array<Theme>;
    findManyThemeCount: Scalars['Int'];
    findManyThemeImage: Array<ThemeImage>;
    findManyTranslation: Array<Translation>;
    findManyTranslationCount: Scalars['Int'];
    findManyVisit: Array<Visit>;
    findManyVisitCount: Scalars['Int'];
    findManyVoting: Array<Voting>;
    findManyVotingCount: Scalars['Int'];
    /** get one conversation for login user */
    findOneConversation?: Maybe<Conversation>;
    /** get one own ConversationProfile node */
    findOneConversationProfile?: Maybe<ConversationProfile>;
    /** get one DeactivatedPush node fo login user */
    findOneDeactivatedPush?: Maybe<DeactivatedPush>;
    findOneEyeCatcher?: Maybe<EyeCatcher>;
    /** get one Favorite for login user */
    findOneFavorite?: Maybe<Favorite>;
    /** get one own Friendship */
    findOneFriendship?: Maybe<Friendship>;
    /** get one Gift */
    findOneGift?: Maybe<Gift>;
    /** get one GiftCategory */
    findOneGiftCategory?: Maybe<GiftCategory>;
    findOneInterestCategory?: Maybe<InterestCategory>;
    findOneOffer?: Maybe<Offer>;
    findOneProfile?: Maybe<Profile>;
    findOneSupportTicket?: Maybe<SupportTicket>;
    findOneTheme?: Maybe<Theme>;
    findOneTranslation?: Maybe<Translation>;
    /** get cost for all types */
    getCosts: Cost;
    getCounties: Array<Scalars['String']>;
    getCountries: Array<Scalars['String']>;
    getMatchFilter?: Maybe<MatchFilter>;
    getNextMatches: NextMatchResult;
    matchConfig: MatchConfigResult;
    myProfile: MyProfile;
    randomProfile?: Maybe<Profile>;
    unreadSupportMessageCount: Scalars['Int'];
    userPremiumStatus: Array<UserPremiumStatus>;
};

export type QueryAggregateConversationsArgs = {
    _sum?: Maybe<ConversationProfileSumAggregateInputType>;
    where?: Maybe<ConversationProfileWhereInput>;
};

export type QueryFindManyAvatarArgs = {
    where?: Maybe<AvatarWhereInput>;
};

export type QueryFindManyBlockedArgs = {
    cursor?: Maybe<BlockedWhereUniqueInput>;
    orderBy?: Maybe<BlockedOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<BlockedWhereInput>;
};

export type QueryFindManyBlockedCountArgs = {
    cursor?: Maybe<BlockedWhereUniqueInput>;
    orderBy?: Maybe<BlockedOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<BlockedWhereInput>;
};

export type QueryFindManyConversationArgs = {
    cursor?: Maybe<ConversationWhereUniqueInput>;
    orderBy?: Maybe<ConversationOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ConversationWhereInput>;
};

export type QueryFindManyConversationCountArgs = {
    cursor?: Maybe<ConversationWhereUniqueInput>;
    orderBy?: Maybe<ConversationOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ConversationWhereInput>;
};

export type QueryFindManyConversationProfileArgs = {
    cursor?: Maybe<ConversationProfileWhereUniqueInput>;
    orderBy?: Maybe<ConversationProfileOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ConversationProfileWhereInput>;
};

export type QueryFindManyDeactivatedPushArgs = {
    orderBy?: Maybe<DeactivatedPushOrderByInput>;
    where?: Maybe<DeactivatedPushWhereInput>;
};

export type QueryFindManyEyeCatcherArgs = {
    cursor?: Maybe<EyeCatcherWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<EyeCatcherWhereInput>;
};

export type QueryFindManyEyeCatcherCountArgs = {
    cursor?: Maybe<EyeCatcherWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<EyeCatcherWhereInput>;
};

export type QueryFindManyFavoriteArgs = {
    cursor?: Maybe<FavoriteWhereUniqueInput>;
    orderBy?: Maybe<FavoriteOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<FavoriteWhereInput>;
};

export type QueryFindManyFavoriteCountArgs = {
    cursor?: Maybe<FavoriteWhereUniqueInput>;
    orderBy?: Maybe<FavoriteOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<FavoriteWhereInput>;
};

export type QueryFindManyFriendshipArgs = {
    cursor?: Maybe<FriendshipWhereUniqueInput>;
    orderBy?: Maybe<FriendshipOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<FriendshipWhereInput>;
};

export type QueryFindManyFriendshipCountArgs = {
    cursor?: Maybe<FriendshipWhereUniqueInput>;
    orderBy?: Maybe<FriendshipOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<FriendshipWhereInput>;
};

export type QueryFindManyGeolocationArgs = {
    cursor?: Maybe<GeolocationWhereUniqueInput>;
    distinct?: Maybe<GeolocationDistinctFieldEnum>;
    orderBy?: Maybe<GeolocationOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<GeolocationWhereInput>;
};

export type QueryFindManyGeolocationCountArgs = {
    cursor?: Maybe<GeolocationWhereUniqueInput>;
    distinct?: Maybe<GeolocationDistinctFieldEnum>;
    orderBy?: Maybe<GeolocationOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<GeolocationWhereInput>;
};

export type QueryFindManyGiftArgs = {
    cursor?: Maybe<GiftWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<GiftWhereInput>;
};

export type QueryFindManyGiftCategoryArgs = {
    cursor?: Maybe<GiftCategoryWhereUniqueInput>;
    orderBy?: Maybe<GiftCategoryOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<GiftCategoryWhereInput>;
};

export type QueryFindManyGiftCategoryCountArgs = {
    cursor?: Maybe<GiftCategoryWhereUniqueInput>;
    orderBy?: Maybe<GiftCategoryOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<GiftCategoryWhereInput>;
};

export type QueryFindManyInterestArgs = {
    cursor?: Maybe<InterestWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<InterestWhereInput>;
};

export type QueryFindManyInterestCategoryArgs = {
    cursor?: Maybe<InterestCategoryWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
};

export type QueryFindManyInterestCountArgs = {
    cursor?: Maybe<InterestWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<InterestWhereInput>;
};

export type QueryFindManyMatchArgs = {
    cursor?: Maybe<MatchWhereUniqueInput>;
    orderBy?: Maybe<Array<Maybe<MatchOrderByWithRelationInput>>>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
};

export type QueryFindManyMatchCountArgs = {
    cursor?: Maybe<MatchWhereUniqueInput>;
    orderBy?: Maybe<MatchOrderByWithRelationInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
};

export type QueryFindManyMessageArgs = {
    cursor?: Maybe<MessageWhereUniqueInput>;
    orderBy?: Maybe<MessageOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<MessageWhereInput>;
};

export type QueryFindManyMessageCountArgs = {
    cursor?: Maybe<MessageWhereUniqueInput>;
    orderBy?: Maybe<MessageOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<MessageWhereInput>;
};

export type QueryFindManyNotificationArgs = {
    cursor?: Maybe<NotificationWhereUniqueInput>;
    orderBy?: Maybe<NotificationOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<NotificationWhereInput>;
};

export type QueryFindManyNotificationCountArgs = {
    cursor?: Maybe<NotificationWhereUniqueInput>;
    orderBy?: Maybe<NotificationOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<NotificationWhereInput>;
};

export type QueryFindManyOfferArgs = {
    cursor?: Maybe<OfferWhereUniqueInput>;
    orderBy?: Maybe<OfferOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<OfferWhereInput>;
};

export type QueryFindManyPictureArgs = {
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
};

export type QueryFindManyProfileArgs = {
    cursor?: Maybe<ProfileWhereUniqueInput>;
    orderBy?: Maybe<ProfileOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ProfileWhereInputExtended>;
};

export type QueryFindManyProfileCountArgs = {
    cursor?: Maybe<ProfileWhereUniqueInput>;
    orderBy?: Maybe<ProfileOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ProfileWhereInput>;
};

export type QueryFindManyProviderArgs = {
    cursor?: Maybe<ProviderWhereUniqueInput>;
    orderBy?: Maybe<ProviderOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ProviderWhereInput>;
};

export type QueryFindManySupportTicketArgs = {
    cursor?: Maybe<SupportTicketWhereUniqueInput>;
    orderBy?: Maybe<Array<Maybe<SupportTicketOrderByInput>>>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<SupportTicketWhereInput>;
};

export type QueryFindManyThemeArgs = {
    cursor?: Maybe<ThemeWhereUniqueInput>;
    orderBy?: Maybe<ThemeOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ThemeWhereInput>;
};

export type QueryFindManyThemeCountArgs = {
    cursor?: Maybe<ThemeWhereUniqueInput>;
    orderBy?: Maybe<ThemeOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ThemeWhereInput>;
};

export type QueryFindManyThemeImageArgs = {
    cursor?: Maybe<ThemeImageWhereUniqueInput>;
    orderBy?: Maybe<ThemeImageOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ThemeImageWhereInput>;
};

export type QueryFindManyTranslationArgs = {
    cursor?: Maybe<TranslationWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<TranslationWhereInput>;
};

export type QueryFindManyTranslationCountArgs = {
    cursor?: Maybe<TranslationWhereUniqueInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<TranslationWhereInput>;
};

export type QueryFindManyVisitArgs = {
    cursor?: Maybe<VisitWhereUniqueInput>;
    orderBy?: Maybe<VisitOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<VisitWhereInput>;
};

export type QueryFindManyVisitCountArgs = {
    cursor?: Maybe<VisitWhereUniqueInput>;
    orderBy?: Maybe<VisitOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<VisitWhereInput>;
};

export type QueryFindManyVotingArgs = {
    cursor?: Maybe<VotingWhereUniqueInput>;
    orderBy?: Maybe<VotingOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<VotingWhereInput>;
};

export type QueryFindManyVotingCountArgs = {
    cursor?: Maybe<VotingWhereUniqueInput>;
    orderBy?: Maybe<VotingOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<VotingWhereInput>;
};

export type QueryFindOneConversationArgs = {
    where: ConversationWhereUniqueInput;
};

export type QueryFindOneConversationProfileArgs = {
    where: ConversationProfileWhereUniqueInput;
};

export type QueryFindOneDeactivatedPushArgs = {
    where: DeactivatedPushWhereUniqueInput;
};

export type QueryFindOneEyeCatcherArgs = {
    where: EyeCatcherWhereUniqueInput;
};

export type QueryFindOneFavoriteArgs = {
    where: FavoriteWhereUniqueInput;
};

export type QueryFindOneFriendshipArgs = {
    where: FriendshipWhereUniqueInput;
};

export type QueryFindOneGiftArgs = {
    where: GiftWhereUniqueInput;
};

export type QueryFindOneGiftCategoryArgs = {
    where: GiftCategoryWhereUniqueInput;
};

export type QueryFindOneInterestCategoryArgs = {
    where: InterestCategoryWhereUniqueInput;
};

export type QueryFindOneOfferArgs = {
    where: OfferWhereUniqueInput;
};

export type QueryFindOneProfileArgs = {
    where: ProfileWhereUniqueInput;
};

export type QueryFindOneSupportTicketArgs = {
    where: SupportTicketWhereUniqueInput;
};

export type QueryFindOneThemeArgs = {
    where: ThemeWhereUniqueInput;
};

export type QueryFindOneTranslationArgs = {
    where: TranslationWhereUniqueInput;
};

export type QueryRandomProfileArgs = {
    where: ProfileWhereInput;
};

export type RegisterC4FInput = {
    affiliateName?: Scalars['String'];
    /** YYYY-MM-DD */
    birthDate: Scalars['String'];
    c4fId: Scalars['String'];
    /** Client */
    client?: Maybe<Scalars['String']>;
    /** Client version */
    clientVersion?: Maybe<Scalars['String']>;
    domain?: Maybe<Scalars['String']>;
    /** Email */
    email?: Maybe<Scalars['String']>;
    /** FlirtText */
    flirtText?: Maybe<Scalars['String']>;
    gender?: Maybe<Gender>;
    hash: Scalars['String'];
    ip: Scalars['String'];
    /** Language.code */
    language: Scalars['String'];
    /** c4f location object */
    location: LocationInput;
    /** MobileNumber E.164 format */
    mobileNumber?: Maybe<Scalars['String']>;
    /** Password */
    password: Scalars['String'];
    /** ProfileName */
    profileName?: Maybe<Scalars['String']>;
    /** pushToken */
    pushToken?: Maybe<Scalars['String']>;
    searches?: Maybe<Gender>;
    /** Theme */
    theme?: Maybe<Scalars['String']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone?: Maybe<Scalars['String']>;
    /** Many leads */
    userLeads?: Maybe<UserLeadCreateManyWithoutUserInput>;
    /** Username */
    username?: Maybe<Scalars['String']>;
};

export type RegisterDirectInput = {
    affiliateName?: Scalars['String'];
    /** YYYY-MM-DD */
    birthDate: Scalars['String'];
    c4fId?: Maybe<Scalars['String']>;
    /** Client */
    client?: Maybe<Scalars['String']>;
    /** Client version */
    clientVersion?: Maybe<Scalars['String']>;
    /** Country Code */
    country: Scalars['String'];
    /** County */
    county?: Maybe<Scalars['String']>;
    domain?: Maybe<Scalars['String']>;
    /** Email */
    email?: Maybe<Scalars['String']>;
    /** FlirtText */
    flirtText?: Maybe<Scalars['String']>;
    gender?: Maybe<Gender>;
    hash: Scalars['String'];
    ip: Scalars['String'];
    /** Language.code */
    language: Scalars['String'];
    /** md5 hash of password */
    md5Password: Scalars['String'];
    /** MobileNumber E.164 format */
    mobileNumber?: Maybe<Scalars['String']>;
    postcode: Scalars['String'];
    /** ProfileName */
    profileName?: Maybe<Scalars['String']>;
    /** pushToken */
    pushToken?: Maybe<Scalars['String']>;
    searches?: Maybe<Gender>;
    /** Theme */
    theme?: Maybe<Scalars['String']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone?: Maybe<Scalars['String']>;
    /** Town */
    town?: Maybe<Scalars['String']>;
    /** Many leads */
    userLeads?: Maybe<UserLeadCreateManyWithoutUserInput>;
    /** Username */
    username?: Maybe<Scalars['String']>;
};

export type RegisterInput = {
    affiliateName?: Scalars['String'];
    /** YYYY-MM-DD */
    birthDate: Scalars['String'];
    /** Client */
    client?: Maybe<Scalars['String']>;
    /** Client version */
    clientVersion?: Maybe<Scalars['String']>;
    /** Country Code */
    country: Scalars['String'];
    /** County */
    county?: Maybe<Scalars['String']>;
    domain?: Maybe<Scalars['String']>;
    /** Email */
    email?: Maybe<Scalars['String']>;
    /** FlirtText */
    flirtText?: Maybe<Scalars['String']>;
    gender?: Maybe<Gender>;
    /** Language.code */
    language: Scalars['String'];
    /** MobileNumber E.164 format */
    mobileNumber?: Maybe<Scalars['String']>;
    /** Password */
    password: Scalars['String'];
    /** Postcode */
    postcode?: Maybe<Scalars['String']>;
    /** ProfileName */
    profileName?: Maybe<Scalars['String']>;
    /** pushToken */
    pushToken?: Maybe<Scalars['String']>;
    searches?: Maybe<Gender>;
    /** Theme */
    theme?: Maybe<Scalars['String']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone: Scalars['String'];
    /** Town */
    town?: Maybe<Scalars['String']>;
    /** Many leads */
    userLeads?: Maybe<UserLeadCreateManyWithoutUserInput>;
    /** Username */
    username?: Maybe<Scalars['String']>;
};

/** Result for register */
export type RegisterResult = RegisterResultSuccess | ResultError;

export type RegisterResultSuccess = {
    __typename: 'RegisterResultSuccess';
    coins: Scalars['Int'];
    myProfile: MyProfile;
    role: UserRole;
    token: Scalars['String'];
    userId: Scalars['String'];
};

export type RegisterShortInput = {
    affiliateName?: Scalars['String'];
    /** Client */
    client?: Maybe<Scalars['String']>;
    /** Client version */
    clientVersion?: Maybe<Scalars['String']>;
    domain?: Maybe<Scalars['String']>;
    /** Email  */
    email?: Maybe<Scalars['String']>;
    /** ISO LanguageCode -> de, en */
    language: Scalars['String'];
    /** MobileNumber E.164 format */
    mobileNumber?: Maybe<Scalars['String']>;
    /** Password min(6), max(100) */
    password: Scalars['String'];
    /** pushToken */
    pushToken?: Maybe<Scalars['String']>;
    /** IANA String, Android: TimeZone tz = TimeZone.getTimeZone("America/Los_Angeles, iOS: var localTimeZoneIdentifier: String { return TimeZone.current.identifier }"); */
    timezone: Scalars['String'];
    /** Many leads */
    userLeads?: Maybe<UserLeadCreateManyWithoutUserInput>;
    /** Username min(3), max(100) */
    username?: Maybe<Scalars['String']>;
};

export type RemoveFriendshipInput = {
    /** cuid other Profile */
    otherId: Scalars['String'];
};

export type ResetPasswordInput = {
    newPassword: Scalars['String'];
    oldPassword?: Maybe<Scalars['String']>;
    passwordHash?: Maybe<Scalars['String']>;
};

export type ResetPasswordResult = ResultError | ResultSuccess;

export type Result = Error | ResultError | ResultSuccess;

export type ResultError = {
    __typename: 'ResultError';
    errors: Array<Error>;
};

export type ResultSuccess = {
    __typename: 'ResultSuccess';
    success?: Maybe<Scalars['Boolean']>;
};

export type SelfIdOtherIdCompoundUniqueInput = {
    /** other profileId */
    otherId: Scalars['String'];
    /** own profileId */
    selfId: Scalars['String'];
};

export type SendMatchResult = Error | Match;

/** Result for sendPoke|sendMessage|sendGift */
export type SendMessageResult = CoinsResultSuccess | ResultError;

export type Social = {
    __typename: 'Social';
    providerName: Scalars['String'];
    socialId: Scalars['String'];
};

export type SocialError = {
    __typename: 'SocialError';
    email?: Maybe<Scalars['Boolean']>;
    username?: Maybe<Scalars['Boolean']>;
};

export type SocialLoginInput = {
    affiliateName?: Maybe<Scalars['String']>;
    client?: Maybe<Scalars['String']>;
    clientVersion?: Maybe<Scalars['String']>;
    domain?: Maybe<Scalars['String']>;
    email?: Maybe<Scalars['String']>;
    language: Scalars['String'];
    socialId?: Maybe<Scalars['String']>;
    timezone: Scalars['String'];
    token: Scalars['String'];
    /** Many leads */
    userLeads?: Maybe<UserLeadCreateManyWithoutUserInput>;
    username?: Maybe<Scalars['String']>;
};

export type SocialLoginResult = LoginResultSuccess | ResultError;

export type SocialWhereUniqueInput = {
    providerName: Scalars['String'];
    userId: Scalars['String'];
};

export const SortOrder = {
    Asc: 'asc',
    Desc: 'desc',
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type StringFilter = {
    contains?: Maybe<Scalars['String']>;
    endsWith?: Maybe<Scalars['String']>;
    equals?: Maybe<Scalars['String']>;
    gt?: Maybe<Scalars['String']>;
    gte?: Maybe<Scalars['String']>;
    in?: Maybe<Array<Maybe<Scalars['String']>>>;
    lt?: Maybe<Scalars['String']>;
    lte?: Maybe<Scalars['String']>;
    not?: Maybe<Scalars['String']>;
    notIn?: Maybe<Array<Maybe<Scalars['String']>>>;
    startsWith?: Maybe<Scalars['String']>;
};

export type StringNullableFilter = {
    contains?: Maybe<Scalars['String']>;
    endsWith?: Maybe<Scalars['String']>;
    equals?: Maybe<Scalars['String']>;
    gt?: Maybe<Scalars['String']>;
    gte?: Maybe<Scalars['String']>;
    in?: Maybe<Array<Maybe<Scalars['String']>>>;
    lt?: Maybe<Scalars['String']>;
    lte?: Maybe<Scalars['String']>;
    not?: Maybe<Scalars['String']>;
    notIn?: Maybe<Array<Maybe<Scalars['String']>>>;
    startsWith?: Maybe<Scalars['String']>;
};

export type Subscription = {
    __typename: 'Subscription';
    /** for online user to send all events */
    notifications?: Maybe<NotificationSubscriptionPayload>;
};

export const SupportCategory = {
    Bug: 'Bug',
    Other: 'Other',
    Payment: 'Payment',
} as const;

export type SupportCategory =
    typeof SupportCategory[keyof typeof SupportCategory];
export type SupportMessage = {
    __typename: 'SupportMessage';
    createdAt: Scalars['DateTime'];
    read: Scalars['Boolean'];
    sender: SupportMessageSender;
    supportMessageId: Scalars['String'];
    supportTicket: SupportTicket;
    supportTicketId: Scalars['String'];
    text: Scalars['String'];
    updatedAt: Scalars['DateTime'];
};

export type SupportMessageCreateInput = {
    category?: Maybe<SupportCategory>;
    status?: Maybe<SupportTicketStatus>;
    supportTicketId?: Maybe<Scalars['String']>;
    text?: Maybe<Scalars['String']>;
};

export type SupportMessageOrderByInput = {
    createdAt?: Maybe<SortOrder>;
    supportMessageId?: Maybe<SortOrder>;
    supportTicketId?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
};

export const SupportMessageSender = {
    Support: 'Support',
    System: 'System',
    User: 'User',
} as const;

export type SupportMessageSender =
    typeof SupportMessageSender[keyof typeof SupportMessageSender];
export type SupportMessageWhereInput = {
    createdAt?: Maybe<DateTimeFilter>;
    supportMessageId?: Maybe<StringFilter>;
    supportTicketId?: Maybe<Scalars['String']>;
    updatedAt?: Maybe<DateTimeFilter>;
};

export type SupportMessageWhereUniqueInput = {
    supportMessageId: Scalars['String'];
};

export type SupportTicket = {
    __typename: 'SupportTicket';
    category: SupportCategory;
    createdAt: Scalars['DateTime'];
    status: SupportTicketStatus;
    supportMessages: Array<SupportMessage>;
    supportTicketId: Scalars['String'];
    ticketNumber: Scalars['Int'];
    updatedAt: Scalars['DateTime'];
};

export type SupportTicketSupportMessagesArgs = {
    cursor?: Maybe<SupportMessageWhereUniqueInput>;
    orderBy?: Maybe<Array<Maybe<SupportMessageOrderByInput>>>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<SupportMessageWhereInput>;
};

export type SupportTicketOrderByInput = {
    status?: Maybe<SortOrder>;
    supportTicketId?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
};

export const SupportTicketStatus = {
    Answered: 'Answered',
    Closed: 'Closed',
    Open: 'Open',
    Pending: 'Pending',
} as const;

export type SupportTicketStatus =
    typeof SupportTicketStatus[keyof typeof SupportTicketStatus];
export type SupportTicketWhereInput = {
    createdAt?: Maybe<DateTimeFilter>;
    status?: Maybe<EnumSupportTicketStatusFilter>;
    supportTicketId?: Maybe<StringFilter>;
    updatedAt?: Maybe<DateTimeFilter>;
};

export type SupportTicketWhereUniqueInput = {
    supportTicketId: Scalars['String'];
};

export type Theme = {
    __typename: 'Theme';
    images: Array<ThemeImage>;
    name: Scalars['String'];
};

export type ThemeImagesArgs = {
    cursor?: Maybe<ThemeImageWhereUniqueInput>;
    distinct?: Maybe<ThemeImageDistinctFieldEnum>;
    orderBy?: Maybe<ThemeImageOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<ThemeImageWhereInput>;
};

export type ThemeImage = {
    __typename: 'ThemeImage';
    label: Scalars['String'];
    /** relative theme image path */
    path: Scalars['String'];
    theme: Theme;
    themeImageId: Scalars['String'];
    themeName: Scalars['String'];
};

export type ThemeImagePathArgs = {
    relative?: Maybe<Scalars['Boolean']>;
};

export const ThemeImageDistinctFieldEnum = {
    Label: 'label',
    Path: 'path',
    ThemeImageId: 'themeImageId',
    ThemeName: 'themeName',
} as const;

export type ThemeImageDistinctFieldEnum =
    typeof ThemeImageDistinctFieldEnum[keyof typeof ThemeImageDistinctFieldEnum];
export type ThemeImageOrderByInput = {
    label?: Maybe<SortOrder>;
    path?: Maybe<SortOrder>;
    themeImageId?: Maybe<SortOrder>;
    themeName?: Maybe<SortOrder>;
};

export type ThemeImageWhereInput = {
    AND?: Maybe<Array<Maybe<ThemeImageWhereInput>>>;
    NOT?: Maybe<Array<Maybe<ThemeImageWhereInput>>>;
    OR?: Maybe<Array<Maybe<ThemeImageWhereInput>>>;
    theme?: Maybe<ThemeWhereInput>;
    themeImageId?: Maybe<StringFilter>;
    themeName?: Maybe<StringFilter>;
};

export type ThemeImageWhereUniqueInput = {
    themeImageId: Scalars['String'];
};

export type ThemeOrderByInput = {
    createdAt?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    updatedAt?: Maybe<SortOrder>;
};

export type ThemeWhereInput = {
    AND?: Maybe<Array<Maybe<ThemeWhereInput>>>;
    NOT?: Maybe<Array<Maybe<ThemeWhereInput>>>;
    OR?: Maybe<Array<Maybe<ThemeWhereInput>>>;
    name?: Maybe<StringFilter>;
};

export type ThemeWhereUniqueInput = {
    name: Scalars['String'];
};

export type Transaction = {
    __typename: 'Transaction';
    bonus?: Maybe<Scalars['Int']>;
    coins: Scalars['Int'];
    cost: Scalars['Float'];
    provider: Provider;
    providerName: Scalars['String'];
    user: User;
    userId: Scalars['String'];
};

export type TransactionInput = {
    Offer: OfferWhereUniqueInput;
    reference?: Maybe<Scalars['String']>;
};

/** Result for createBilling */
export type TransactionResult =
    | ResultError
    | TransactionResultPending
    | TransactionResultSuccess;

export type TransactionResultData = BankData;

export type TransactionResultPending = {
    __typename: 'TransactionResultPending';
    /** Custom data object for frontend */
    data?: Maybe<TransactionResultData>;
    extTransactionId?: Maybe<Scalars['String']>;
    offer?: Maybe<Offer>;
    provider?: Maybe<Scalars['String']>;
    redirectUrl?: Maybe<Scalars['String']>;
    transactionId: Scalars['String'];
};

export type TransactionResultSuccess = {
    __typename: 'TransactionResultSuccess';
    coins: CoinsResultSuccess;
    extTransactionId?: Maybe<Scalars['String']>;
    provider?: Maybe<Scalars['String']>;
    transactionCountry?: Maybe<Scalars['String']>;
    transactionId: Scalars['String'];
};

export type TransactionWhereUniqueInput = {
    reference?: Maybe<Scalars['String']>;
    token?: Maybe<Scalars['String']>;
    transactionId?: Maybe<Scalars['String']>;
};

export type Translation = {
    __typename: 'Translation';
    /** cuid for avatar, Avatar is a feature and not available for all projects */
    avatarId?: Maybe<Scalars['String']>;
    complainTypeId?: Maybe<Scalars['String']>;
    flagId?: Maybe<Scalars['String']>;
    flagValueId?: Maybe<Scalars['String']>;
    giftCategoryId?: Maybe<Scalars['String']>;
    giftId?: Maybe<Scalars['String']>;
    interestCategoryId?: Maybe<Scalars['String']>;
    interestId?: Maybe<Scalars['String']>;
    languageCode: Scalars['String'];
    /**
     * cuid of [PredefinedMessage]({{Types.PredefinedMessage}}),
     *             **[PredefinedMessage]({{Types.PredefinedMessage}}) is a feature and
     *             not available for all projects**
     */
    predefinedMessageId?: Maybe<Scalars['String']>;
    /** cuid of ProfileText */
    profileTextId?: Maybe<Scalars['String']>;
    projectName: Scalars['String'];
    translation: Scalars['String'];
    translationId: Scalars['String'];
    translationView: TranslationView;
};

export const TranslationView = {
    Edit: 'Edit',
    Show: 'Show',
} as const;

export type TranslationView =
    typeof TranslationView[keyof typeof TranslationView];
export type TranslationWhereInput = {
    languageCode?: Maybe<StringFilter>;
    translationId?: Maybe<StringFilter>;
    translationView?: Maybe<TranslationView>;
};

export type TranslationWhereUniqueInput = {
    translationId: Scalars['String'];
};

export type UpdateGalleryImageInput = {
    imageId: Scalars['String'];
    private: Scalars['Boolean'];
};

export type UpdateMyProfileInput = {
    /** cuid for avatar, Avatar is a feature and not available for all projects */
    avatarId?: Maybe<Scalars['String']>;
    birthDate?: Maybe<Scalars['String']>;
    country?: Maybe<Scalars['String']>;
    county?: Maybe<Scalars['String']>;
    /** cuid of ProfileText */
    defaultTextId?: Maybe<Scalars['String']>;
    flirtText?: Maybe<Scalars['String']>;
    gender?: Maybe<Gender>;
    hidden?: Maybe<Scalars['Boolean']>;
    postcode?: Maybe<Scalars['String']>;
    profileFlags?: Maybe<ProfileFlagUpdateManyWithoutProfileNestedInput>;
    profileInterests?: Maybe<Array<InterestWhereUniqueInput>>;
    searches?: Maybe<Gender>;
    theme?: Maybe<ThemeWhereUniqueInput>;
    town?: Maybe<Scalars['String']>;
};

export type UpdateMyProfileResult = MyProfile | ResultError;

export type UpdateProfileImageInput = {
    imageId: Scalars['String'];
};

export type UpdateTokenInput = {
    pushToken: Scalars['String'];
};

export type UpdateTokenResultSuccess = {
    __typename: 'UpdateTokenResultSuccess';
    success?: Maybe<Scalars['Boolean']>;
};

export type UploadGalleryImageInput = {
    /** base64 string of image file, please use crop to 1000x1000! */
    base64: Scalars['String'];
};

export type UploadPictureInput = {
    base64: Scalars['String'];
};

export type UploadPictureResult = Error | Picture;

export type User = {
    __typename: 'User';
    Notification?: Maybe<Array<Maybe<Notification>>>;
    client?: Maybe<Scalars['String']>;
    clientVersion?: Maybe<Scalars['String']>;
    coins: Scalars['Int'];
    createdAt: Scalars['DateTime'];
    deactivatedPushes?: Maybe<Array<Maybe<DeactivatedPush>>>;
    deleteToken: Scalars['String'];
    email?: Maybe<Scalars['String']>;
    emailValidated: Scalars['Boolean'];
    flirtTextCompleted: Scalars['Boolean'];
    imageCompleted: Scalars['Boolean'];
    latitude?: Maybe<Scalars['String']>;
    longitude?: Maybe<Scalars['String']>;
    mobileNumber?: Maybe<Scalars['String']>;
    mobileNumberValidated: Scalars['Boolean'];
    profile: Profile;
    profileFlagsCompleted: Scalars['Boolean'];
    profileId: Scalars['String'];
    role: Scalars['String'];
    sendMarketingEmail: Scalars['Boolean'];
    sendSMS: Scalars['Boolean'];
    sendTransactionalEmail: Scalars['Boolean'];
    socials?: Maybe<Array<Social>>;
    userId: Scalars['String'];
    userPremiumStatus: Array<UserPremiumStatus>;
    username: Scalars['String'];
};

export type UserNotificationArgs = {
    cursor?: Maybe<NotificationWhereUniqueInput>;
    distinct?: Maybe<NotificationDistinctFieldEnum>;
    orderBy?: Maybe<NotificationOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<NotificationWhereInput>;
};

export type UserDeactivatedPushesArgs = {
    cursor?: Maybe<DeactivatedPushWhereUniqueInput>;
    distinct?: Maybe<DeactivatedPushDistinctFieldEnum>;
    orderBy?: Maybe<DeactivatedPushOrderByInput>;
    skip?: Maybe<Scalars['Int']>;
    take?: Maybe<Scalars['Int']>;
    where?: Maybe<DeactivatedPushWhereInput>;
};

export type UserComplain = {
    __typename: 'UserComplain';
    complainType: ComplainType;
    complainTypeName: Scalars['String'];
    name?: Maybe<Scalars['String']>;
    target: Profile;
    targetId: Scalars['String'];
    text?: Maybe<Scalars['String']>;
};

export type UserComplainCreateInput = {
    complainType: ComplainTypeCreateOneWithoutUserComplainInput;
    name?: Maybe<Scalars['String']>;
    target: ProfileCreateOneWithoutUserComplainInput;
    text?: Maybe<Scalars['String']>;
};

export const UserComplainDistinctFieldEnum = {
    ComplainTypeName: 'complainTypeName',
    CreatedAt: 'createdAt',
    LanguageCode: 'languageCode',
    Name: 'name',
    ReporterId: 'reporterId',
    TargetId: 'targetId',
    Text: 'text',
    UserComplainId: 'userComplainId',
} as const;

export type UserComplainDistinctFieldEnum =
    typeof UserComplainDistinctFieldEnum[keyof typeof UserComplainDistinctFieldEnum];
export type UserComplainListRelationFilter = {
    every?: Maybe<UserComplainWhereInput>;
    none?: Maybe<UserComplainWhereInput>;
    some?: Maybe<UserComplainWhereInput>;
};

export type UserComplainOrderByInput = {
    complainTypeName?: Maybe<SortOrder>;
    createdAt?: Maybe<SortOrder>;
    languageCode?: Maybe<SortOrder>;
    name?: Maybe<SortOrder>;
    reporterId?: Maybe<SortOrder>;
    targetId?: Maybe<SortOrder>;
    text?: Maybe<SortOrder>;
    userComplainId?: Maybe<SortOrder>;
};

export type UserComplainWhereInput = {
    complainTypeName?: Maybe<StringFilter>;
    languageCode?: Maybe<StringFilter>;
    name?: Maybe<StringFilter>;
};

export type UserComplainWhereUniqueInput = {
    userComplainId?: Maybe<Scalars['String']>;
};

export type UserCoupon = {
    __typename: 'UserCoupon';
    coupon: Coupon;
    couponCode: Scalars['String'];
    user: User;
    userId: Scalars['String'];
};

export type UserIdSettingCompoundUniqueInput = {
    setting: PushSetting;
    userId: Scalars['String'];
};

export type UserLead = {
    __typename: 'UserLead';
    leadId: Scalars['String'];
    leadName: Scalars['String'];
    value: Scalars['String'];
};

export type UserLeadCreateManyWithoutUserInput = {
    create: Array<UserLeadCreateWithoutUserInput>;
};

export type UserLeadCreateWithoutUserInput = {
    lead: LeadCreateOneWithoutUserLeadInput;
    value: Scalars['String'];
};

export type UserPremiumStatus = {
    __typename: 'UserPremiumStatus';
    createdAt: Scalars['DateTime'];
    profilePremiumStatusId: Scalars['String'];
    status: ProfileStatus;
    userId: Scalars['String'];
    validTo: Scalars['DateTime'];
};

export const UserRole = {
    Blocked: 'Blocked',
    Deleted: 'Deleted',
    Guest: 'Guest',
    Incomplete: 'Incomplete',
    Lead: 'Lead',
    Member: 'Member',
    Premium: 'Premium',
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];
export type UserUpdateInput = {
    deactivatedPushes?: Maybe<DeactivatedPushUpdateManyWithoutUserInput>;
    lastAction?: Maybe<Scalars['String']>;
    latitude?: Maybe<Scalars['String']>;
    longitude?: Maybe<Scalars['String']>;
    pushToken?: Maybe<Scalars['String']>;
    sendMarketingEmail?: Maybe<Scalars['Boolean']>;
    sendSms?: Maybe<Scalars['Boolean']>;
    sendTransactionalEmail?: Maybe<Scalars['Boolean']>;
    timezone?: Maybe<Scalars['String']>;
};

export type UserWhereUniqueInput = {
    userId?: Maybe<Scalars['String']>;
};

export type ValidateEmailInput = {
    /** Email */
    email: Scalars['String'];
};

export type ValidateMobileNumberInput = {
    /** MobileNumber E.164 format */
    mobileNumber: Scalars['String'];
};

/** Result for validate */
export type ValidateResult = ResultError | ValidateResultSuccess;

export type ValidateResultSuccess = {
    __typename: 'ValidateResultSuccess';
    success?: Maybe<Scalars['Boolean']>;
};

export type ValidateUsernameInput = {
    /** Username */
    username: Scalars['String'];
};

export type VerifyEmailInput = {
    hash: Scalars['String'];
};

export type Visit = {
    __typename: 'Visit';
    createdAt: Scalars['DateTime'];
    other: Profile;
    otherId: Scalars['String'];
    visitId: Scalars['String'];
};

export type VisitOrderByInput = {
    createdAt?: Maybe<SortOrder>;
    visitId?: Maybe<SortOrder>;
    visitorId?: Maybe<SortOrder>;
};

export type VisitProfileResult = {
    __typename: 'VisitProfileResult';
    other?: Maybe<Profile>;
    otherId?: Maybe<Scalars['String']>;
    success: Scalars['Boolean'];
};

export type VisitWhereInput = {
    AND?: Maybe<Array<Maybe<VisitWhereInput>>>;
    NOT?: Maybe<Array<Maybe<VisitWhereInput>>>;
    OR?: Maybe<Array<Maybe<VisitWhereInput>>>;
    createdAt?: Maybe<DateTimeFilter>;
    other?: Maybe<ProfileWhereInput>;
    otherId?: Maybe<StringFilter>;
    visitId?: Maybe<StringFilter>;
};

export type VisitWhereUniqueInput = {
    visitId: Scalars['String'];
};

export type Voting = {
    __typename: 'Voting';
    profile: Profile;
    profileId: Scalars['String'];
    votes?: Maybe<Scalars['Int']>;
    votingId: Scalars['String'];
};

export type VotingCreateInput = {
    profile: ProfileCreateOneWithoutVotingInput;
};

export type VotingOrderByInput = {
    profileId?: Maybe<SortOrder>;
    votes?: Maybe<SortOrder>;
    votingId?: Maybe<SortOrder>;
};

export type VotingWhereInput = {
    AND?: Maybe<Array<Maybe<VotingWhereInput>>>;
    NOT?: Maybe<Array<Maybe<VotingWhereInput>>>;
    OR?: Maybe<Array<Maybe<VotingWhereInput>>>;
    profile?: Maybe<ProfileWhereInput>;
    profileId?: Maybe<StringFilter>;
    votes?: Maybe<IntNullableFilter>;
    votingId?: Maybe<StringFilter>;
};

export type VotingWhereUniqueInput = {
    profileId?: Maybe<Scalars['String']>;
    votingId?: Maybe<Scalars['String']>;
};

export type AvatarFragment = {
    __typename: 'Avatar';
    avatarId: string;
    name?: Maybe<string>;
    path: string;
    translations: Array<{
        __typename: 'Translation';
        translation: string;
        translationId: string;
        avatarId?: Maybe<string>;
        languageCode: string;
    }>;
};

export type BatchPayloadFragment = {
    __typename: 'BatchPayload';
    count: number;
};

export type BlockedFragment = {
    __typename: 'Blocked';
    blockedId: string;
    otherId: string;
    createdAt: Date;
};

export type CoinsResultSuccessFragment = {
    __typename: 'CoinsResultSuccess';
    coins: number;
    spentCoins?: Maybe<number>;
    increasedCoins?: Maybe<number>;
};

export type ComplainTypeFragment = {
    __typename: 'ComplainType';
    complainTypeId: string;
    name: string;
};

export type ConversationFragment = {
    __typename: 'Conversation';
    conversationId: string;
    blind: boolean;
    free: boolean;
    lastMessageId?: Maybe<string>;
    lastAction?: Maybe<Date>;
    support: boolean;
};

export type ConversationProfileFragment = {
    __typename: 'ConversationProfile';
    conversationProfileId: string;
    conversationId: string;
    picturesSend: number;
    picturesUnread: number;
    messagesSend: number;
    messagesUnread: number;
    pokesSend: number;
    pokesUnread: number;
};

export type ConversationProfileAggregateFragment = {
    __typename: 'ConversationProfileAggregate';
    send: number;
    unread: number;
    freeMessages: number;
    messagesSend: number;
    pokesSend: number;
    giftsSend: number;
    picturesSend: number;
    messagesUnread: number;
    pokesUnread: number;
    giftsUnread: number;
};

export type CostFragment = {
    __typename: 'Cost';
    eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
    friendship: { __typename: 'CostNode'; cost: number };
    match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
    message: { __typename: 'MessageCost'; cost: number; length: number };
    poke: { __typename: 'PokeCost'; cost: number; free?: Maybe<number> };
    picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
};

export type DailySongFragment = {
    __typename: 'DailySong';
    name: string;
    dailySongId: string;
    path: string;
};

export type DeactivatedPushFragment = {
    __typename: 'DeactivatedPush';
    deactivatedPushId: string;
    setting: PushSetting;
};

export type ErrorFragment = {
    __typename: 'Error';
    errorCode: number;
    errorMessage: string;
};

export type FavoriteFragment = {
    __typename: 'Favorite';
    createdAt: Date;
    favoriteId: string;
    otherId: string;
};

export type FlagFragment = {
    __typename: 'Flag';
    flagId: string;
    max?: Maybe<number>;
    maxLength: number;
    min?: Maybe<number>;
    minLength: number;
    name: string;
    numberStep?: Maybe<string>;
    gender: FlagGender;
    regEx?: Maybe<string>;
    type: FlagType;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
    flagValues: Array<{
        __typename: 'FlagValue';
        flagId: string;
        flagValueId: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: Maybe<string>;
            giftId?: Maybe<string>;
            interestCategoryId?: Maybe<string>;
            interestId?: Maybe<string>;
            translationView: TranslationView;
        }>;
    }>;
};

export type FlagProfileFragment = {
    __typename: 'Flag';
    flagId: string;
    name: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
};

export type FlagValueFragment = {
    __typename: 'FlagValue';
    flagId: string;
    flagValueId: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
};

export type FriendshipFragment = {
    __typename: 'Friendship';
    friendshipId: string;
    otherId: string;
    status: FriendshipStatus;
    updatedAt: Date;
};

export type GeolocationFragment = {
    __typename: 'Geolocation';
    geolocationId: string;
    country: string;
    postcode: string;
    location: string;
    state?: Maybe<string>;
    province?: Maybe<string>;
    community?: Maybe<string>;
    latitude: string;
    longitude: string;
};

export type GiftFragment = {
    __typename: 'Gift';
    giftId: string;
    name: string;
    cost: number;
    path: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
};

export type GiftCategoryFragment = {
    __typename: 'GiftCategory';
    giftCategoryId: string;
    name: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
};

export type ImageFragment = {
    __typename: 'Image';
    imageId: string;
    profileId: string;
    path: string;
    main: boolean;
    private: boolean;
};

export type InterestFragment = {
    __typename: 'Interest';
    interestId: string;
    name: string;
    class?: Maybe<string>;
    path?: Maybe<string>;
    categoryId: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
};

export type InterestCategoryFragment = {
    __typename: 'InterestCategory';
    interestCategoryId: string;
    name: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
};

export type LanguageFragment = {
    __typename: 'Language';
    code: string;
    name: string;
};

export type LoginResultSuccessFragment = {
    __typename: 'LoginResultSuccess';
    userId: string;
    token: string;
    role: UserRole;
    coins: number;
};

export type MatchFragment = {
    __typename: 'Match';
    matchId: string;
    ownerId: string;
    playedAt?: Maybe<Date>;
    profileId: string;
    type: MatchType;
    profile: {
        __typename: 'Profile';
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        zodiacSign?: Maybe<string>;
        age: number;
        premiumStatus: Array<ProfileStatus>;
        images: Array<{
            __typename: 'Image';
            imageId: string;
            profileId: string;
            path: string;
            main: boolean;
            private: boolean;
        }>;
    };
};

export type MatchFilterFragment = {
    __typename: 'MatchFilter';
    matchFilterId: string;
    userId: string;
    updatedAt: Date;
    ageFrom: number;
    ageTo: number;
};

export type MessageFragment = {
    __typename: 'Message';
    senderId: string;
    text?: Maybe<string>;
    updatedAt: Date;
    coins: number;
    createdAt: Date;
    giftId?: Maybe<string>;
    messageId: string;
    model: MessageType;
    pictureId?: Maybe<string>;
    path?: Maybe<string>;
};

export type MyImageFragment = {
    __typename: 'Image';
    verified: boolean;
    userChanged: Date;
    imageId: string;
    profileId: string;
    path: string;
    main: boolean;
    private: boolean;
};

export type MyProfileFragment = {
    __typename: 'MyProfile';
    acceptPicture: boolean;
    country: string;
    county: string;
    flirtText: string;
    gender: Gender;
    languageCode: string;
    profileId: string;
    profileName: string;
    searches: Gender;
    shownLocation: string;
    themeName?: Maybe<string>;
    birthDate?: Maybe<string>;
    completed: boolean;
    zodiacSign?: Maybe<string>;
    premiumStatus: Array<ProfileStatus>;
};

export type NotificationFragment = {
    __typename: 'Notification';
    notificationId: string;
    target?: Maybe<string>;
    type: NotificationType;
    read: boolean;
    updatedAt: Date;
    createdAt: Date;
};

export type OfferFragment = {
    __typename: 'Offer';
    offerId: string;
    name: string;
    cost: number;
    coins: number;
    bonus: number;
    extra: string;
    currency: string;
    providerName: string;
    periodUnit: PeriodUnitOffer;
    profileStatus?: Maybe<ProfileStatus>;
    statusPeriod: number;
};

export type OptionPollFragment = {
    __typename: 'OptionPoll';
    optionPollId: string;
    name: string;
    text: string;
    position: number;
    languageCode: string;
};

export type OptionPollAnswerFragment = {
    __typename: 'OptionPollAnswer';
    optionPollAnswerId: string;
    text: string;
    optionPollId: string;
    languageCode: string;
    votes: string;
    path?: Maybe<string>;
};

export type PictureFragment = {
    __typename: 'Picture';
    pictureId: string;
    path: string;
    ownerId: string;
};

export type PredefinedMessageFragment = {
    __typename: 'PredefinedMessage';
    path?: Maybe<string>;
    predefinedMessageId: string;
    translations: Array<{
        __typename: 'Translation';
        translation: string;
        translationId: string;
        predefinedMessageId?: Maybe<string>;
        languageCode: string;
    }>;
};

export type ProfileFragment = {
    __typename: 'Profile';
    acceptPicture: boolean;
    country: string;
    county: string;
    flirtText: string;
    gender: Gender;
    languageCode: string;
    profileId: string;
    profileName: string;
    searches: Gender;
    shownLocation: string;
    zodiacSign?: Maybe<string>;
    age: number;
    premiumStatus: Array<ProfileStatus>;
};

export type ProfileFlagFragment = {
    __typename: 'ProfileFlag';
    profileFlagId: string;
    flagValueId?: Maybe<string>;
    value?: Maybe<string>;
    flag: {
        __typename: 'Flag';
        flagId: string;
        name: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: Maybe<string>;
            giftId?: Maybe<string>;
            interestCategoryId?: Maybe<string>;
            interestId?: Maybe<string>;
            translationView: TranslationView;
        }>;
    };
    flagValue?: Maybe<{
        __typename: 'FlagValue';
        flagId: string;
        flagValueId: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: Maybe<string>;
            giftId?: Maybe<string>;
            interestCategoryId?: Maybe<string>;
            interestId?: Maybe<string>;
            translationView: TranslationView;
        }>;
    }>;
};

export type ProfileInterestFragment = {
    __typename: 'ProfileInterest';
    profileInterestId: string;
    profileId: string;
    interestName: string;
};

export type ProfileOptionPollFragment = {
    __typename: 'ProfileOptionPoll';
    optionPollAnswerId: string;
    optionPollId: string;
    profileId: string;
    profileOptionPollId: string;
    createdAt: Date;
};

export type ProfileTextFragment = {
    __typename: 'ProfileText';
    profileTextId: string;
    translations: Array<{
        __typename: 'Translation';
        translationId: string;
        profileTextId?: Maybe<string>;
        languageCode: string;
        translation: string;
    }>;
};

export type ProviderFragment = {
    __typename: 'Provider';
    providerId: string;
    name: string;
    logo: string;
    title: string;
    description?: Maybe<string>;
    currency: string;
};

export type RegisterResultSuccessFragment = {
    __typename: 'RegisterResultSuccess';
    userId: string;
    token: string;
    role: UserRole;
    coins: number;
};

export type ResultErrorFragment = {
    __typename: 'ResultError';
    errors: Array<{
        __typename: 'Error';
        errorCode: number;
        errorMessage: string;
    }>;
};

export type ResultSuccessFragment = {
    __typename: 'ResultSuccess';
    success?: Maybe<boolean>;
};

export type SupportMessageFragment = {
    __typename: 'SupportMessage';
    supportMessageId: string;
    text: string;
    createdAt: Date;
    updatedAt: Date;
    sender: SupportMessageSender;
    supportTicketId: string;
    read: boolean;
};

export type SupportTicketFragment = {
    __typename: 'SupportTicket';
    supportTicketId: string;
    status: SupportTicketStatus;
    createdAt: Date;
    updatedAt: Date;
    category: SupportCategory;
    ticketNumber: number;
};

export type ThemeFragment = { __typename: 'Theme'; name: string };

export type ThemeImageFragment = {
    __typename: 'ThemeImage';
    label: string;
    path: string;
    themeImageId: string;
    themeName: string;
};

export type TransactionResultPendingFragment = {
    __typename: 'TransactionResultPending';
    redirectUrl?: Maybe<string>;
    transactionId: string;
    extTransactionId?: Maybe<string>;
    provider?: Maybe<string>;
    offer?: Maybe<{
        __typename: 'Offer';
        offerId: string;
        name: string;
        cost: number;
        coins: number;
        bonus: number;
        extra: string;
        currency: string;
        providerName: string;
        periodUnit: PeriodUnitOffer;
        profileStatus?: Maybe<ProfileStatus>;
        statusPeriod: number;
    }>;
    data?: Maybe<{
        __typename: 'BankData';
        iban: string;
        beneficiary: string;
        bic: string;
        bank?: Maybe<string>;
    }>;
};

export type TransactionResultSuccessFragment = {
    __typename: 'TransactionResultSuccess';
    transactionId: string;
    coins: {
        __typename: 'CoinsResultSuccess';
        coins: number;
        increasedCoins?: Maybe<number>;
    };
};

export type TranslationFragment = {
    __typename: 'Translation';
    translationId: string;
    translation: string;
    languageCode: string;
    giftCategoryId?: Maybe<string>;
    giftId?: Maybe<string>;
    interestCategoryId?: Maybe<string>;
    interestId?: Maybe<string>;
    translationView: TranslationView;
};

export type UserFragment = {
    __typename: 'User';
    role: string;
    username: string;
    sendMarketingEmail: boolean;
    sendTransactionalEmail: boolean;
    sendSMS: boolean;
    imageCompleted: boolean;
    flirtTextCompleted: boolean;
    profileFlagsCompleted: boolean;
    emailValidated: boolean;
    mobileNumberValidated: boolean;
    email?: Maybe<string>;
    mobileNumber?: Maybe<string>;
    deleteToken: string;
};

export type UserComplainFragment = {
    __typename: 'UserComplain';
    complainTypeName: string;
    name?: Maybe<string>;
    targetId: string;
    text?: Maybe<string>;
};

export type VisitFragment = {
    __typename: 'Visit';
    visitId: string;
    otherId: string;
    createdAt: Date;
};

export type DisableAllPushMutationVariables = Exact<{ [key: string]: never }>;

export type DisableAllPushMutation = {
    __typename: 'Mutation';
    activateAllDeactivatedPush: { __typename: 'BatchPayload'; count: number };
};

export type AddFavoriteMutationVariables = Exact<{
    a_Data: ProfileWhereUniqueInput;
}>;

export type AddFavoriteMutation = {
    __typename: 'Mutation';
    addFavorite?: Maybe<{
        __typename: 'Favorite';
        createdAt: Date;
        favoriteId: string;
        otherId: string;
    }>;
};

export type AddFriendMutationVariables = Exact<{
    a_Data: ProfileWhereUniqueInput;
}>;

export type AddFriendMutation = {
    __typename: 'Mutation';
    addFriendship?: Maybe<
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: Maybe<number>;
              increasedCoins?: Maybe<number>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
    >;
};

export type BlockProfileMutationVariables = Exact<{
    b_Data: BlockProfileInput;
}>;

export type BlockProfileMutation = {
    __typename: 'Mutation';
    blockProfile?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type BuyMoreMatchesMutationVariables = Exact<{ [key: string]: never }>;

export type BuyMoreMatchesMutation = {
    __typename: 'Mutation';
    buyMoreMatches:
        | { __typename: 'Error'; errorCode: number; errorMessage: string }
        | {
              __typename: 'NextMatchResultSuccess';
              matches: Array<{
                  __typename: 'Match';
                  matchId: string;
                  ownerId: string;
                  playedAt?: Maybe<Date>;
                  profileId: string;
                  type: MatchType;
                  profile: {
                      __typename: 'Profile';
                      acceptPicture: boolean;
                      country: string;
                      county: string;
                      flirtText: string;
                      gender: Gender;
                      languageCode: string;
                      profileId: string;
                      profileName: string;
                      searches: Gender;
                      shownLocation: string;
                      zodiacSign?: Maybe<string>;
                      age: number;
                      premiumStatus: Array<ProfileStatus>;
                      images: Array<{
                          __typename: 'Image';
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>;
                  };
              }>;
          };
};

export type ChangePushMutationVariables = Exact<{
    c_Data: DeactivatedPushChangeInput;
}>;

export type ChangePushMutation = {
    __typename: 'Mutation';
    changeOneDeactivatedPush: {
        __typename: 'DeactivatedPush';
        deactivatedPushId: string;
        setting: PushSetting;
    };
};

export type ChangeFriendshipMutationVariables = Exact<{
    c_Data: ChangeFriendshipInput;
}>;

export type ChangeFriendshipMutation = {
    __typename: 'Mutation';
    changeStatusFriendship?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type ContactSupportMutationVariables = Exact<{
    c_Data: ContactSupportInput;
}>;

export type ContactSupportMutation = {
    __typename: 'Mutation';
    contactSupport: { __typename: 'ResultSuccess'; success?: Maybe<boolean> };
};

export type TransactionMutationVariables = Exact<{
    t_Data: TransactionInput;
}>;

export type TransactionMutation = {
    __typename: 'Mutation';
    createTransaction?: Maybe<
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | {
              __typename: 'TransactionResultPending';
              redirectUrl?: Maybe<string>;
              transactionId: string;
              extTransactionId?: Maybe<string>;
              provider?: Maybe<string>;
              offer?: Maybe<{
                  __typename: 'Offer';
                  offerId: string;
                  name: string;
                  cost: number;
                  coins: number;
                  bonus: number;
                  extra: string;
                  currency: string;
                  providerName: string;
                  periodUnit: PeriodUnitOffer;
                  profileStatus?: Maybe<ProfileStatus>;
                  statusPeriod: number;
              }>;
              data?: Maybe<{
                  __typename: 'BankData';
                  iban: string;
                  beneficiary: string;
                  bic: string;
                  bank?: Maybe<string>;
              }>;
          }
        | {
              __typename: 'TransactionResultSuccess';
              transactionId: string;
              coins: {
                  __typename: 'CoinsResultSuccess';
                  coins: number;
                  increasedCoins?: Maybe<number>;
              };
          }
    >;
};

export type DeleteAccountMutationVariables = Exact<{
    d_Data: DeleteAccountInput;
}>;

export type DeleteAccountMutation = {
    __typename: 'Mutation';
    deleteAccount:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ResultSuccess'; success?: Maybe<boolean> };
};

export type EnableAllPushMutationVariables = Exact<{ [key: string]: never }>;

export type EnableAllPushMutation = {
    __typename: 'Mutation';
    deleteAllDeactivatedPush: { __typename: 'BatchPayload'; count: number };
};

export type DeleteGalleryImageMutationVariables = Exact<{
    d_Data: DeleteGalleryImageInput;
}>;

export type DeleteGalleryImageMutation = {
    __typename: 'Mutation';
    deleteGalleryImage?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type FacebookLoginMutationVariables = Exact<{
    f_Data: SocialLoginInput;
    withF_DeactivatedPushes?: Maybe<Scalars['Boolean']>;
    withF_Cost?: Maybe<Scalars['Boolean']>;
    withF_FreePokes?: Maybe<Scalars['Boolean']>;
    withF_M_Age?: Maybe<Scalars['Boolean']>;
    withF_M_FurtherInformation?: Maybe<Scalars['Boolean']>;
    withF_M_Images?: Maybe<Scalars['Boolean']>;
    withF_M_Avatar?: Maybe<Scalars['Boolean']>;
    withF_M_User?: Maybe<Scalars['Boolean']>;
    withF_M_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withF_M_P_Interest?: Maybe<Scalars['Boolean']>;
    withF_User?: Maybe<Scalars['Boolean']>;
    f_M_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    f_M_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    f_M_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    f_M_ImagesSkip?: Maybe<Scalars['Int']>;
    f_M_ImagesTake?: Maybe<Scalars['Int']>;
    f_M_ImagesWhere?: Maybe<ImageWhereInput>;
    withF_M_Theme?: Maybe<Scalars['Boolean']>;
    withF_M_T_Images?: Maybe<Scalars['Boolean']>;
    f_M_T_ImagesWhere?: Maybe<ThemeImageWhereInput>;
    withF_M_ProfileFlags?: Maybe<Scalars['Boolean']>;
}>;

export type FacebookLoginMutation = {
    __typename: 'Mutation';
    facebookLogin:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: Maybe<number>;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Maybe<
                  Array<
                      Maybe<{
                          __typename: 'DeactivatedPush';
                          deactivatedPushId: string;
                          setting: PushSetting;
                      }>
                  >
              >;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: Maybe<string>;
                  avatarPath?: Maybe<string>;
                  age?: Maybe<number>;
                  furtherInformation?: Maybe<string>;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: Maybe<string>;
                  birthDate?: Maybe<string>;
                  completed: boolean;
                  zodiacSign?: Maybe<string>;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Maybe<
                      Array<{
                          __typename: 'ProfileFlag';
                          profileFlagId: string;
                          flagValueId?: Maybe<string>;
                          value?: Maybe<string>;
                          flag: {
                              __typename: 'Flag';
                              flagId: string;
                              name: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          };
                          flagValue?: Maybe<{
                              __typename: 'FlagValue';
                              flagId: string;
                              flagValueId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  avatar?: Maybe<{
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: Maybe<string>;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: Maybe<string>;
                          languageCode: string;
                      }>;
                  }>;
                  user?: Maybe<{
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: Maybe<string>;
                      mobileNumber?: Maybe<string>;
                      deleteToken: string;
                  }>;
                  images?: Maybe<
                      Array<{
                          __typename: 'Image';
                          verified: boolean;
                          userChanged: Date;
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>
                  >;
                  profileInterests?: Maybe<
                      Array<{
                          __typename: 'ProfileInterest';
                          profileInterestId: string;
                          profileId: string;
                          interestName: string;
                          interest?: Maybe<{
                              __typename: 'Interest';
                              interestId: string;
                              name: string;
                              class?: Maybe<string>;
                              path?: Maybe<string>;
                              categoryId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  theme?: Maybe<{
                      __typename: 'Theme';
                      name: string;
                      images?: Maybe<
                          Array<{
                              __typename: 'ThemeImage';
                              label: string;
                              path: string;
                              themeImageId: string;
                              themeName: string;
                          }>
                      >;
                  }>;
              };
              cost?: Maybe<{
                  __typename: 'Cost';
                  eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: Maybe<number>;
                  };
                  picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
              }>;
              user?: Maybe<{
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: Maybe<string>;
                  mobileNumber?: Maybe<string>;
                  deleteToken: string;
              }>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          };
};

export type ForgottenPasswordMutationVariables = Exact<{
    f_Email?: Maybe<Scalars['String']>;
    f_Username?: Maybe<Scalars['String']>;
}>;

export type ForgottenPasswordMutation = {
    __typename: 'Mutation';
    forgottenPassword: {
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    };
};

export type GoogleLoginMutationVariables = Exact<{
    g_Data: SocialLoginInput;
    withG_DeactivatedPushes?: Maybe<Scalars['Boolean']>;
    withG_Cost?: Maybe<Scalars['Boolean']>;
    withG_FreePokes?: Maybe<Scalars['Boolean']>;
    withG_M_Age?: Maybe<Scalars['Boolean']>;
    withG_M_FurtherInformation?: Maybe<Scalars['Boolean']>;
    withG_M_Images?: Maybe<Scalars['Boolean']>;
    withG_M_Avatar?: Maybe<Scalars['Boolean']>;
    withG_M_User?: Maybe<Scalars['Boolean']>;
    withG_M_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withG_M_P_Interest?: Maybe<Scalars['Boolean']>;
    withG_User?: Maybe<Scalars['Boolean']>;
    g_M_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    g_M_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    g_M_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    g_M_ImagesSkip?: Maybe<Scalars['Int']>;
    g_M_ImagesTake?: Maybe<Scalars['Int']>;
    g_M_ImagesWhere?: Maybe<ImageWhereInput>;
    withG_M_Theme?: Maybe<Scalars['Boolean']>;
    withG_M_T_Images?: Maybe<Scalars['Boolean']>;
    g_M_T_ImagesWhere?: Maybe<ThemeImageWhereInput>;
    withG_M_ProfileFlags?: Maybe<Scalars['Boolean']>;
}>;

export type GoogleLoginMutation = {
    __typename: 'Mutation';
    googleLogin:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: Maybe<number>;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Maybe<
                  Array<
                      Maybe<{
                          __typename: 'DeactivatedPush';
                          deactivatedPushId: string;
                          setting: PushSetting;
                      }>
                  >
              >;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: Maybe<string>;
                  avatarPath?: Maybe<string>;
                  age?: Maybe<number>;
                  furtherInformation?: Maybe<string>;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: Maybe<string>;
                  birthDate?: Maybe<string>;
                  completed: boolean;
                  zodiacSign?: Maybe<string>;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Maybe<
                      Array<{
                          __typename: 'ProfileFlag';
                          profileFlagId: string;
                          flagValueId?: Maybe<string>;
                          value?: Maybe<string>;
                          flag: {
                              __typename: 'Flag';
                              flagId: string;
                              name: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          };
                          flagValue?: Maybe<{
                              __typename: 'FlagValue';
                              flagId: string;
                              flagValueId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  avatar?: Maybe<{
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: Maybe<string>;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: Maybe<string>;
                          languageCode: string;
                      }>;
                  }>;
                  user?: Maybe<{
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: Maybe<string>;
                      mobileNumber?: Maybe<string>;
                      deleteToken: string;
                  }>;
                  images?: Maybe<
                      Array<{
                          __typename: 'Image';
                          verified: boolean;
                          userChanged: Date;
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>
                  >;
                  profileInterests?: Maybe<
                      Array<{
                          __typename: 'ProfileInterest';
                          profileInterestId: string;
                          profileId: string;
                          interestName: string;
                          interest?: Maybe<{
                              __typename: 'Interest';
                              interestId: string;
                              name: string;
                              class?: Maybe<string>;
                              path?: Maybe<string>;
                              categoryId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  theme?: Maybe<{
                      __typename: 'Theme';
                      name: string;
                      images?: Maybe<
                          Array<{
                              __typename: 'ThemeImage';
                              label: string;
                              path: string;
                              themeImageId: string;
                              themeName: string;
                          }>
                      >;
                  }>;
              };
              cost?: Maybe<{
                  __typename: 'Cost';
                  eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: Maybe<number>;
                  };
                  picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
              }>;
              user?: Maybe<{
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: Maybe<string>;
                  mobileNumber?: Maybe<string>;
                  deleteToken: string;
              }>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          };
};

export type HideConversationMutationVariables = Exact<{
    r_ConversationId: Scalars['String'];
    r_Hide?: Maybe<Scalars['Boolean']>;
}>;

export type HideConversationMutation = {
    __typename: 'Mutation';
    hideConversation?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type LikeProfileMutationVariables = Exact<{
    l_Data: LikeProfileInput;
}>;

export type LikeProfileMutation = {
    __typename: 'Mutation';
    likeProfile?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type LoginMutationVariables = Exact<{
    l_Username: Scalars['String'];
    l_Password: Scalars['String'];
    l_Timezone?: Maybe<Scalars['String']>;
    withL_DeactivatedPushes?: Maybe<Scalars['Boolean']>;
    withL_Cost?: Maybe<Scalars['Boolean']>;
    withL_FreePokes?: Maybe<Scalars['Boolean']>;
    withL_M_Age?: Maybe<Scalars['Boolean']>;
    withL_M_FurtherInformation?: Maybe<Scalars['Boolean']>;
    withL_M_Images?: Maybe<Scalars['Boolean']>;
    withL_User?: Maybe<Scalars['Boolean']>;
    l_M_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    l_M_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    l_M_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    l_M_ImagesSkip?: Maybe<Scalars['Int']>;
    l_M_ImagesTake?: Maybe<Scalars['Int']>;
    l_M_ImagesWhere?: Maybe<ImageWhereInput>;
    withL_M_Theme?: Maybe<Scalars['Boolean']>;
    withL_M_T_Images?: Maybe<Scalars['Boolean']>;
    l_M_T_ImagesWhere?: Maybe<ThemeImageWhereInput>;
    withL_M_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withL_M_P_Interest?: Maybe<Scalars['Boolean']>;
    withL_M_User?: Maybe<Scalars['Boolean']>;
    withL_M_Avatar?: Maybe<Scalars['Boolean']>;
    withL_M_ProfileFlags?: Maybe<Scalars['Boolean']>;
}>;

export type LoginMutation = {
    __typename: 'Mutation';
    login:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: Maybe<number>;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Maybe<
                  Array<
                      Maybe<{
                          __typename: 'DeactivatedPush';
                          deactivatedPushId: string;
                          setting: PushSetting;
                      }>
                  >
              >;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: Maybe<string>;
                  avatarPath?: Maybe<string>;
                  age?: Maybe<number>;
                  furtherInformation?: Maybe<string>;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: Maybe<string>;
                  birthDate?: Maybe<string>;
                  completed: boolean;
                  zodiacSign?: Maybe<string>;
                  premiumStatus: Array<ProfileStatus>;
                  avatar?: Maybe<{
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: Maybe<string>;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: Maybe<string>;
                          languageCode: string;
                      }>;
                  }>;
                  user?: Maybe<{
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: Maybe<string>;
                      mobileNumber?: Maybe<string>;
                      deleteToken: string;
                  }>;
                  images?: Maybe<
                      Array<{
                          __typename: 'Image';
                          verified: boolean;
                          userChanged: Date;
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>
                  >;
                  profileInterests?: Maybe<
                      Array<{
                          __typename: 'ProfileInterest';
                          profileInterestId: string;
                          profileId: string;
                          interestName: string;
                          interest?: Maybe<{
                              __typename: 'Interest';
                              interestId: string;
                              name: string;
                              class?: Maybe<string>;
                              path?: Maybe<string>;
                              categoryId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  profileFlags?: Maybe<
                      Array<{
                          __typename: 'ProfileFlag';
                          profileFlagId: string;
                          flagValueId?: Maybe<string>;
                          value?: Maybe<string>;
                          flag: {
                              __typename: 'Flag';
                              flagId: string;
                              name: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          };
                          flagValue?: Maybe<{
                              __typename: 'FlagValue';
                              flagId: string;
                              flagValueId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  theme?: Maybe<{
                      __typename: 'Theme';
                      name: string;
                      images?: Maybe<
                          Array<{
                              __typename: 'ThemeImage';
                              label: string;
                              path: string;
                              themeImageId: string;
                              themeName: string;
                          }>
                      >;
                  }>;
              };
              cost?: Maybe<{
                  __typename: 'Cost';
                  eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: Maybe<number>;
                  };
                  picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
              }>;
              user?: Maybe<{
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: Maybe<string>;
                  mobileNumber?: Maybe<string>;
                  deleteToken: string;
              }>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          };
};

export type LoginByMd5MutationVariables = Exact<{
    l_Data: LoginMd5Input;
    withL_DeactivatedPushes?: Maybe<Scalars['Boolean']>;
    withL_Cost?: Maybe<Scalars['Boolean']>;
    withL_FreePokes?: Maybe<Scalars['Boolean']>;
    withL_M_Age?: Maybe<Scalars['Boolean']>;
    withL_M_FurtherInformation?: Maybe<Scalars['Boolean']>;
    withL_M_Images?: Maybe<Scalars['Boolean']>;
    withL_User?: Maybe<Scalars['Boolean']>;
    l_M_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    l_M_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    l_M_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    l_M_ImagesSkip?: Maybe<Scalars['Int']>;
    l_M_ImagesTake?: Maybe<Scalars['Int']>;
    l_M_ImagesWhere?: Maybe<ImageWhereInput>;
    withL_M_Theme?: Maybe<Scalars['Boolean']>;
    withL_M_T_Images?: Maybe<Scalars['Boolean']>;
    l_M_T_ImagesWhere?: Maybe<ThemeImageWhereInput>;
    withL_M_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withL_M_P_Interest?: Maybe<Scalars['Boolean']>;
    withL_M_User?: Maybe<Scalars['Boolean']>;
    withL_M_Avatar?: Maybe<Scalars['Boolean']>;
    withL_M_ProfileFlags?: Maybe<Scalars['Boolean']>;
}>;

export type LoginByMd5Mutation = {
    __typename: 'Mutation';
    loginByMD5:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: Maybe<number>;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Maybe<
                  Array<
                      Maybe<{
                          __typename: 'DeactivatedPush';
                          deactivatedPushId: string;
                          setting: PushSetting;
                      }>
                  >
              >;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: Maybe<string>;
                  avatarPath?: Maybe<string>;
                  age?: Maybe<number>;
                  furtherInformation?: Maybe<string>;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: Maybe<string>;
                  birthDate?: Maybe<string>;
                  completed: boolean;
                  zodiacSign?: Maybe<string>;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Maybe<
                      Array<{
                          __typename: 'ProfileFlag';
                          profileFlagId: string;
                          flagValueId?: Maybe<string>;
                          value?: Maybe<string>;
                          flag: {
                              __typename: 'Flag';
                              flagId: string;
                              name: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          };
                          flagValue?: Maybe<{
                              __typename: 'FlagValue';
                              flagId: string;
                              flagValueId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  avatar?: Maybe<{
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: Maybe<string>;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: Maybe<string>;
                          languageCode: string;
                      }>;
                  }>;
                  user?: Maybe<{
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: Maybe<string>;
                      mobileNumber?: Maybe<string>;
                      deleteToken: string;
                  }>;
                  images?: Maybe<
                      Array<{
                          __typename: 'Image';
                          verified: boolean;
                          userChanged: Date;
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>
                  >;
                  profileInterests?: Maybe<
                      Array<{
                          __typename: 'ProfileInterest';
                          profileInterestId: string;
                          profileId: string;
                          interestName: string;
                          interest?: Maybe<{
                              __typename: 'Interest';
                              interestId: string;
                              name: string;
                              class?: Maybe<string>;
                              path?: Maybe<string>;
                              categoryId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  theme?: Maybe<{
                      __typename: 'Theme';
                      name: string;
                      images?: Maybe<
                          Array<{
                              __typename: 'ThemeImage';
                              label: string;
                              path: string;
                              themeImageId: string;
                              themeName: string;
                          }>
                      >;
                  }>;
              };
              cost?: Maybe<{
                  __typename: 'Cost';
                  eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: Maybe<number>;
                  };
                  picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
              }>;
              user?: Maybe<{
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: Maybe<string>;
                  mobileNumber?: Maybe<string>;
                  deleteToken: string;
              }>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          };
};

export type LoginByTokenMutationVariables = Exact<{
    l_Token: Scalars['String'];
    l_Timezone: Scalars['String'];
    withL_DeactivatedPushes?: Maybe<Scalars['Boolean']>;
    withL_Cost?: Maybe<Scalars['Boolean']>;
    withL_FreePokes?: Maybe<Scalars['Boolean']>;
    withL_M_Age?: Maybe<Scalars['Boolean']>;
    withL_M_FurtherInformation?: Maybe<Scalars['Boolean']>;
    withL_M_Images?: Maybe<Scalars['Boolean']>;
    withL_User?: Maybe<Scalars['Boolean']>;
    l_M_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    l_M_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    l_M_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    l_M_ImagesSkip?: Maybe<Scalars['Int']>;
    l_M_ImagesTake?: Maybe<Scalars['Int']>;
    l_M_ImagesWhere?: Maybe<ImageWhereInput>;
    withL_M_Theme?: Maybe<Scalars['Boolean']>;
    withL_M_T_Images?: Maybe<Scalars['Boolean']>;
    l_M_T_ImagesWhere?: Maybe<ThemeImageWhereInput>;
    withL_M_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withL_M_P_Interest?: Maybe<Scalars['Boolean']>;
    withL_M_User?: Maybe<Scalars['Boolean']>;
    withL_M_Avatar?: Maybe<Scalars['Boolean']>;
    withL_M_ProfileFlags?: Maybe<Scalars['Boolean']>;
}>;

export type LoginByTokenMutation = {
    __typename: 'Mutation';
    loginByToken:
        | {
              __typename: 'LoginResultSuccess';
              freePokes?: Maybe<number>;
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              deactivatedPushes?: Maybe<
                  Array<
                      Maybe<{
                          __typename: 'DeactivatedPush';
                          deactivatedPushId: string;
                          setting: PushSetting;
                      }>
                  >
              >;
              myProfile: {
                  __typename: 'MyProfile';
                  defaultText?: Maybe<string>;
                  avatarPath?: Maybe<string>;
                  age?: Maybe<number>;
                  furtherInformation?: Maybe<string>;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: Maybe<string>;
                  birthDate?: Maybe<string>;
                  completed: boolean;
                  zodiacSign?: Maybe<string>;
                  premiumStatus: Array<ProfileStatus>;
                  profileFlags?: Maybe<
                      Array<{
                          __typename: 'ProfileFlag';
                          profileFlagId: string;
                          flagValueId?: Maybe<string>;
                          value?: Maybe<string>;
                          flag: {
                              __typename: 'Flag';
                              flagId: string;
                              name: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          };
                          flagValue?: Maybe<{
                              __typename: 'FlagValue';
                              flagId: string;
                              flagValueId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  avatar?: Maybe<{
                      __typename: 'Avatar';
                      avatarId: string;
                      name?: Maybe<string>;
                      path: string;
                      translations: Array<{
                          __typename: 'Translation';
                          translation: string;
                          translationId: string;
                          avatarId?: Maybe<string>;
                          languageCode: string;
                      }>;
                  }>;
                  user?: Maybe<{
                      __typename: 'User';
                      role: string;
                      username: string;
                      sendMarketingEmail: boolean;
                      sendTransactionalEmail: boolean;
                      sendSMS: boolean;
                      imageCompleted: boolean;
                      flirtTextCompleted: boolean;
                      profileFlagsCompleted: boolean;
                      emailValidated: boolean;
                      mobileNumberValidated: boolean;
                      email?: Maybe<string>;
                      mobileNumber?: Maybe<string>;
                      deleteToken: string;
                  }>;
                  images?: Maybe<
                      Array<{
                          __typename: 'Image';
                          verified: boolean;
                          userChanged: Date;
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>
                  >;
                  profileInterests?: Maybe<
                      Array<{
                          __typename: 'ProfileInterest';
                          profileInterestId: string;
                          profileId: string;
                          interestName: string;
                          interest?: Maybe<{
                              __typename: 'Interest';
                              interestId: string;
                              name: string;
                              class?: Maybe<string>;
                              path?: Maybe<string>;
                              categoryId: string;
                              translations: Array<{
                                  __typename: 'Translation';
                                  translationId: string;
                                  translation: string;
                                  languageCode: string;
                                  giftCategoryId?: Maybe<string>;
                                  giftId?: Maybe<string>;
                                  interestCategoryId?: Maybe<string>;
                                  interestId?: Maybe<string>;
                                  translationView: TranslationView;
                              }>;
                          }>;
                      }>
                  >;
                  theme?: Maybe<{
                      __typename: 'Theme';
                      name: string;
                      images?: Maybe<
                          Array<{
                              __typename: 'ThemeImage';
                              label: string;
                              path: string;
                              themeImageId: string;
                              themeName: string;
                          }>
                      >;
                  }>;
              };
              cost?: Maybe<{
                  __typename: 'Cost';
                  eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  friendship: { __typename: 'CostNode'; cost: number };
                  match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
                  message: {
                      __typename: 'MessageCost';
                      cost: number;
                      length: number;
                  };
                  poke: {
                      __typename: 'PokeCost';
                      cost: number;
                      free?: Maybe<number>;
                  };
                  picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
              }>;
              user?: Maybe<{
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: Maybe<string>;
                  mobileNumber?: Maybe<string>;
                  deleteToken: string;
              }>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          };
};

export type ChangeMatchFilterMutationVariables = Exact<{
    c_Data: MatchFilterUpdateInput;
}>;

export type ChangeMatchFilterMutation = {
    __typename: 'Mutation';
    changeMatchFilter:
        | { __typename: 'Error'; errorCode: number; errorMessage: string }
        | {
              __typename: 'MatchFilter';
              matchFilterId: string;
              userId: string;
              updatedAt: Date;
              ageFrom: number;
              ageTo: number;
          };
};

export type MobileNumberValidationMutationVariables = Exact<{
    m_Data: MobileNumberValidationInput;
}>;

export type MobileNumberValidationMutation = {
    __typename: 'Mutation';
    mobileNumberValidation:
        | { __typename: 'Error' }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ResultSuccess'; success?: Maybe<boolean> };
};

export type OptionPollAnswerMutationVariables = Exact<{
    o_Data: OptionPollAnswerInput;
}>;

export type OptionPollAnswerMutation = {
    __typename: 'Mutation';
    optionPollAnswer?: Maybe<{
        __typename: 'ProfileOptionPoll';
        optionPollAnswerId: string;
        optionPollId: string;
        profileId: string;
        profileOptionPollId: string;
        createdAt: Date;
    }>;
};

export type ReadConversationMutationVariables = Exact<{
    r_ConversationId: Scalars['String'];
}>;

export type ReadConversationMutation = {
    __typename: 'Mutation';
    readConversation?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type ReadNotificationsMutationVariables = Exact<{
    r_Where: Array<NotificationWhereUniqueInput> | NotificationWhereUniqueInput;
}>;

export type ReadNotificationsMutation = {
    __typename: 'Mutation';
    readManyNotification?: Maybe<{ __typename: 'BatchPayload'; count: number }>;
};

export type ReadSupportMessageMutationVariables = Exact<{
    r_Where: SupportMessageWhereUniqueInput;
    withR_SupportTicket?: Maybe<Scalars['Boolean']>;
}>;

export type ReadSupportMessageMutation = {
    __typename: 'Mutation';
    readSupportMessage: {
        __typename: 'SupportMessage';
        supportMessageId: string;
        text: string;
        createdAt: Date;
        updatedAt: Date;
        sender: SupportMessageSender;
        supportTicketId: string;
        read: boolean;
        supportTicket?: Maybe<{
            __typename: 'SupportTicket';
            supportTicketId: string;
            status: SupportTicketStatus;
            createdAt: Date;
            updatedAt: Date;
            category: SupportCategory;
            ticketNumber: number;
        }>;
    };
};

export type RedeemCouponMutationVariables = Exact<{
    r_Data: CouponWhereUniqueInput;
}>;

export type RedeemCouponMutation = {
    __typename: 'Mutation';
    redeemCoupon?: Maybe<
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: Maybe<number>;
              increasedCoins?: Maybe<number>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
    >;
};

export type RegisterMutationVariables = Exact<{
    r_Data: RegisterInput;
    withR_M_Age?: Maybe<Scalars['Boolean']>;
    withR_M_FurtherInformation?: Maybe<Scalars['Boolean']>;
}>;

export type RegisterMutation = {
    __typename: 'Mutation';
    register:
        | {
              __typename: 'RegisterResultSuccess';
              userId: string;
              token: string;
              role: UserRole;
              coins: number;
              myProfile: {
                  __typename: 'MyProfile';
                  age?: Maybe<number>;
                  furtherInformation?: Maybe<string>;
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  themeName?: Maybe<string>;
                  birthDate?: Maybe<string>;
                  completed: boolean;
                  zodiacSign?: Maybe<string>;
                  premiumStatus: Array<ProfileStatus>;
              };
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          };
};

export type RemoveFavoriteMutationVariables = Exact<{
    r_Data: FavoriteWhereUniqueInput;
}>;

export type RemoveFavoriteMutation = {
    __typename: 'Mutation';
    removeFavorite?: Maybe<{
        __typename: 'Favorite';
        createdAt: Date;
        favoriteId: string;
        otherId: string;
    }>;
};

export type RemoveFriendMutationVariables = Exact<{
    r_Data: RemoveFriendshipInput;
}>;

export type RemoveFriendMutation = {
    __typename: 'Mutation';
    removeFriendship?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type ResetPasswordMutationVariables = Exact<{
    r_Data: ResetPasswordInput;
}>;

export type ResetPasswordMutation = {
    __typename: 'Mutation';
    resetPassword:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ResultSuccess'; success?: Maybe<boolean> };
};

export type SendGiftMutationVariables = Exact<{
    s_Data: GiftInput;
}>;

export type SendGiftMutation = {
    __typename: 'Mutation';
    sendGift?: Maybe<
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: Maybe<number>;
              increasedCoins?: Maybe<number>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
    >;
};

export type SendMatchMutationVariables = Exact<{
    s_Where: MatchWhereUniqueInput;
    s_Type: MatchType;
}>;

export type SendMatchMutation = {
    __typename: 'Mutation';
    sendMatch:
        | { __typename: 'Error'; errorCode: number; errorMessage: string }
        | {
              __typename: 'Match';
              matchId: string;
              ownerId: string;
              playedAt?: Maybe<Date>;
              profileId: string;
              type: MatchType;
              profile: {
                  __typename: 'Profile';
                  acceptPicture: boolean;
                  country: string;
                  county: string;
                  flirtText: string;
                  gender: Gender;
                  languageCode: string;
                  profileId: string;
                  profileName: string;
                  searches: Gender;
                  shownLocation: string;
                  zodiacSign?: Maybe<string>;
                  age: number;
                  premiumStatus: Array<ProfileStatus>;
                  images: Array<{
                      __typename: 'Image';
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>;
              };
          };
};

export type SendMessageMutationVariables = Exact<{
    s_Data: MessageInput;
}>;

export type SendMessageMutation = {
    __typename: 'Mutation';
    sendMessage?: Maybe<
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: Maybe<number>;
              increasedCoins?: Maybe<number>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
    >;
};

export type SendPictureMutationVariables = Exact<{
    s_Data: PictureInput;
}>;

export type SendPictureMutation = {
    __typename: 'Mutation';
    sendPicture?: Maybe<
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: Maybe<number>;
              increasedCoins?: Maybe<number>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
    >;
};

export type SendPokeMutationVariables = Exact<{
    s_Data: PokeInput;
}>;

export type SendPokeMutation = {
    __typename: 'Mutation';
    sendPoke?: Maybe<
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: Maybe<number>;
              increasedCoins?: Maybe<number>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
    >;
};

export type SendPredefinedMessageMutationVariables = Exact<{
    s_Data: PredefinedMessageInput;
}>;

export type SendPredefinedMessageMutation = {
    __typename: 'Mutation';
    sendPredefinedMessage:
        | {
              __typename: 'CoinsResultSuccess';
              coins: number;
              spentCoins?: Maybe<number>;
              increasedCoins?: Maybe<number>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          };
};

export type SendSupportMessageMutationVariables = Exact<{
    s_Data: SupportMessageCreateInput;
    withS_SupportTicket?: Maybe<Scalars['Boolean']>;
}>;

export type SendSupportMessageMutation = {
    __typename: 'Mutation';
    sendSupportMessage: {
        __typename: 'SupportMessage';
        supportMessageId: string;
        text: string;
        createdAt: Date;
        updatedAt: Date;
        sender: SupportMessageSender;
        supportTicketId: string;
        read: boolean;
        supportTicket?: Maybe<{
            __typename: 'SupportTicket';
            supportTicketId: string;
            status: SupportTicketStatus;
            createdAt: Date;
            updatedAt: Date;
            category: SupportCategory;
            ticketNumber: number;
        }>;
    };
};

export type UnblockProfileMutationVariables = Exact<{
    u_Data: MyBlockedWhereUniqueInput;
}>;

export type UnblockProfileMutation = {
    __typename: 'Mutation';
    unblockProfile?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type UpdateEmailMutationVariables = Exact<{
    u_Data: ValidateEmailInput;
}>;

export type UpdateEmailMutation = {
    __typename: 'Mutation';
    updateEmail:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: Maybe<boolean> };
};

export type UpdateGalleryImageMutationVariables = Exact<{
    u_Data: UpdateGalleryImageInput;
}>;

export type UpdateGalleryImageMutation = {
    __typename: 'Mutation';
    updateGalleryImage?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type UpdateMobileNumberMutationVariables = Exact<{
    u_Data: ValidateMobileNumberInput;
}>;

export type UpdateMobileNumberMutation = {
    __typename: 'Mutation';
    updateMobileNumber:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: Maybe<boolean> };
};

export type UpdateMyProfileMutationVariables = Exact<{
    u_Data: UpdateMyProfileInput;
    withU_M_User?: Maybe<Scalars['Boolean']>;
    withU_M_Age?: Maybe<Scalars['Boolean']>;
    withU_M_FurtherInformation?: Maybe<Scalars['Boolean']>;
    withU_M_Images?: Maybe<Scalars['Boolean']>;
    withU_M_ProfileFlags?: Maybe<Scalars['Boolean']>;
    withU_M_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withU_M_P_Interest?: Maybe<Scalars['Boolean']>;
    u_M_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    u_M_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    u_M_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    u_M_ImagesSkip?: Maybe<Scalars['Int']>;
    u_M_ImagesTake?: Maybe<Scalars['Int']>;
    u_M_ImagesWhere?: Maybe<ImageWhereInput>;
    withU_M_Theme?: Maybe<Scalars['Boolean']>;
    withU_M_T_Images?: Maybe<Scalars['Boolean']>;
    u_M_T_ImagesWhere?: Maybe<ThemeImageWhereInput>;
    withU_M_Avatar?: Maybe<Scalars['Boolean']>;
}>;

export type UpdateMyProfileMutation = {
    __typename: 'Mutation';
    updateMyProfile?: Maybe<
        | {
              __typename: 'MyProfile';
              defaultText?: Maybe<string>;
              avatarPath?: Maybe<string>;
              age?: Maybe<number>;
              furtherInformation?: Maybe<string>;
              acceptPicture: boolean;
              country: string;
              county: string;
              flirtText: string;
              gender: Gender;
              languageCode: string;
              profileId: string;
              profileName: string;
              searches: Gender;
              shownLocation: string;
              themeName?: Maybe<string>;
              birthDate?: Maybe<string>;
              completed: boolean;
              zodiacSign?: Maybe<string>;
              premiumStatus: Array<ProfileStatus>;
              avatar?: Maybe<{
                  __typename: 'Avatar';
                  avatarId: string;
                  name?: Maybe<string>;
                  path: string;
                  translations: Array<{
                      __typename: 'Translation';
                      translation: string;
                      translationId: string;
                      avatarId?: Maybe<string>;
                      languageCode: string;
                  }>;
              }>;
              user?: Maybe<{
                  __typename: 'User';
                  role: string;
                  username: string;
                  sendMarketingEmail: boolean;
                  sendTransactionalEmail: boolean;
                  sendSMS: boolean;
                  imageCompleted: boolean;
                  flirtTextCompleted: boolean;
                  profileFlagsCompleted: boolean;
                  emailValidated: boolean;
                  mobileNumberValidated: boolean;
                  email?: Maybe<string>;
                  mobileNumber?: Maybe<string>;
                  deleteToken: string;
              }>;
              images?: Maybe<
                  Array<{
                      __typename: 'Image';
                      verified: boolean;
                      userChanged: Date;
                      imageId: string;
                      profileId: string;
                      path: string;
                      main: boolean;
                      private: boolean;
                  }>
              >;
              profileFlags?: Maybe<
                  Array<{
                      __typename: 'ProfileFlag';
                      profileFlagId: string;
                      flagValueId?: Maybe<string>;
                      value?: Maybe<string>;
                      flag: {
                          __typename: 'Flag';
                          flagId: string;
                          name: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: Maybe<string>;
                              giftId?: Maybe<string>;
                              interestCategoryId?: Maybe<string>;
                              interestId?: Maybe<string>;
                              translationView: TranslationView;
                          }>;
                      };
                      flagValue?: Maybe<{
                          __typename: 'FlagValue';
                          flagId: string;
                          flagValueId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: Maybe<string>;
                              giftId?: Maybe<string>;
                              interestCategoryId?: Maybe<string>;
                              interestId?: Maybe<string>;
                              translationView: TranslationView;
                          }>;
                      }>;
                  }>
              >;
              profileInterests?: Maybe<
                  Array<{
                      __typename: 'ProfileInterest';
                      profileInterestId: string;
                      profileId: string;
                      interestName: string;
                      interest?: Maybe<{
                          __typename: 'Interest';
                          interestId: string;
                          name: string;
                          class?: Maybe<string>;
                          path?: Maybe<string>;
                          categoryId: string;
                          translations: Array<{
                              __typename: 'Translation';
                              translationId: string;
                              translation: string;
                              languageCode: string;
                              giftCategoryId?: Maybe<string>;
                              giftId?: Maybe<string>;
                              interestCategoryId?: Maybe<string>;
                              interestId?: Maybe<string>;
                              translationView: TranslationView;
                          }>;
                      }>;
                  }>
              >;
              theme?: Maybe<{
                  __typename: 'Theme';
                  name: string;
                  images?: Maybe<
                      Array<{
                          __typename: 'ThemeImage';
                          label: string;
                          path: string;
                          themeImageId: string;
                          themeName: string;
                      }>
                  >;
              }>;
          }
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
    >;
};

export type UpdateProfileImageMutationVariables = Exact<{
    u_Data: UpdateProfileImageInput;
}>;

export type UpdateProfileImageMutation = {
    __typename: 'Mutation';
    updateProfileImage?: Maybe<{
        __typename: 'ResultSuccess';
        success?: Maybe<boolean>;
    }>;
};

export type UpdateUserMutationVariables = Exact<{
    u_Data: UserUpdateInput;
}>;

export type UpdateUserMutation = {
    __typename: 'Mutation';
    updateOneUser: {
        __typename: 'User';
        role: string;
        username: string;
        sendMarketingEmail: boolean;
        sendTransactionalEmail: boolean;
        sendSMS: boolean;
        imageCompleted: boolean;
        flirtTextCompleted: boolean;
        profileFlagsCompleted: boolean;
        emailValidated: boolean;
        mobileNumberValidated: boolean;
        email?: Maybe<string>;
        mobileNumber?: Maybe<string>;
        deleteToken: string;
    };
};

export type UploadImageMutationVariables = Exact<{
    u_Data: UploadGalleryImageInput;
}>;

export type UploadImageMutation = {
    __typename: 'Mutation';
    uploadGalleryImage?: Maybe<{
        __typename: 'Image';
        imageId: string;
        profileId: string;
        path: string;
        main: boolean;
        private: boolean;
    }>;
};

export type UploadPictureMutationVariables = Exact<{
    u_Data: UploadPictureInput;
}>;

export type UploadPictureMutation = {
    __typename: 'Mutation';
    uploadPicture:
        | { __typename: 'Error'; errorCode: number; errorMessage: string }
        | {
              __typename: 'Picture';
              pictureId: string;
              path: string;
              ownerId: string;
          };
};

export type UserComplainMutationVariables = Exact<{
    u_Data: UserComplainCreateInput;
}>;

export type UserComplainMutation = {
    __typename: 'Mutation';
    createOneUserComplain: {
        __typename: 'UserComplain';
        complainTypeName: string;
        name?: Maybe<string>;
        targetId: string;
        text?: Maybe<string>;
    };
};

export type EmailMutationVariables = Exact<{
    e_Data: ValidateEmailInput;
}>;

export type EmailMutation = {
    __typename: 'Mutation';
    validateEmail:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: Maybe<boolean> };
};

export type ValidateMobileNumberMutationVariables = Exact<{
    v_Data: ValidateMobileNumberInput;
}>;

export type ValidateMobileNumberMutation = {
    __typename: 'Mutation';
    validateMobileNumber:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: Maybe<boolean> };
};

export type UsernameMutationVariables = Exact<{
    u_Data: ValidateUsernameInput;
}>;

export type UsernameMutation = {
    __typename: 'Mutation';
    validateUsername:
        | {
              __typename: 'ResultError';
              errors: Array<{
                  __typename: 'Error';
                  errorCode: number;
                  errorMessage: string;
              }>;
          }
        | { __typename: 'ValidateResultSuccess'; success?: Maybe<boolean> };
};

export type VisitProfileMutationVariables = Exact<{
    v_Data: ProfileWhereUniqueInput;
    withV_Other?: Maybe<Scalars['Boolean']>;
    v_O_ImagesWhere?: Maybe<ImageWhereInput>;
    v_O_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    v_O_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    v_O_ImagesTake?: Maybe<Scalars['Int']>;
    v_O_ImagesSkip?: Maybe<Scalars['Int']>;
    v_O_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    withV_O_Images?: Maybe<Scalars['Boolean']>;
    withV_O_Age?: Maybe<Scalars['Boolean']>;
    withV_O_ProfileFlags?: Maybe<Scalars['Boolean']>;
    withV_O_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withV_O_P_Interest?: Maybe<Scalars['Boolean']>;
    withV_O_Blocked?: Maybe<Scalars['Boolean']>;
    withV_O_Favorite?: Maybe<Scalars['Boolean']>;
    withV_O_FriendshipStatus?: Maybe<Scalars['Boolean']>;
    withV_O_Avatar?: Maybe<Scalars['Boolean']>;
    withV_O_Theme?: Maybe<Scalars['Boolean']>;
    withV_O_T_Images?: Maybe<Scalars['Boolean']>;
}>;

export type VisitProfileMutation = {
    __typename: 'Mutation';
    visitProfile?: Maybe<{
        __typename: 'VisitProfileResult';
        otherId?: Maybe<string>;
        success: boolean;
        other?: Maybe<{
            __typename: 'Profile';
            defaultText?: Maybe<string>;
            avatarPath?: Maybe<string>;
            age: number;
            furtherInformation?: Maybe<string>;
            blocked?: Maybe<boolean>;
            favorite?: Maybe<boolean>;
            friendshipStatus?: Maybe<string>;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: Maybe<string>;
            premiumStatus: Array<ProfileStatus>;
            theme?: Maybe<{
                __typename: 'Theme';
                name: string;
                images?: Maybe<
                    Array<{
                        __typename: 'ThemeImage';
                        label: string;
                        path: string;
                        themeImageId: string;
                        themeName: string;
                    }>
                >;
            }>;
            avatar?: Maybe<{
                __typename: 'Avatar';
                avatarId: string;
                name?: Maybe<string>;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translation: string;
                    translationId: string;
                    avatarId?: Maybe<string>;
                    languageCode: string;
                }>;
            }>;
            images?: Maybe<
                Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>
            >;
            profileFlags?: Maybe<
                Array<{
                    __typename: 'ProfileFlag';
                    profileFlagId: string;
                    flagValueId?: Maybe<string>;
                    value?: Maybe<string>;
                    flag: {
                        __typename: 'Flag';
                        flagId: string;
                        name: string;
                        translations: Array<{
                            __typename: 'Translation';
                            translationId: string;
                            translation: string;
                            languageCode: string;
                            giftCategoryId?: Maybe<string>;
                            giftId?: Maybe<string>;
                            interestCategoryId?: Maybe<string>;
                            interestId?: Maybe<string>;
                            translationView: TranslationView;
                        }>;
                    };
                    flagValue?: Maybe<{
                        __typename: 'FlagValue';
                        flagId: string;
                        flagValueId: string;
                        translations: Array<{
                            __typename: 'Translation';
                            translationId: string;
                            translation: string;
                            languageCode: string;
                            giftCategoryId?: Maybe<string>;
                            giftId?: Maybe<string>;
                            interestCategoryId?: Maybe<string>;
                            interestId?: Maybe<string>;
                            translationView: TranslationView;
                        }>;
                    }>;
                }>
            >;
            profileInterests?: Maybe<
                Array<{
                    __typename: 'ProfileInterest';
                    profileInterestId: string;
                    profileId: string;
                    interestName: string;
                    interest?: Maybe<{
                        __typename: 'Interest';
                        interestId: string;
                        name: string;
                        class?: Maybe<string>;
                        path?: Maybe<string>;
                        categoryId: string;
                        translations: Array<{
                            __typename: 'Translation';
                            translationId: string;
                            translation: string;
                            languageCode: string;
                            giftCategoryId?: Maybe<string>;
                            giftId?: Maybe<string>;
                            interestCategoryId?: Maybe<string>;
                            interestId?: Maybe<string>;
                            translationView: TranslationView;
                        }>;
                    }>;
                }>
            >;
        }>;
    }>;
};

export type AggregateConversationsQueryVariables = Exact<{
    a_Where?: Maybe<ConversationProfileWhereInput>;
    a__sum?: Maybe<ConversationProfileSumAggregateInputType>;
    withA__Sum?: Maybe<Scalars['Boolean']>;
}>;

export type AggregateConversationsQuery = {
    __typename: 'Query';
    aggregateConversations?: Maybe<{
        __typename: 'AggregateConversationsResult';
        _sum?: Maybe<{
            __typename: 'ConversationProfileAggregate';
            send: number;
            unread: number;
            freeMessages: number;
            messagesSend: number;
            pokesSend: number;
            giftsSend: number;
            picturesSend: number;
            messagesUnread: number;
            pokesUnread: number;
            giftsUnread: number;
        }>;
    }>;
};

export type AvatarsQueryVariables = Exact<{
    a_Where?: Maybe<AvatarWhereInput>;
}>;

export type AvatarsQuery = {
    __typename: 'Query';
    findManyAvatar: Array<{
        __typename: 'Avatar';
        avatarId: string;
        name?: Maybe<string>;
        path: string;
        translations: Array<{
            __typename: 'Translation';
            translation: string;
            translationId: string;
            avatarId?: Maybe<string>;
            languageCode: string;
        }>;
    }>;
};

export type BlockedQueryVariables = Exact<{
    b_Where?: Maybe<BlockedWhereInput>;
    b_OrderBy?: Maybe<BlockedOrderByInput>;
    b_Cursor?: Maybe<BlockedWhereUniqueInput>;
    b_Skip?: Maybe<Scalars['Int']>;
    b_Take?: Maybe<Scalars['Int']>;
    withB_Other?: Maybe<Scalars['Boolean']>;
    withB_O_Age?: Maybe<Scalars['Boolean']>;
    withB_O_Theme?: Maybe<Scalars['Boolean']>;
    b_O_ImagesWhere?: Maybe<ImageWhereInput>;
    b_O_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    b_O_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    b_O_ImagesTake?: Maybe<Scalars['Int']>;
    b_O_ImagesSkip?: Maybe<Scalars['Int']>;
    b_O_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    withB_O_Images?: Maybe<Scalars['Boolean']>;
}>;

export type BlockedQuery = {
    __typename: 'Query';
    findManyBlocked: Array<{
        __typename: 'Blocked';
        blockedId: string;
        otherId: string;
        createdAt: Date;
        other?: Maybe<{
            __typename: 'Profile';
            age: number;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: Maybe<string>;
            premiumStatus: Array<ProfileStatus>;
            theme?: Maybe<{ __typename: 'Theme'; name: string }>;
            images?: Maybe<
                Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>
            >;
        }>;
    }>;
};

export type BlockedCountQueryVariables = Exact<{
    b_Where?: Maybe<BlockedWhereInput>;
    b_OrderBy?: Maybe<BlockedOrderByInput>;
    b_Cursor?: Maybe<BlockedWhereUniqueInput>;
    b_Skip?: Maybe<Scalars['Int']>;
    b_Take?: Maybe<Scalars['Int']>;
}>;

export type BlockedCountQuery = {
    __typename: 'Query';
    findManyBlockedCount: number;
};

export type CoinsQueryVariables = Exact<{ [key: string]: never }>;

export type CoinsQuery = { __typename: 'Query'; coins?: Maybe<number> };

export type ComplainTypesQueryVariables = Exact<{
    withC_Translations?: Maybe<Scalars['Boolean']>;
}>;

export type ComplainTypesQuery = {
    __typename: 'Query';
    findManyComplainType: Array<{
        __typename: 'ComplainType';
        complainTypeId: string;
        name: string;
        translations?: Maybe<
            Array<{
                __typename: 'Translation';
                translationId: string;
                translation: string;
                languageCode: string;
                giftCategoryId?: Maybe<string>;
                giftId?: Maybe<string>;
                interestCategoryId?: Maybe<string>;
                interestId?: Maybe<string>;
                translationView: TranslationView;
            }>
        >;
    }>;
};

export type ConfigQueryVariables = Exact<{ [key: string]: never }>;

export type ConfigQuery = {
    __typename: 'Query';
    config: {
        __typename: 'Config';
        profileFlagsBonus: number;
        firstFlirtTextBonus: number;
        firstImageBonus: number;
        activateBonus: number;
        dailyLoginBonus: number;
        mobileNumberBonus: number;
        cost: {
            __typename: 'Cost';
            eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
            friendship: { __typename: 'CostNode'; cost: number };
            match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
            message: {
                __typename: 'MessageCost';
                cost: number;
                length: number;
            };
            poke: {
                __typename: 'PokeCost';
                cost: number;
                free?: Maybe<number>;
            };
            picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
        };
    };
};

export type ConversationQueryVariables = Exact<{
    ownProfileId?: Maybe<Scalars['String']>;
    c_Where: ConversationWhereUniqueInput;
    c_MessagesWhere?: Maybe<MessageWhereInput>;
    c_MessagesOrderBy?: Maybe<MessageOrderByInput>;
    c_MessagesCursor?: Maybe<MessageWhereUniqueInput>;
    c_MessagesTake?: Maybe<Scalars['Int']>;
    c_MessagesSkip?: Maybe<Scalars['Int']>;
    withC_Messages?: Maybe<Scalars['Boolean']>;
    withC_M_Sender?: Maybe<Scalars['Boolean']>;
    withC_M_Gift?: Maybe<Scalars['Boolean']>;
    withC_M_Picture?: Maybe<Scalars['Boolean']>;
    withC_Profiles?: Maybe<Scalars['Boolean']>;
    withC_OwnProfile?: Maybe<Scalars['Boolean']>;
    withC_P_Profile?: Maybe<Scalars['Boolean']>;
    withC_MessageCost?: Maybe<Scalars['Boolean']>;
    withC_MessageLength?: Maybe<Scalars['Boolean']>;
    withC_P_P_Images?: Maybe<Scalars['Boolean']>;
    withC_LastMessage?: Maybe<Scalars['Boolean']>;
    withC_L_Sender?: Maybe<Scalars['Boolean']>;
    withC_L_Gift?: Maybe<Scalars['Boolean']>;
    withC_L_Picture?: Maybe<Scalars['Boolean']>;
}>;

export type ConversationQuery = {
    __typename: 'Query';
    findOneConversation?: Maybe<{
        __typename: 'Conversation';
        messageCost?: Maybe<number>;
        messageLength?: Maybe<number>;
        conversationId: string;
        blind: boolean;
        free: boolean;
        lastMessageId?: Maybe<string>;
        lastAction?: Maybe<Date>;
        support: boolean;
        messages?: Maybe<
            Array<{
                __typename: 'Message';
                senderId: string;
                text?: Maybe<string>;
                updatedAt: Date;
                coins: number;
                createdAt: Date;
                giftId?: Maybe<string>;
                messageId: string;
                model: MessageType;
                pictureId?: Maybe<string>;
                path?: Maybe<string>;
                sender?: Maybe<{
                    __typename: 'Profile';
                    acceptPicture: boolean;
                    country: string;
                    county: string;
                    flirtText: string;
                    gender: Gender;
                    languageCode: string;
                    profileId: string;
                    profileName: string;
                    searches: Gender;
                    shownLocation: string;
                    zodiacSign?: Maybe<string>;
                    age: number;
                    premiumStatus: Array<ProfileStatus>;
                }>;
                gift?: Maybe<{
                    __typename: 'Gift';
                    giftId: string;
                    name: string;
                    cost: number;
                    path: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                }>;
                picture?: Maybe<{
                    __typename: 'Picture';
                    pictureId: string;
                    path: string;
                    ownerId: string;
                }>;
            }>
        >;
        profiles?: Maybe<
            Array<{
                __typename: 'ConversationProfile';
                profile?: Maybe<{
                    __typename: 'Profile';
                    acceptPicture: boolean;
                    country: string;
                    county: string;
                    flirtText: string;
                    gender: Gender;
                    languageCode: string;
                    profileId: string;
                    profileName: string;
                    searches: Gender;
                    shownLocation: string;
                    zodiacSign?: Maybe<string>;
                    age: number;
                    premiumStatus: Array<ProfileStatus>;
                    images?: Maybe<
                        Array<{
                            __typename: 'Image';
                            imageId: string;
                            profileId: string;
                            path: string;
                            main: boolean;
                            private: boolean;
                        }>
                    >;
                }>;
            }>
        >;
        ownProfile: Maybe<
            Array<{
                __typename: 'ConversationProfile';
                freeMessages: number;
                messagesUnread: number;
                pokesUnread: number;
                giftsUnread: number;
                picturesUnread: number;
                messagesSend: number;
                picturesSend: number;
                giftsSend: number;
                pokesSend: number;
                conversationProfileId: string;
                conversationId: string;
                profile?: Maybe<{
                    __typename: 'Profile';
                    acceptPicture: boolean;
                    country: string;
                    county: string;
                    flirtText: string;
                    gender: Gender;
                    languageCode: string;
                    profileId: string;
                    profileName: string;
                    searches: Gender;
                    shownLocation: string;
                    zodiacSign?: Maybe<string>;
                    age: number;
                    premiumStatus: Array<ProfileStatus>;
                    images?: Maybe<
                        Array<{
                            __typename: 'Image';
                            imageId: string;
                            profileId: string;
                            path: string;
                            main: boolean;
                            private: boolean;
                        }>
                    >;
                }>;
            }>
        >;
        lastMessage?: Maybe<{
            __typename: 'Message';
            senderId: string;
            text?: Maybe<string>;
            updatedAt: Date;
            coins: number;
            createdAt: Date;
            giftId?: Maybe<string>;
            messageId: string;
            model: MessageType;
            pictureId?: Maybe<string>;
            path?: Maybe<string>;
            sender?: Maybe<{
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: Maybe<string>;
                age: number;
                premiumStatus: Array<ProfileStatus>;
            }>;
            gift?: Maybe<{
                __typename: 'Gift';
                giftId: string;
                name: string;
                cost: number;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: Maybe<string>;
                    giftId?: Maybe<string>;
                    interestCategoryId?: Maybe<string>;
                    interestId?: Maybe<string>;
                    translationView: TranslationView;
                }>;
            }>;
            picture?: Maybe<{
                __typename: 'Picture';
                pictureId: string;
                path: string;
                ownerId: string;
            }>;
        }>;
    }>;
};

export type ConversationsQueryVariables = Exact<{
    ownProfileId: Scalars['String'];
    c_Take?: Maybe<Scalars['Int']>;
    c_Skip?: Maybe<Scalars['Int']>;
    c_Cursor?: Maybe<ConversationWhereUniqueInput>;
    c_OrderBy?: Maybe<ConversationOrderByInput>;
    c_Where?: Maybe<ConversationWhereInput>;
    withC_Profiles?: Maybe<Scalars['Boolean']>;
    withC_OwnProfile?: Maybe<Scalars['Boolean']>;
    withC_P_P_Images?: Maybe<Scalars['Boolean']>;
    withC_O_Profile?: Maybe<Scalars['Boolean']>;
    withC_LastMessage?: Maybe<Scalars['Boolean']>;
    withC_MessageCost?: Maybe<Scalars['Boolean']>;
    withC_MessageLength?: Maybe<Scalars['Boolean']>;
    withC_L_Gift?: Maybe<Scalars['Boolean']>;
    withC_L_Picture?: Maybe<Scalars['Boolean']>;
    withC_L_Sender?: Maybe<Scalars['Boolean']>;
}>;

export type ConversationsQuery = {
    __typename: 'Query';
    findManyConversation: Array<{
        __typename: 'Conversation';
        messageCost?: Maybe<number>;
        messageLength?: Maybe<number>;
        conversationId: string;
        blind: boolean;
        free: boolean;
        lastMessageId?: Maybe<string>;
        lastAction?: Maybe<Date>;
        support: boolean;
        profiles?: Maybe<
            Array<{
                __typename: 'ConversationProfile';
                profile: {
                    __typename: 'Profile';
                    acceptPicture: boolean;
                    country: string;
                    county: string;
                    flirtText: string;
                    gender: Gender;
                    languageCode: string;
                    profileId: string;
                    profileName: string;
                    searches: Gender;
                    shownLocation: string;
                    zodiacSign?: Maybe<string>;
                    age: number;
                    premiumStatus: Array<ProfileStatus>;
                    images?: Maybe<
                        Array<{
                            __typename: 'Image';
                            imageId: string;
                            profileId: string;
                            path: string;
                            main: boolean;
                            private: boolean;
                        }>
                    >;
                };
            }>
        >;
        ownProfile: Maybe<
            Array<{
                __typename: 'ConversationProfile';
                freeMessages: number;
                messagesUnread: number;
                pokesUnread: number;
                giftsUnread: number;
                picturesUnread: number;
                messagesSend: number;
                picturesSend: number;
                giftsSend: number;
                pokesSend: number;
                conversationProfileId: string;
                conversationId: string;
                profile?: Maybe<{
                    __typename: 'Profile';
                    acceptPicture: boolean;
                    country: string;
                    county: string;
                    flirtText: string;
                    gender: Gender;
                    languageCode: string;
                    profileId: string;
                    profileName: string;
                    searches: Gender;
                    shownLocation: string;
                    zodiacSign?: Maybe<string>;
                    age: number;
                    premiumStatus: Array<ProfileStatus>;
                    images?: Maybe<
                        Array<{
                            __typename: 'Image';
                            imageId: string;
                            profileId: string;
                            path: string;
                            main: boolean;
                            private: boolean;
                        }>
                    >;
                }>;
            }>
        >;
        lastMessage?: Maybe<{
            __typename: 'Message';
            senderId: string;
            text?: Maybe<string>;
            updatedAt: Date;
            coins: number;
            createdAt: Date;
            giftId?: Maybe<string>;
            messageId: string;
            model: MessageType;
            pictureId?: Maybe<string>;
            path?: Maybe<string>;
            gift?: Maybe<{
                __typename: 'Gift';
                giftId: string;
                name: string;
                cost: number;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: Maybe<string>;
                    giftId?: Maybe<string>;
                    interestCategoryId?: Maybe<string>;
                    interestId?: Maybe<string>;
                    translationView: TranslationView;
                }>;
            }>;
            picture?: Maybe<{
                __typename: 'Picture';
                pictureId: string;
                path: string;
                ownerId: string;
            }>;
            sender?: Maybe<{
                __typename: 'Profile';
                acceptPicture: boolean;
                country: string;
                county: string;
                flirtText: string;
                gender: Gender;
                languageCode: string;
                profileId: string;
                profileName: string;
                searches: Gender;
                shownLocation: string;
                zodiacSign?: Maybe<string>;
                age: number;
                premiumStatus: Array<ProfileStatus>;
            }>;
        }>;
    }>;
};

export type CostQueryVariables = Exact<{ [key: string]: never }>;

export type CostQuery = {
    __typename: 'Query';
    getCosts: {
        __typename: 'Cost';
        predefinedMessage?: Maybe<{ __typename: 'CostNode'; cost: number }>;
        eyeCatcher?: Maybe<{ __typename: 'CostNode'; cost: number }>;
        friendship: { __typename: 'CostNode'; cost: number };
        match?: Maybe<{ __typename: 'CostNode'; cost: number }>;
        message: { __typename: 'MessageCost'; cost: number; length: number };
        poke: { __typename: 'PokeCost'; cost: number; free?: Maybe<number> };
        picture?: Maybe<{ __typename: 'CostNode'; cost: number }>;
    };
};

export type CountiesQueryVariables = Exact<{ [key: string]: never }>;

export type CountiesQuery = { __typename: 'Query'; getCounties: Array<string> };

export type CountriesQueryVariables = Exact<{ [key: string]: never }>;

export type CountriesQuery = {
    __typename: 'Query';
    getCountries: Array<string>;
};

export type DailySongsQueryVariables = Exact<{ [key: string]: never }>;

export type DailySongsQuery = {
    __typename: 'Query';
    findManyDailySong: Array<{
        __typename: 'DailySong';
        name: string;
        dailySongId: string;
        path: string;
    }>;
};

export type DeactivatedPushesQueryVariables = Exact<{
    d_Where?: Maybe<DeactivatedPushWhereInput>;
    d_OrderBy?: Maybe<DeactivatedPushOrderByInput>;
}>;

export type DeactivatedPushesQuery = {
    __typename: 'Query';
    findManyDeactivatedPush: Array<{
        __typename: 'DeactivatedPush';
        deactivatedPushId: string;
        setting: PushSetting;
    }>;
};

export type FavoritesQueryVariables = Exact<{
    f_Where?: Maybe<FavoriteWhereInput>;
    f_OrderBy?: Maybe<FavoriteOrderByInput>;
    f_Cursor?: Maybe<FavoriteWhereUniqueInput>;
    f_Skip?: Maybe<Scalars['Int']>;
    f_Take?: Maybe<Scalars['Int']>;
    withF_Other?: Maybe<Scalars['Boolean']>;
    withF_O_Age?: Maybe<Scalars['Boolean']>;
    withF_O_Theme?: Maybe<Scalars['Boolean']>;
    withF_O_Images?: Maybe<Scalars['Boolean']>;
}>;

export type FavoritesQuery = {
    __typename: 'Query';
    findManyFavorite: Array<{
        __typename: 'Favorite';
        createdAt: Date;
        favoriteId: string;
        otherId: string;
        other?: Maybe<{
            __typename: 'Profile';
            age: number;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: Maybe<string>;
            premiumStatus: Array<ProfileStatus>;
            theme?: Maybe<{ __typename: 'Theme'; name: string }>;
            images?: Maybe<
                Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>
            >;
        }>;
    }>;
};

export type FavoritesCountQueryVariables = Exact<{
    f_Where?: Maybe<FavoriteWhereInput>;
    f_OrderBy?: Maybe<FavoriteOrderByInput>;
    f_Cursor?: Maybe<FavoriteWhereUniqueInput>;
    f_Skip?: Maybe<Scalars['Int']>;
    f_Take?: Maybe<Scalars['Int']>;
}>;

export type FavoritesCountQuery = {
    __typename: 'Query';
    findManyFavoriteCount: number;
};

export type FlagsQueryVariables = Exact<{ [key: string]: never }>;

export type FlagsQuery = {
    __typename: 'Query';
    findManyFlag: Array<{
        __typename: 'Flag';
        flagId: string;
        max?: Maybe<number>;
        maxLength: number;
        min?: Maybe<number>;
        minLength: number;
        name: string;
        numberStep?: Maybe<string>;
        gender: FlagGender;
        regEx?: Maybe<string>;
        type: FlagType;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: Maybe<string>;
            giftId?: Maybe<string>;
            interestCategoryId?: Maybe<string>;
            interestId?: Maybe<string>;
            translationView: TranslationView;
        }>;
        flagValues: Array<{
            __typename: 'FlagValue';
            flagId: string;
            flagValueId: string;
            translations: Array<{
                __typename: 'Translation';
                translationId: string;
                translation: string;
                languageCode: string;
                giftCategoryId?: Maybe<string>;
                giftId?: Maybe<string>;
                interestCategoryId?: Maybe<string>;
                interestId?: Maybe<string>;
                translationView: TranslationView;
            }>;
        }>;
    }>;
};

export type FriendshipsQueryVariables = Exact<{
    f_Where?: Maybe<FriendshipWhereInput>;
    f_OrderBy?: Maybe<FriendshipOrderByInput>;
    f_Cursor?: Maybe<FriendshipWhereUniqueInput>;
    f_Skip?: Maybe<Scalars['Int']>;
    f_Take?: Maybe<Scalars['Int']>;
    withF_Other?: Maybe<Scalars['Boolean']>;
    withF_O_Age?: Maybe<Scalars['Boolean']>;
    withF_O_Theme?: Maybe<Scalars['Boolean']>;
    withF_O_Images?: Maybe<Scalars['Boolean']>;
    withF_O_Favorite?: Maybe<Scalars['Boolean']>;
}>;

export type FriendshipsQuery = {
    __typename: 'Query';
    findManyFriendship: Array<{
        __typename: 'Friendship';
        friendshipId: string;
        otherId: string;
        status: FriendshipStatus;
        updatedAt: Date;
        other?: Maybe<{
            __typename: 'Profile';
            age: number;
            favorite?: Maybe<boolean>;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: Maybe<string>;
            premiumStatus: Array<ProfileStatus>;
            theme?: Maybe<{ __typename: 'Theme'; name: string }>;
            images?: Maybe<
                Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>
            >;
        }>;
    }>;
};

export type FriendshipsCountQueryVariables = Exact<{
    f_Where?: Maybe<FriendshipWhereInput>;
    f_OrderBy?: Maybe<FriendshipOrderByInput>;
    f_Cursor?: Maybe<FriendshipWhereUniqueInput>;
    f_Skip?: Maybe<Scalars['Int']>;
    f_Take?: Maybe<Scalars['Int']>;
}>;

export type FriendshipsCountQuery = {
    __typename: 'Query';
    findManyFriendshipCount: number;
};

export type GeolocationsQueryVariables = Exact<{
    g_Where: GeolocationWhereInput;
    g_OrderBy?: Maybe<GeolocationOrderByInput>;
    g_Cursor?: Maybe<GeolocationWhereUniqueInput>;
    g_Skip?: Maybe<Scalars['Int']>;
    g_take?: Maybe<Scalars['Int']>;
}>;

export type GeolocationsQuery = {
    __typename: 'Query';
    findManyGeolocation: Array<{
        __typename: 'Geolocation';
        geolocationId: string;
        country: string;
        postcode: string;
        location: string;
        state?: Maybe<string>;
        province?: Maybe<string>;
        community?: Maybe<string>;
        latitude: string;
        longitude: string;
    }>;
};

export type GetNextMatchesQueryVariables = Exact<{ [key: string]: never }>;

export type GetNextMatchesQuery = {
    __typename: 'Query';
    getNextMatches:
        | { __typename: 'Error'; errorCode: number; errorMessage: string }
        | {
              __typename: 'NextMatchResultSuccess';
              matches: Array<{
                  __typename: 'Match';
                  matchId: string;
                  ownerId: string;
                  playedAt?: Maybe<Date>;
                  profileId: string;
                  type: MatchType;
                  profile: {
                      __typename: 'Profile';
                      acceptPicture: boolean;
                      country: string;
                      county: string;
                      flirtText: string;
                      gender: Gender;
                      languageCode: string;
                      profileId: string;
                      profileName: string;
                      searches: Gender;
                      shownLocation: string;
                      zodiacSign?: Maybe<string>;
                      age: number;
                      premiumStatus: Array<ProfileStatus>;
                      images: Array<{
                          __typename: 'Image';
                          imageId: string;
                          profileId: string;
                          path: string;
                          main: boolean;
                          private: boolean;
                      }>;
                  };
              }>;
          };
};

export type GiftQueryVariables = Exact<{
    g_Where: GiftWhereUniqueInput;
    withG_Translations?: Maybe<Scalars['Boolean']>;
}>;

export type GiftQuery = {
    __typename: 'Query';
    findOneGift?: Maybe<{
        __typename: 'Gift';
        giftId: string;
        name: string;
        cost: number;
        path: string;
        translations?: Maybe<
            Array<{
                __typename: 'Translation';
                translationId: string;
                translation: string;
                languageCode: string;
                giftCategoryId?: Maybe<string>;
                giftId?: Maybe<string>;
                interestCategoryId?: Maybe<string>;
                interestId?: Maybe<string>;
                translationView: TranslationView;
            }>
        >;
    }>;
};

export type GiftCategoriesQueryVariables = Exact<{
    g_Where?: Maybe<GiftCategoryWhereInput>;
    g_OrderBy?: Maybe<GiftCategoryOrderByInput>;
    g_Cursor?: Maybe<GiftCategoryWhereUniqueInput>;
    g_Skip?: Maybe<Scalars['Int']>;
    g_Take?: Maybe<Scalars['Int']>;
    withG_Gifts?: Maybe<Scalars['Boolean']>;
}>;

export type GiftCategoriesQuery = {
    __typename: 'Query';
    findManyGiftCategory: Array<{
        __typename: 'GiftCategory';
        giftCategoryId: string;
        name: string;
        gifts?: Maybe<
            Array<{
                __typename: 'Gift';
                giftId: string;
                name: string;
                cost: number;
                path: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: Maybe<string>;
                    giftId?: Maybe<string>;
                    interestCategoryId?: Maybe<string>;
                    interestId?: Maybe<string>;
                    translationView: TranslationView;
                }>;
            }>
        >;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: Maybe<string>;
            giftId?: Maybe<string>;
            interestCategoryId?: Maybe<string>;
            interestId?: Maybe<string>;
            translationView: TranslationView;
        }>;
    }>;
};

export type GiftsQueryVariables = Exact<{
    g_Where?: Maybe<GiftWhereInput>;
    g_Cursor?: Maybe<GiftWhereUniqueInput>;
    g_Skip?: Maybe<Scalars['Int']>;
    g_Take?: Maybe<Scalars['Int']>;
}>;

export type GiftsQuery = {
    __typename: 'Query';
    findManyGift: Array<{
        __typename: 'Gift';
        giftId: string;
        name: string;
        cost: number;
        path: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: Maybe<string>;
            giftId?: Maybe<string>;
            interestCategoryId?: Maybe<string>;
            interestId?: Maybe<string>;
            translationView: TranslationView;
        }>;
    }>;
};

export type InterestCategoriesQueryVariables = Exact<{
    i_Cursor?: Maybe<InterestCategoryWhereUniqueInput>;
    i_Skip?: Maybe<Scalars['Int']>;
    i_Take?: Maybe<Scalars['Int']>;
    withI_Interests?: Maybe<Scalars['Boolean']>;
}>;

export type InterestCategoriesQuery = {
    __typename: 'Query';
    findManyInterestCategory: Array<{
        __typename: 'InterestCategory';
        interestCategoryId: string;
        name: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            translation: string;
            languageCode: string;
            giftCategoryId?: Maybe<string>;
            giftId?: Maybe<string>;
            interestCategoryId?: Maybe<string>;
            interestId?: Maybe<string>;
            translationView: TranslationView;
        }>;
        interests?: Maybe<
            Array<{
                __typename: 'Interest';
                interestId: string;
                name: string;
                class?: Maybe<string>;
                path?: Maybe<string>;
                categoryId: string;
                translations: Array<{
                    __typename: 'Translation';
                    translationId: string;
                    translation: string;
                    languageCode: string;
                    giftCategoryId?: Maybe<string>;
                    giftId?: Maybe<string>;
                    interestCategoryId?: Maybe<string>;
                    interestId?: Maybe<string>;
                    translationView: TranslationView;
                }>;
            }>
        >;
    }>;
};

export type LanguagesQueryVariables = Exact<{ [key: string]: never }>;

export type LanguagesQuery = {
    __typename: 'Query';
    findManyLanguage: Array<{
        __typename: 'Language';
        code: string;
        name: string;
    }>;
};

export type MatchConfigQueryVariables = Exact<{ [key: string]: never }>;

export type MatchConfigQuery = {
    __typename: 'Query';
    matchConfig:
        | { __typename: 'Error'; errorCode: number; errorMessage: string }
        | {
              __typename: 'MatchConfigResultSuccess';
              limit: number;
              played: number;
              freeMessages: number;
              cost: number;
              buyMore: boolean;
          };
};

export type MatchCountQueryVariables = Exact<{
    m_Cursor?: Maybe<MatchWhereUniqueInput>;
    m_Skip?: Maybe<Scalars['Int']>;
    m_Take?: Maybe<Scalars['Int']>;
}>;

export type MatchCountQuery = {
    __typename: 'Query';
    findManyMatchCount: number;
};

export type MatchFilterQueryVariables = Exact<{ [key: string]: never }>;

export type MatchFilterQuery = {
    __typename: 'Query';
    getMatchFilter?: Maybe<{
        __typename: 'MatchFilter';
        matchFilterId: string;
        userId: string;
        updatedAt: Date;
        ageFrom: number;
        ageTo: number;
    }>;
};

export type MatchesQueryVariables = Exact<{
    m_Cursor?: Maybe<MatchWhereUniqueInput>;
    m_OrderBy?: Maybe<
        | Array<Maybe<MatchOrderByWithRelationInput>>
        | Maybe<MatchOrderByWithRelationInput>
    >;
    m_Skip?: Maybe<Scalars['Int']>;
    m_Take?: Maybe<Scalars['Int']>;
}>;

export type MatchesQuery = {
    __typename: 'Query';
    findManyMatch: Array<{
        __typename: 'Match';
        matchId: string;
        ownerId: string;
        playedAt?: Maybe<Date>;
        profileId: string;
        type: MatchType;
        profile: {
            __typename: 'Profile';
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: Maybe<string>;
            age: number;
            premiumStatus: Array<ProfileStatus>;
            images: Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>;
        };
    }>;
};

export type MessageCountQueryVariables = Exact<{
    m_Where?: Maybe<MessageWhereInput>;
    m_OrderBy?: Maybe<MessageOrderByInput>;
    m_Cursor?: Maybe<MessageWhereUniqueInput>;
    m_Skip?: Maybe<Scalars['Int']>;
    m_Take?: Maybe<Scalars['Int']>;
}>;

export type MessageCountQuery = {
    __typename: 'Query';
    findManyMessageCount?: Maybe<number>;
};

export type MessagesQueryVariables = Exact<{
    m_Where?: Maybe<MessageWhereInput>;
    m_OrderBy?: Maybe<MessageOrderByInput>;
    m_Cursor?: Maybe<MessageWhereUniqueInput>;
    m_Skip?: Maybe<Scalars['Int']>;
    m_Take?: Maybe<Scalars['Int']>;
    withM_Sender?: Maybe<Scalars['Boolean']>;
    withM_S_Age?: Maybe<Scalars['Boolean']>;
    withM_Picture?: Maybe<Scalars['Boolean']>;
    withM_Gift?: Maybe<Scalars['Boolean']>;
    withM_Conversation?: Maybe<Scalars['Boolean']>;
    withM_C_LastMessage?: Maybe<Scalars['Boolean']>;
    withM_C_L_Gift?: Maybe<Scalars['Boolean']>;
    withM_C_L_Picture?: Maybe<Scalars['Boolean']>;
}>;

export type MessagesQuery = {
    __typename: 'Query';
    findManyMessage?: Maybe<
        Array<
            Maybe<{
                __typename: 'Message';
                senderId: string;
                text?: Maybe<string>;
                updatedAt: Date;
                coins: number;
                createdAt: Date;
                giftId?: Maybe<string>;
                messageId: string;
                model: MessageType;
                pictureId?: Maybe<string>;
                path?: Maybe<string>;
                sender?: Maybe<{
                    __typename: 'Profile';
                    age: number;
                    acceptPicture: boolean;
                    country: string;
                    county: string;
                    flirtText: string;
                    gender: Gender;
                    languageCode: string;
                    profileId: string;
                    profileName: string;
                    searches: Gender;
                    shownLocation: string;
                    zodiacSign?: Maybe<string>;
                    premiumStatus: Array<ProfileStatus>;
                }>;
                picture?: Maybe<{
                    __typename: 'Picture';
                    pictureId: string;
                    path: string;
                    ownerId: string;
                }>;
                gift?: Maybe<{
                    __typename: 'Gift';
                    giftId: string;
                    name: string;
                    cost: number;
                    path: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                }>;
                conversation?: Maybe<{
                    __typename: 'Conversation';
                    conversationId: string;
                    blind: boolean;
                    free: boolean;
                    lastMessageId?: Maybe<string>;
                    lastAction?: Maybe<Date>;
                    support: boolean;
                    lastMessage?: Maybe<{
                        __typename: 'Message';
                        senderId: string;
                        text?: Maybe<string>;
                        updatedAt: Date;
                        coins: number;
                        createdAt: Date;
                        giftId?: Maybe<string>;
                        messageId: string;
                        model: MessageType;
                        pictureId?: Maybe<string>;
                        path?: Maybe<string>;
                        gift?: Maybe<{
                            __typename: 'Gift';
                            giftId: string;
                            name: string;
                            cost: number;
                            path: string;
                            translations: Array<{
                                __typename: 'Translation';
                                translationId: string;
                                translation: string;
                                languageCode: string;
                                giftCategoryId?: Maybe<string>;
                                giftId?: Maybe<string>;
                                interestCategoryId?: Maybe<string>;
                                interestId?: Maybe<string>;
                                translationView: TranslationView;
                            }>;
                        }>;
                        picture?: Maybe<{
                            __typename: 'Picture';
                            pictureId: string;
                            path: string;
                            ownerId: string;
                        }>;
                    }>;
                }>;
            }>
        >
    >;
};

export type MyProfileQueryVariables = Exact<{
    withM_Age?: Maybe<Scalars['Boolean']>;
    withM_User?: Maybe<Scalars['Boolean']>;
    m_ImagesWhere?: Maybe<ImageWhereInput>;
    m_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    m_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    m_ImagesTake?: Maybe<Scalars['Int']>;
    m_ImagesSkip?: Maybe<Scalars['Int']>;
    m_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    withM_Images?: Maybe<Scalars['Boolean']>;
    withM_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withM_ProfileFlags?: Maybe<Scalars['Boolean']>;
    withM_P_Interest?: Maybe<Scalars['Boolean']>;
    withM_Theme?: Maybe<Scalars['Boolean']>;
    withM_T_Images?: Maybe<Scalars['Boolean']>;
    m_T_ImagesWhere?: Maybe<ThemeImageWhereInput>;
    withM_Avatar?: Maybe<Scalars['Boolean']>;
}>;

export type MyProfileQuery = {
    __typename: 'Query';
    myProfile: {
        __typename: 'MyProfile';
        defaultText?: Maybe<string>;
        avatarPath?: Maybe<string>;
        age?: Maybe<number>;
        furtherInformation?: Maybe<string>;
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        themeName?: Maybe<string>;
        birthDate?: Maybe<string>;
        completed: boolean;
        zodiacSign?: Maybe<string>;
        premiumStatus: Array<ProfileStatus>;
        avatar?: Maybe<{
            __typename: 'Avatar';
            avatarId: string;
            name?: Maybe<string>;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translation: string;
                translationId: string;
                avatarId?: Maybe<string>;
                languageCode: string;
            }>;
        }>;
        user?: Maybe<{
            __typename: 'User';
            role: string;
            username: string;
            sendMarketingEmail: boolean;
            sendTransactionalEmail: boolean;
            sendSMS: boolean;
            imageCompleted: boolean;
            flirtTextCompleted: boolean;
            profileFlagsCompleted: boolean;
            emailValidated: boolean;
            mobileNumberValidated: boolean;
            email?: Maybe<string>;
            mobileNumber?: Maybe<string>;
            deleteToken: string;
        }>;
        images?: Maybe<
            Array<{
                __typename: 'Image';
                verified: boolean;
                userChanged: Date;
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>
        >;
        profileInterests?: Maybe<
            Array<{
                __typename: 'ProfileInterest';
                profileInterestId: string;
                profileId: string;
                interestName: string;
                interest?: Maybe<{
                    __typename: 'Interest';
                    interestId: string;
                    name: string;
                    class?: Maybe<string>;
                    path?: Maybe<string>;
                    categoryId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                }>;
            }>
        >;
        profileFlags?: Maybe<
            Array<{
                __typename: 'ProfileFlag';
                profileFlagId: string;
                flagValueId?: Maybe<string>;
                value?: Maybe<string>;
                flag: {
                    __typename: 'Flag';
                    flagId: string;
                    name: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                };
                flagValue?: Maybe<{
                    __typename: 'FlagValue';
                    flagId: string;
                    flagValueId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                }>;
            }>
        >;
        theme?: Maybe<{
            __typename: 'Theme';
            name: string;
            images?: Maybe<
                Array<{
                    __typename: 'ThemeImage';
                    label: string;
                    path: string;
                    themeImageId: string;
                    themeName: string;
                }>
            >;
        }>;
    };
};

export type NotificationCountQueryVariables = Exact<{
    n_Where?: Maybe<NotificationWhereInput>;
    n_OrderBy?: Maybe<NotificationOrderByInput>;
    n_Cursor?: Maybe<NotificationWhereUniqueInput>;
    n_Skip?: Maybe<Scalars['Int']>;
    n_Take?: Maybe<Scalars['Int']>;
}>;

export type NotificationCountQuery = {
    __typename: 'Query';
    findManyNotificationCount: number;
};

export type NotificationsQueryVariables = Exact<{
    n_Where?: Maybe<NotificationWhereInput>;
    n_OrderBy?: Maybe<NotificationOrderByInput>;
    n_Cursor?: Maybe<NotificationWhereUniqueInput>;
    n_Skip?: Maybe<Scalars['Int']>;
    n_Take?: Maybe<Scalars['Int']>;
    withN_Profile?: Maybe<Scalars['Boolean']>;
    withN_P_Age?: Maybe<Scalars['Boolean']>;
}>;

export type NotificationsQuery = {
    __typename: 'Query';
    findManyNotification: Array<{
        __typename: 'Notification';
        notificationId: string;
        target?: Maybe<string>;
        type: NotificationType;
        read: boolean;
        updatedAt: Date;
        createdAt: Date;
        profile?: Maybe<{
            __typename: 'Profile';
            profileId: string;
            age?: Maybe<number>;
        }>;
    }>;
};

export type OffersQueryVariables = Exact<{
    o_Where: OfferWhereInput;
    o_OrderBy?: Maybe<OfferOrderByInput>;
    o_Cursor?: Maybe<OfferWhereUniqueInput>;
    o_Skip?: Maybe<Scalars['Int']>;
    o_Take?: Maybe<Scalars['Int']>;
    withO_Provider?: Maybe<Scalars['Boolean']>;
}>;

export type OffersQuery = {
    __typename: 'Query';
    findManyOffer: Array<{
        __typename: 'Offer';
        offerId: string;
        name: string;
        cost: number;
        coins: number;
        bonus: number;
        extra: string;
        currency: string;
        providerName: string;
        periodUnit: PeriodUnitOffer;
        profileStatus?: Maybe<ProfileStatus>;
        statusPeriod: number;
        provider?: Maybe<{
            __typename: 'Provider';
            providerId: string;
            name: string;
            logo: string;
            title: string;
            description?: Maybe<string>;
            currency: string;
        }>;
    }>;
};

export type OptionPollsQueryVariables = Exact<{ [key: string]: never }>;

export type OptionPollsQuery = {
    __typename: 'Query';
    findManyOptionPoll: Array<{
        __typename: 'OptionPoll';
        optionPollId: string;
        name: string;
        text: string;
        position: number;
        languageCode: string;
        answers: Array<{
            __typename: 'OptionPollAnswer';
            optionPollAnswerId: string;
            text: string;
            optionPollId: string;
            languageCode: string;
            votes: string;
            path?: Maybe<string>;
        }>;
        myAnswer?: Maybe<{
            __typename: 'ProfileOptionPoll';
            optionPollAnswerId: string;
            optionPollId: string;
            profileId: string;
            profileOptionPollId: string;
            createdAt: Date;
        }>;
    }>;
};

export type PicturesQueryVariables = Exact<{
    p_Take?: Maybe<Scalars['Int']>;
    p_Skip?: Maybe<Scalars['Int']>;
}>;

export type PicturesQuery = {
    __typename: 'Query';
    findManyPicture: Array<{
        __typename: 'Picture';
        pictureId: string;
        path: string;
        ownerId: string;
    }>;
};

export type PredefinedMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type PredefinedMessagesQuery = {
    __typename: 'Query';
    findManyPredefinedMessage: Array<{
        __typename: 'PredefinedMessage';
        path?: Maybe<string>;
        predefinedMessageId: string;
        translations: Array<{
            __typename: 'Translation';
            translation: string;
            translationId: string;
            predefinedMessageId?: Maybe<string>;
            languageCode: string;
        }>;
    }>;
};

export type ProfileQueryVariables = Exact<{
    p_Where: ProfileWhereUniqueInput;
    p_ImagesWhere?: Maybe<ImageWhereInput>;
    p_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    p_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    p_ImagesTake?: Maybe<Scalars['Int']>;
    p_ImagesSkip?: Maybe<Scalars['Int']>;
    p_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    withP_Images?: Maybe<Scalars['Boolean']>;
    withP_Age?: Maybe<Scalars['Boolean']>;
    withP_ProfileFlags?: Maybe<Scalars['Boolean']>;
    withP_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withP_P_Interest?: Maybe<Scalars['Boolean']>;
    withP_Blocked?: Maybe<Scalars['Boolean']>;
    withP_Favorite?: Maybe<Scalars['Boolean']>;
    withP_FriendshipStatus?: Maybe<Scalars['Boolean']>;
    withP_Theme?: Maybe<Scalars['Boolean']>;
    withP_T_Images?: Maybe<Scalars['Boolean']>;
    withP_Avatar?: Maybe<Scalars['Boolean']>;
    withP_DefaultText?: Maybe<Scalars['Boolean']>;
}>;

export type ProfileQuery = {
    __typename: 'Query';
    findOneProfile?: Maybe<{
        __typename: 'Profile';
        defaultText?: Maybe<string>;
        avatarPath?: Maybe<string>;
        age: number;
        furtherInformation?: Maybe<string>;
        blocked?: Maybe<boolean>;
        favorite?: Maybe<boolean>;
        friendshipStatus?: Maybe<string>;
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        zodiacSign?: Maybe<string>;
        premiumStatus: Array<ProfileStatus>;
        theme?: Maybe<{
            __typename: 'Theme';
            name: string;
            images?: Maybe<
                Array<{
                    __typename: 'ThemeImage';
                    label: string;
                    path: string;
                    themeImageId: string;
                    themeName: string;
                }>
            >;
        }>;
        avatar?: Maybe<{
            __typename: 'Avatar';
            avatarId: string;
            name?: Maybe<string>;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translation: string;
                translationId: string;
                avatarId?: Maybe<string>;
                languageCode: string;
            }>;
        }>;
        images?: Maybe<
            Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>
        >;
        profileFlags?: Maybe<
            Array<{
                __typename: 'ProfileFlag';
                profileFlagId: string;
                flagValueId?: Maybe<string>;
                value?: Maybe<string>;
                flag: {
                    __typename: 'Flag';
                    flagId: string;
                    name: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                };
                flagValue?: Maybe<{
                    __typename: 'FlagValue';
                    flagId: string;
                    flagValueId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                }>;
            }>
        >;
        profileInterests?: Maybe<
            Array<{
                __typename: 'ProfileInterest';
                profileInterestId: string;
                profileId: string;
                interestName: string;
                interest?: Maybe<{
                    __typename: 'Interest';
                    interestId: string;
                    name: string;
                    class?: Maybe<string>;
                    path?: Maybe<string>;
                    categoryId: string;
                    translations: Array<{
                        __typename: 'Translation';
                        translationId: string;
                        translation: string;
                        languageCode: string;
                        giftCategoryId?: Maybe<string>;
                        giftId?: Maybe<string>;
                        interestCategoryId?: Maybe<string>;
                        interestId?: Maybe<string>;
                        translationView: TranslationView;
                    }>;
                }>;
            }>
        >;
    }>;
};

export type ProfileCountQueryVariables = Exact<{
    p_Where?: Maybe<ProfileWhereInput>;
    p_OrderBy?: Maybe<ProfileOrderByInput>;
    p_Cursor?: Maybe<ProfileWhereUniqueInput>;
    p_Skip?: Maybe<Scalars['Int']>;
    p_Take?: Maybe<Scalars['Int']>;
}>;

export type ProfileCountQuery = {
    __typename: 'Query';
    findManyProfileCount: number;
};

export type ProfileTextsQueryVariables = Exact<{ [key: string]: never }>;

export type ProfileTextsQuery = {
    __typename: 'Query';
    findManyProfileText: Array<{
        __typename: 'ProfileText';
        profileTextId: string;
        translations: Array<{
            __typename: 'Translation';
            translationId: string;
            profileTextId?: Maybe<string>;
            languageCode: string;
            translation: string;
        }>;
    }>;
};

export type ProfilesQueryVariables = Exact<{
    p_Where?: Maybe<ProfileWhereInputExtended>;
    p_OrderBy?: Maybe<ProfileOrderByInput>;
    p_Cursor?: Maybe<ProfileWhereUniqueInput>;
    p_Skip?: Maybe<Scalars['Int']>;
    p_Take?: Maybe<Scalars['Int']>;
    withP_Age?: Maybe<Scalars['Boolean']>;
    withP_Images?: Maybe<Scalars['Boolean']>;
    withP_Favorite?: Maybe<Scalars['Boolean']>;
    withP_FriendshipStatus?: Maybe<Scalars['Boolean']>;
    withP_Avatar?: Maybe<Scalars['Boolean']>;
    withP_DefaultText?: Maybe<Scalars['Boolean']>;
    withP_Theme?: Maybe<Scalars['Boolean']>;
    withP_T_Images?: Maybe<Scalars['Boolean']>;
}>;

export type ProfilesQuery = {
    __typename: 'Query';
    findManyProfile: Array<{
        __typename: 'Profile';
        defaultText?: Maybe<string>;
        avatarPath?: Maybe<string>;
        age: number;
        favorite?: Maybe<boolean>;
        friendshipStatus?: Maybe<string>;
        acceptPicture: boolean;
        country: string;
        county: string;
        flirtText: string;
        gender: Gender;
        languageCode: string;
        profileId: string;
        profileName: string;
        searches: Gender;
        shownLocation: string;
        zodiacSign?: Maybe<string>;
        premiumStatus: Array<ProfileStatus>;
        theme?: Maybe<{
            __typename: 'Theme';
            name: string;
            images?: Maybe<
                Array<{
                    __typename: 'ThemeImage';
                    label: string;
                    path: string;
                    themeImageId: string;
                    themeName: string;
                }>
            >;
        }>;
        avatar?: Maybe<{
            __typename: 'Avatar';
            avatarId: string;
            name?: Maybe<string>;
            path: string;
            translations: Array<{
                __typename: 'Translation';
                translation: string;
                translationId: string;
                avatarId?: Maybe<string>;
                languageCode: string;
            }>;
        }>;
        images?: Maybe<
            Array<{
                __typename: 'Image';
                imageId: string;
                profileId: string;
                path: string;
                main: boolean;
                private: boolean;
            }>
        >;
    }>;
};

export type ProvidersQueryVariables = Exact<{
    p_Where?: Maybe<ProviderWhereInput>;
    p_OrderBy?: Maybe<ProviderOrderByInput>;
    p_Cursor?: Maybe<ProviderWhereUniqueInput>;
    p_Skip?: Maybe<Scalars['Int']>;
    p_Take?: Maybe<Scalars['Int']>;
    p_OffersWhere?: Maybe<OfferWhereInput>;
    p_OffersOrderBy?: Maybe<OfferOrderByInput>;
    p_OffersCursor?: Maybe<OfferWhereUniqueInput>;
    p_OffersSkip?: Maybe<Scalars['Int']>;
    p_OffersTake?: Maybe<Scalars['Int']>;
    p_OffersDistinct?: Maybe<OfferDistinctFieldEnum>;
    withP_Offers?: Maybe<Scalars['Boolean']>;
}>;

export type ProvidersQuery = {
    __typename: 'Query';
    findManyProvider: Array<{
        __typename: 'Provider';
        providerId: string;
        name: string;
        logo: string;
        title: string;
        description?: Maybe<string>;
        currency: string;
        offers?: Maybe<
            Array<{
                __typename: 'Offer';
                offerId: string;
                name: string;
                cost: number;
                coins: number;
                bonus: number;
                extra: string;
                currency: string;
                providerName: string;
                periodUnit: PeriodUnitOffer;
                profileStatus?: Maybe<ProfileStatus>;
                statusPeriod: number;
            }>
        >;
    }>;
};

export type SupportMessageCountQueryVariables = Exact<{ [key: string]: never }>;

export type SupportMessageCountQuery = {
    __typename: 'Query';
    unreadSupportMessageCount: number;
};

export type SupportTicketQueryVariables = Exact<{
    s_Where: SupportTicketWhereUniqueInput;
    withS_SupportMessages?: Maybe<Scalars['Boolean']>;
    s_SupportMessagesWhere?: Maybe<SupportMessageWhereInput>;
    s_SupportMessagesOrderBy?: Maybe<
        | Array<Maybe<SupportMessageOrderByInput>>
        | Maybe<SupportMessageOrderByInput>
    >;
    s_SupportMessagesCursor?: Maybe<SupportMessageWhereUniqueInput>;
    s_SupportMessagesSkip?: Maybe<Scalars['Int']>;
    s_SupportMessagesTake?: Maybe<Scalars['Int']>;
}>;

export type SupportTicketQuery = {
    __typename: 'Query';
    findOneSupportTicket?: Maybe<{
        __typename: 'SupportTicket';
        supportTicketId: string;
        status: SupportTicketStatus;
        createdAt: Date;
        updatedAt: Date;
        category: SupportCategory;
        ticketNumber: number;
        supportMessages?: Maybe<
            Array<{
                __typename: 'SupportMessage';
                supportMessageId: string;
                text: string;
                createdAt: Date;
                updatedAt: Date;
                sender: SupportMessageSender;
                supportTicketId: string;
                read: boolean;
            }>
        >;
    }>;
};

export type SupportTicketsQueryVariables = Exact<{
    s_Where?: Maybe<SupportTicketWhereInput>;
    s_OrderBy?: Maybe<
        | Array<Maybe<SupportTicketOrderByInput>>
        | Maybe<SupportTicketOrderByInput>
    >;
    s_Cursor?: Maybe<SupportTicketWhereUniqueInput>;
    s_Skip?: Maybe<Scalars['Int']>;
    s_Take?: Maybe<Scalars['Int']>;
    withS_SupportMessages?: Maybe<Scalars['Boolean']>;
}>;

export type SupportTicketsQuery = {
    __typename: 'Query';
    findManySupportTicket: Array<{
        __typename: 'SupportTicket';
        supportTicketId: string;
        status: SupportTicketStatus;
        createdAt: Date;
        updatedAt: Date;
        category: SupportCategory;
        ticketNumber: number;
        supportMessages?: Maybe<
            Array<{
                __typename: 'SupportMessage';
                supportMessageId: string;
                text: string;
                createdAt: Date;
                updatedAt: Date;
                sender: SupportMessageSender;
                supportTicketId: string;
                read: boolean;
            }>
        >;
    }>;
};

export type ThemesQueryVariables = Exact<{ [key: string]: never }>;

export type ThemesQuery = {
    __typename: 'Query';
    findManyTheme: Array<{
        __typename: 'Theme';
        name: string;
        images: Array<{
            __typename: 'ThemeImage';
            label: string;
            path: string;
            themeImageId: string;
            themeName: string;
        }>;
    }>;
};

export type TranslationCountQueryVariables = Exact<{
    s_Where?: Maybe<TranslationWhereInput>;
    s_Cursor?: Maybe<TranslationWhereUniqueInput>;
    s_Skip?: Maybe<Scalars['Int']>;
    s_Take?: Maybe<Scalars['Int']>;
}>;

export type TranslationCountQuery = {
    __typename: 'Query';
    findManyTranslationCount: number;
};

export type TranslationsQueryVariables = Exact<{
    s_Where?: Maybe<TranslationWhereInput>;
    s_Cursor?: Maybe<TranslationWhereUniqueInput>;
    s_Skip?: Maybe<Scalars['Int']>;
    s_Take?: Maybe<Scalars['Int']>;
}>;

export type TranslationsQuery = {
    __typename: 'Query';
    findManyTranslation: Array<{
        __typename: 'Translation';
        avatarId?: Maybe<string>;
        profileTextId?: Maybe<string>;
        translationId: string;
        translation: string;
        languageCode: string;
        giftCategoryId?: Maybe<string>;
        giftId?: Maybe<string>;
        interestCategoryId?: Maybe<string>;
        interestId?: Maybe<string>;
        translationView: TranslationView;
    }>;
};

export type UserPremiumStatusQueryVariables = Exact<{ [key: string]: never }>;

export type UserPremiumStatusQuery = {
    __typename: 'Query';
    userPremiumStatus: Array<{
        __typename: 'UserPremiumStatus';
        createdAt: Date;
        validTo: Date;
        userId: string;
        status: ProfileStatus;
        profilePremiumStatusId: string;
    }>;
};

export type VisitQueryVariables = Exact<{
    v_Where?: Maybe<VisitWhereInput>;
    v_OrderBy?: Maybe<VisitOrderByInput>;
    v_Cursor?: Maybe<VisitWhereUniqueInput>;
    v_Skip?: Maybe<Scalars['Int']>;
    v_Take?: Maybe<Scalars['Int']>;
    v_ImagesWhere?: Maybe<ImageWhereInput>;
    v_ImagesOrderBy?: Maybe<
        Array<Maybe<ImageOrderByInput>> | Maybe<ImageOrderByInput>
    >;
    v_ImagesCursor?: Maybe<ImageWhereUniqueInput>;
    v_ImagesTake?: Maybe<Scalars['Int']>;
    v_ImagesSkip?: Maybe<Scalars['Int']>;
    v_ImagesDistinct?: Maybe<ImageDistinctFieldEnum>;
    withV_Other?: Maybe<Scalars['Boolean']>;
    withV_O_Images?: Maybe<Scalars['Boolean']>;
    withV_O_Age?: Maybe<Scalars['Boolean']>;
    withV_O_Theme?: Maybe<Scalars['Boolean']>;
    withV_O_ProfileFlags?: Maybe<Scalars['Boolean']>;
    withV_O_ProfileInterests?: Maybe<Scalars['Boolean']>;
    withV_O_P_Interest?: Maybe<Scalars['Boolean']>;
    withV_O_Blocked?: Maybe<Scalars['Boolean']>;
    withV_O_Favorite?: Maybe<Scalars['Boolean']>;
    withV_O_FriendshipStatus?: Maybe<Scalars['Boolean']>;
}>;

export type VisitQuery = {
    __typename: 'Query';
    findManyVisit: Array<{
        __typename: 'Visit';
        visitId: string;
        otherId: string;
        createdAt: Date;
        other?: Maybe<{
            __typename: 'Profile';
            age: number;
            furtherInformation?: Maybe<string>;
            blocked?: Maybe<boolean>;
            favorite?: Maybe<boolean>;
            friendshipStatus?: Maybe<string>;
            acceptPicture: boolean;
            country: string;
            county: string;
            flirtText: string;
            gender: Gender;
            languageCode: string;
            profileId: string;
            profileName: string;
            searches: Gender;
            shownLocation: string;
            zodiacSign?: Maybe<string>;
            premiumStatus: Array<ProfileStatus>;
            images?: Maybe<
                Array<{
                    __typename: 'Image';
                    imageId: string;
                    profileId: string;
                    path: string;
                    main: boolean;
                    private: boolean;
                }>
            >;
            theme?: Maybe<{ __typename: 'Theme'; name: string }>;
            profileFlags?: Maybe<
                Array<{
                    __typename: 'ProfileFlag';
                    profileFlagId: string;
                    flagValueId?: Maybe<string>;
                    value?: Maybe<string>;
                    flag: {
                        __typename: 'Flag';
                        flagId: string;
                        name: string;
                        translations: Array<{
                            __typename: 'Translation';
                            translationId: string;
                            translation: string;
                            languageCode: string;
                            giftCategoryId?: Maybe<string>;
                            giftId?: Maybe<string>;
                            interestCategoryId?: Maybe<string>;
                            interestId?: Maybe<string>;
                            translationView: TranslationView;
                        }>;
                    };
                    flagValue?: Maybe<{
                        __typename: 'FlagValue';
                        flagId: string;
                        flagValueId: string;
                        translations: Array<{
                            __typename: 'Translation';
                            translationId: string;
                            translation: string;
                            languageCode: string;
                            giftCategoryId?: Maybe<string>;
                            giftId?: Maybe<string>;
                            interestCategoryId?: Maybe<string>;
                            interestId?: Maybe<string>;
                            translationView: TranslationView;
                        }>;
                    }>;
                }>
            >;
            profileInterests?: Maybe<
                Array<{
                    __typename: 'ProfileInterest';
                    profileInterestId: string;
                    profileId: string;
                    interestName: string;
                    interest?: Maybe<{
                        __typename: 'Interest';
                        interestId: string;
                        name: string;
                        class?: Maybe<string>;
                        path?: Maybe<string>;
                        categoryId: string;
                        translations: Array<{
                            __typename: 'Translation';
                            translationId: string;
                            translation: string;
                            languageCode: string;
                            giftCategoryId?: Maybe<string>;
                            giftId?: Maybe<string>;
                            interestCategoryId?: Maybe<string>;
                            interestId?: Maybe<string>;
                            translationView: TranslationView;
                        }>;
                    }>;
                }>
            >;
        }>;
    }>;
};

export type VisitCountQueryVariables = Exact<{
    v_Where?: Maybe<VisitWhereInput>;
    v_OrderBy?: Maybe<VisitOrderByInput>;
    v_Cursor?: Maybe<VisitWhereUniqueInput>;
    v_Skip?: Maybe<Scalars['Int']>;
    v_Take?: Maybe<Scalars['Int']>;
}>;

export type VisitCountQuery = {
    __typename: 'Query';
    findManyVisitCount: number;
};

export type NotificationSubscriptionVariables = Exact<{ [key: string]: never }>;

export type NotificationSubscription = {
    __typename: 'Subscription';
    notifications?: Maybe<
        | {
              __typename: 'NotificationSubscriptionCoinsAddedPayload';
              coinsChanged: number;
              totalCoins: number;
              type: NotificationType;
          }
        | {
              __typename: 'NotificationSubscriptionFriendshipPayload';
              type: NotificationType;
              friendshipId: string;
              senderId: string;
              senderName: string;
          }
        | {
              __typename: 'NotificationSubscriptionGiftPayload';
              type: NotificationType;
              giftId: string;
              text: string;
              senderId: string;
              senderName: string;
              conversationId: string;
          }
        | {
              __typename: 'NotificationSubscriptionImagePayload';
              imageId: string;
              type: NotificationType;
          }
        | {
              __typename: 'NotificationSubscriptionLikePayload';
              type: NotificationType;
              otherProfileId: string;
          }
        | {
              __typename: 'NotificationSubscriptionMatchPayload';
              type: NotificationType;
              otherProfileId: string;
              matchId: string;
          }
        | {
              __typename: 'NotificationSubscriptionMessagePayload';
              type: NotificationType;
              text: string;
              senderId: string;
              senderName: string;
              conversationId: string;
          }
        | {
              __typename: 'NotificationSubscriptionPaymentPayload';
              type: NotificationType;
              transactionId: string;
              coins: number;
              provider: string;
          }
        | { __typename: 'NotificationSubscriptionPicturePayload' }
        | {
              __typename: 'NotificationSubscriptionPokePayload';
              type: NotificationType;
              senderName: string;
              senderId: string;
              conversationId: string;
          }
        | {
              __typename: 'NotificationSubscriptionProfileTextChangedPayload';
              type: NotificationType;
          }
        | {
              __typename: 'NotificationSubscriptionSupportMessagePayload';
              supportMessageId: string;
              text: string;
              type: NotificationType;
              supportTicketId: string;
          }
        | {
              __typename: 'NotificationSubscriptionVisitPayload';
              type: NotificationType;
              senderId: string;
              senderName: string;
          }
    >;
};
